import { t } from "@/i18n";
import { Helpers, Format, ObjectLib } from "@/core/utils";

import { Commercials } from "@/core/commercials";

import { TableSelect } from "@/core/table";

export const $_TableObject =
{
    accountMenu:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups  : [ { id: 'column', get label(){ return t('table.accountMenu.groups.column.label') } } ],
            columns : [ { id: 'default', group: 'column', get label(){ return t('table.accountMenu.columns.default.label') } } ],
            presets : [ { id: 'default', name: 'default', columns: [ 'default' ] } ]
        }
    },

    companyMenu:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups  : [ { id: 'column', get label(){ return t('table.companyMenu.groups.column.label') } } ],
            columns : [ { id: 'default', group: 'column', get label(){ return t('table.companyMenu.columns.default.label') } } ],
            presets : [ { id: 'default', name: 'default', columns: [ 'default' ] } ]
        }
    },

    userHierarchy:
    {
        grid    : {},
        table   :
        {
            groups  :
            [
                { id: 'user', get label(){ return t('table.userHierarchy.groups.user.label') } }
            ],
            columns :
            [
                {
                    id     : 'title', group: 'user', get label(){ return t('table.userHierarchy.columns.title.label') },
                    width  : '384px',
                    scope  : [ 'admin', 'employer', 'recruiter' ],
                    sort   : { asc: 'title_asc', desc: 'title_desc' },
                    export :
                    {
                        columns: []
                    }
                },
            ],
            presets:
            [
                { id: 'admin', name: 'default', columns: [ "title" ] },
                { id: 'employer', name: 'default', columns: [ "title" ] },
                { id: 'recruiter', name: 'default', columns: [ "title" ] },
            ]
        }
    },

    mailboxList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            options:
            {
                hideThead: true
            },

            groups:
            [
                { id: 'message', get label(){ return t('table.mailboxList.groups.message.label') } },
            ],

            columns:
            [
                { id: 'message', group: 'message', get label(){ return t('table.mailboxList.columns.message.label') }, width: 'auto' }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'message' ] }
            ]
        }
    },

    livechatList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            options:
            {
                hideThead: true
            },

            groups:
            [
                { id: 'message', get label(){ return t('table.livechatList.groups.message.label') } },
            ],

            columns:
            [
                { id: 'message', group: 'message', get label(){ return t('table.livechatList.columns.message.label') }, width: 'auto' }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'message' ] }
            ]
        } 
    },

    supplierPerformanceList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'worker', get label(){ return t('table.supplierPerformanceList.groups.worker.label') } },
            ],

            columns:
            [
                {
                    id      : 'agency', group: 'agency', get label(){ return t('table.supplierPerformanceList.columns.agency.label') },
                    tooltip : { get title(){ return t('table.supplierPerformanceList.columns.agency.tooltip.title') }, get description(){ return t('table.supplierPerformanceList.columns.agency.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'engagements', group: 'metrics', get label(){ return t('table.supplierPerformanceList.columns.engagements.label') },
                    tooltip : { get title(){ return t('table.supplierPerformanceList.columns.engagements.tooltip.title') }, get description(){ return t('table.supplierPerformanceList.columns.engagements.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'jobsWorked', group: 'metrics', get label(){ return t('table.supplierPerformanceList.columns.jobsWorked.label') },
                    tooltip : { get title(){ return t('table.supplierPerformanceList.columns.jobsWorked.tooltip.title') }, get description(){ return t('table.supplierPerformanceList.columns.jobsWorked.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'applications', group: 'metrics', get label(){ return t('table.supplierPerformanceList.columns.applications.label') },
                    tooltip : { get title(){ return t('table.supplierPerformanceList.columns.applications.tooltip.title') }, get description(){ return t('table.supplierPerformanceList.columns.applications.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'interviews', group: 'metrics', get label(){ return t('table.supplierPerformanceList.columns.interviews.label') },
                    tooltip : { get title(){ return t('table.supplierPerformanceList.columns.interviews.tooltip.title') }, get description(){ return t('table.supplierPerformanceList.columns.interviews.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'hires', group: 'metrics', get label(){ return t('table.supplierPerformanceList.columns.hires.label') },
                    tooltip : { get title(){ return t('table.supplierPerformanceList.columns.hires.tooltip.title') }, get description(){ return t('table.supplierPerformanceList.columns.hires.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'rolesReleased', group: 'metrics', get label(){ return t('table.supplierPerformanceList.columns.rolesReleased.label') },
                    tooltip : { get title(){ return t('table.supplierPerformanceList.columns.rolesReleased.tooltip.title') }, get description(){ return t('table.supplierPerformanceList.columns.rolesReleased.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'responseRate', group: 'performance', get label(){ return t('table.supplierPerformanceList.columns.responseRate.label') },
                    tooltip : { get title(){ return t('table.supplierPerformanceList.columns.responseRate.tooltip.title') }, get description(){ return t('table.supplierPerformanceList.columns.responseRate.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'interviewRate', group: 'performance', get label(){ return t('table.supplierPerformanceList.columns.interviewRate.label') },
                    tooltip : { get title(){ return t('table.supplierPerformanceList.columns.interviewRate.tooltip.title') }, get description(){ return t('table.supplierPerformanceList.columns.interviewRate.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'fillRate', group: 'performance', get label(){ return t('table.supplierPerformanceList.columns.fillRate.label') },
                    tooltip : { get title(){ return t('table.supplierPerformanceList.columns.fillRate.tooltip.title') }, get description(){ return t('table.supplierPerformanceList.columns.fillRate.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'locations', group: 'agency', get label(){ return t('table.supplierPerformanceList.columns.locations.label') },
                    tooltip : { get title(){ return t('table.supplierPerformanceList.columns.locations.tooltip.title') }, get description(){ return t('table.supplierPerformanceList.columns.locations.tooltip.description') } },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'nonCompliantHires', group: 'compliance', get label(){ return t('table.supplierPerformanceList.columns.nonCompliantHires.label') },
                    tooltip : { get title(){ return t('table.supplierPerformanceList.columns.nonCompliantHires.tooltip.title') }, get description(){ return t('table.supplierPerformanceList.columns.nonCompliantHires.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ]
                },
                {
                    id      : 'unsatisfactoryCVs', group: 'compliance', get label(){ return t('table.supplierPerformanceList.columns.unsatisfactoryCVs.label') },
                    tooltip : { get title(){ return t('table.supplierPerformanceList.columns.unsatisfactoryCVs.tooltip.title') }, get description(){ return t('table.supplierPerformanceList.columns.unsatisfactoryCVs.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ]
                },
                {
                    id      : 'moreThanTwoWeeksFeedback', group: 'compliance', get label(){ return t('table.supplierPerformanceList.columns.moreThanTwoWeeksFeedback.label') },
                    tooltip : { get title(){ return t('table.supplierPerformanceList.columns.moreThanTwoWeeksFeedback.tooltip.title') }, get description(){ return t('table.supplierPerformanceList.columns.moreThanTwoWeeksFeedback.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ]
                },
                {
                    id      : 'cvsOutsideSLA', group: 'compliance', get label(){ return t('table.supplierPerformanceList.columns.cvsOutsideSLA.label') },
                    tooltip : { get title(){ return t('table.supplierPerformanceList.columns.cvsOutsideSLA.tooltip.title') }, get description(){ return t('table.supplierPerformanceList.columns.cvsOutsideSLA.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ]
                },
                {
                    id      : 'weightedScore', group: 'performance', get label(){ return t('table.supplierPerformanceList.columns.weightedScore.label') },
                    tooltip : { get title(){ return t('table.supplierPerformanceList.columns.weightedScore.tooltip.title') }, get description(){ return t('table.supplierPerformanceList.columns.weightedScore.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ]
                }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'agency', 'locations', 'engagements', 'jobsWorked', 'applications', 'interviews', 'hires', 'rolesReleased', 'responseRate', 'interviewRate', 'fillRate', 'weightedScore', 'nonCompliantHires', 'unsatisfactoryCVs', 'moreThanTwoWeeksFeedback', 'cvsOutsideSLA' ] },
            ]
        }
    },

    roleList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'role', get label(){ return t('table.roleList.groups.role.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'role', get label(){ return t('table.roleList.columns.title.label') },
                    tooltip : { get title(){ return t('table.roleList.columns.title.tooltip.title') }, get description(){ return t('table.roleList.columns.title.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'description', group: 'role', get label(){ return t('table.roleList.columns.description.label') },
                    tooltip : { get title(){ return t('table.roleList.columns.description.tooltip.title') }, get description(){ return t('table.roleList.columns.description.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'title', 'description' ] }
            ]
        }
    },

    personList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'person', get label(){ return t('table.personList.groups.person.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'person', get label(){ return t('table.personList.columns.title.label') },
                    tooltip : { get title(){ return t('table.personList.columns.title.tooltip.title') }, get description(){ return t('table.personList.columns.title.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'title' ] }
            ]
        }
    },

    workerList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'worker', get label(){ return t('table.workerList.groups.worker.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'worker', get label(){ return t('table.workerList.columns.title.label') },
                    tooltip : { get title(){ return t('table.workerList.columns.title.tooltip.title') }, get description(){ return t('table.workerList.columns.title.tooltip.description') } },
                    width   : '384px',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'status', group: 'worker', get label(){ return t('table.workerList.columns.status.label') },
                    tooltip : { get title(){ return t('table.workerList.columns.status.tooltip.title') }, get description(){ return t('table.workerList.columns.status.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'assignments', group: 'worker', get label(){ return t('table.workerList.columns.assignments.label') },
                    tooltip : { get title(){ return t('table.workerList.columns.assignments.tooltip.title') }, get description(){ return t('table.workerList.columns.assignments.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'latest_rate', group: 'worker', get label(){ return t('table.workerList.columns.latest_rate.label') },
                    align   : 'right',
                    tooltip : { get title(){ return t('table.workerList.columns.latest_rate.tooltip.title') }, get description(){ return t('table.workerList.columns.latest_rate.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'agency', group: 'worker', get label(){ return t('table.workerList.columns.agency.label') },
                    tooltip : { get title(){ return t('table.workerList.columns.agency.tooltip.title') }, get description(){ return t('table.workerList.columns.agency.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'job_location', group: 'worker', get label(){ return t('table.workerList.columns.job_location.label') },
                    tooltip : { get title(){ return t('table.workerList.columns.job_location.tooltip.title') }, get description(){ return t('table.workerList.columns.job_location.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'worker_location', group: 'worker', get label(){ return t('table.workerList.columns.worker_location.label') },
                    tooltip : { get title(){ return t('table.workerList.columns.worker_location.tooltip.title') }, get description(){ return t('table.workerList.columns.worker_location.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'latest_program', group: 'worker', get label(){ return t('table.workerList.columns.latest_program.label') },
                    tooltip : { get title(){ return t('table.workerList.columns.latest_program.tooltip.title') }, get description(){ return t('table.workerList.columns.latest_program.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'end_date', group: 'worker', get label(){ return t('table.workerList.columns.end_date.label') },
                    tooltip : { get title(){ return t('table.workerList.columns.end_date.tooltip.title') }, get description(){ return t('table.workerList.columns.end_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'title', 'status', 'assignments', 'latest_rate', 'agency', 'job_location', 'worker_location', 'latest_program', 'end_date' ] },
            ]
        }
    },

    accountList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'account', get label(){ return t('table.accountList.groups.account.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'recruitment', get label(){ return t('table.accountList.columns.title.label') },
                    tooltip : { get title(){ return t('table.accountList.columns.title.tooltip.title') }, get description(){ return t('table.accountList.columns.title.tooltip.description') } },
                    width   : '384px',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'fill_rate', group: 'recruitment', get label(){ return t('table.accountList.columns.fill_rate.label') },
                    tooltip : { get title(){ return t('table.accountList.columns.fill_rate.tooltip.title') }, get description(){ return t('table.accountList.columns.fill_rate.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'jobs', group: 'recruitment', get label(){ return t('table.accountList.columns.jobs.label') },
                    tooltip : { get title(){ return t('table.accountList.columns.jobs.tooltip.title') }, get description(){ return t('table.accountList.columns.jobs.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'applications', group: 'recruitment', get label(){ return t('table.accountList.columns.applications.label') },
                    tooltip : { get title(){ return t('table.accountList.columns.applications.tooltip.title') }, get description(){ return t('table.accountList.columns.applications.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'placements', group: 'recruitment', get label(){ return t('table.accountList.columns.placements.label') },
                    tooltip : { get title(){ return t('table.accountList.columns.placements.tooltip.title') }, get description(){ return t('table.accountList.columns.placements.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'contracts', group: 'recruitment', get label(){ return t('table.accountList.columns.contracts.label') },
                    tooltip : { get title(){ return t('table.accountList.columns.contracts.tooltip.title') }, get description(){ return t('table.accountList.columns.contracts.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'title', 'fill_rate', 'jobs', 'applications', 'placements', 'contracts' ] }
            ]
        }
    },

    onboardingList:
    {
        grid    : { columns : 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'onboarding', get label(){ return t('table.onboardingList.groups.onboarding.label') } }
            ],

            columns:
            [
                {
                    id      : 'title', group: 'onboarding', get label(){ return t('table.onboardingList.columns.title.label') },
                    tooltip : { get title(){ return t('table.onboardingList.columns.title.tooltip.title') }, get description(){ return t('table.onboardingList.columns.title.tooltip.description') } },
                    width   : '384px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'title_asc', desc: 'title_desc' },
                    export  :
                    {
                        columns: []
                    }
                },
                {
                    id      : 'status', group: 'onboarding', get label(){ return t('table.onboardingList.columns.status.label') },
                    tooltip : { get title(){ return t('table.onboardingList.columns.status.tooltip.title') }, get description(){ return t('table.onboardingList.columns.status.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'status_asc', desc: 'status_desc' },
                    export  :
                    {
                        columns: []
                    }
                },
                {
                    id      : 'compliant', group: 'agencyOnboarding', get label(){ return t('table.onboardingList.columns.compliant.label') },
                    tooltip : { get title(){ return t('table.onboardingList.columns.compliant.tooltip.title') }, get description(){ return t('table.onboardingList.columns.compliant.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'compliant_asc', desc: 'compliant_desc' },
                    export  :
                    {
                        columns: []
                    }
                },
                {
                    id      : 'type', group: 'onboarding', get label(){ return t('table.onboardingList.columns.type.label') },
                    tooltip : { get title(){ return t('table.onboardingList.columns.type.tooltip.title') }, get description(){ return t('table.onboardingList.columns.type.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'recruiter_asc', desc: 'recruiter_desc' },
                    export  :
                    {
                        columns: []
                    }
                },
                {
                    id      : 'inviter', group: 'onboarding', get label(){ return t('table.onboardingList.columns.inviter.label') },
                    tooltip : { get title(){ return t('table.onboardingList.columns.inviter.tooltip.title') }, get description(){ return t('table.onboardingList.columns.inviter.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'inviter_asc', desc: 'inviter_desc' },
                    export  :
                    {
                        columns: []
                    }
                },
                {
                    id      : 'created', group: 'onboarding', get label(){ return t('table.onboardingList.columns.created.label') },
                    tooltip : { get title(){ return t('table.onboardingList.columns.created.tooltip.title') }, get description(){ return t('table.onboardingList.columns.created.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'createdDate_asc', desc: 'createdDate_desc' },
                    export  :
                    {
                        columns: []
                    }
                }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ "title", "status", "compliant", "type", "inviter", "created" ] },
                { id: 'employer', name: 'default', columns: [ "title", "status", "compliant", "type", "inviter", "created" ] },
                { id: 'recruiter', name: 'default', columns: [ "title", "status", "compliant", "type", "inviter", "created" ] },
            ]
        }
    },

    programmeList: //DONE
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'programme', get label(){ return t('table.programmeList.groups.programme.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'programme', get label(){ return t('table.programmeList.columns.title.label') },
                    tooltip : { get title(){ return t('table.programmeList.columns.title.tooltip.title') }, get description(){ return t('table.programmeList.columns.title.tooltip.description') } },
                    width   : '384px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'title_asc', desc: 'title_desc' }
                },
                {
                    id      : 'status', group: 'programme', get label(){ return t('table.programmeList.columns.status.label') },
                    tooltip : { get title(){ return t('table.programmeList.columns.status.tooltip.title') }, get description(){ return t('table.programmeList.columns.status.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'recruiter' ],
                    //sort  : { asc: 'agencyRate_asc', desc: 'agencyRate_desc' }
                },
                /*
                {
                    id      : 'rate', group: 'programme', get label(){ return t('table.programmeList.columns.rate.label') },
                    tooltip : { get title(){ return t('table.programmeList.columns.rate.tooltip.title') }, get description(){ return t('table.programmeList.columns.rate.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort  : { asc: 'agencyRate_asc', desc: 'agencyRate_desc' }
                },
                */
                {
                    id      : 'agencies', group: 'programme', get label(){ return t('table.programmeList.columns.agencies.label') },
                    tooltip : { get title(){ return t('table.programmeList.columns.agencies.tooltip.title') }, get description(){ return t('table.programmeList.columns.agencies.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort  : { asc: 'agenciesTotal_asc', desc: 'agenciesTotal_desc' }
                },
                {
                    id      : 'jobs', group: 'programme', get label(){ return t('table.programmeList.columns.jobs.label') },
                    tooltip : { get title(){ return t('table.programmeList.columns.jobs.tooltip.title') }, get description(){ return t('table.programmeList.columns.jobs.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort  : { asc: 'agenciesTotal_asc', desc: 'agenciesTotal_desc' }
                },
                {
                    id      : 'applications', group: 'programme', get label(){ return t('table.programmeList.columns.applications.label') },
                    tooltip : { get title(){ return t('table.programmeList.columns.applications.tooltip.title') }, get description(){ return t('table.programmeList.columns.applications.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort  : { asc: 'applicationsTotal_asc', desc: 'applicationsTotal_desc' }
                },
                {
                    id      : 'placements', group: 'programme', get label(){ return t('table.programmeList.columns.placements.label') },
                    tooltip : { get title(){ return t('table.programmeList.columns.placements.tooltip.title') }, get description(){ return t('table.programmeList.columns.placements.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort  : { asc: 'placementsTotal_asc', desc: 'placementsTotal_desc' }
                },
                {
                    id      : 'contracts', group: 'programme', get label(){ return t('table.programmeList.columns.contracts.label') },
                    tooltip : { get title(){ return t('table.programmeList.columns.contracts.tooltip.title') }, get description(){ return t('table.programmeList.columns.contracts.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort  : { asc: 'contractsTotal_asc', desc: 'contractsTotal_desc' }
                }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'title', /*'rate',*/ 'agencies', 'jobs', 'applications', 'placements', 'contracts' ] },
                { id: 'employer', name: 'default', columns: [ 'title', /*'rate',*/ 'agencies', 'jobs', 'applications', 'placements', 'contracts' ] },
                { id: 'recruiter', name: 'default', columns: [ 'title', 'status', 'jobs', 'applications', 'placements', 'contracts' ] },
            ]
        }
    },

    programmeLocationList: //DONE
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'programmeLocation', get label(){ return t('table.programmeLocationList.groups.programmeLocation.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'programmeLocation', get label(){ return t('table.programmeLocationList.columns.title.label') },
                    tooltip : { get title(){ return t('table.programmeLocationList.columns.title.tooltip.title') }, get description(){ return t('table.programmeLocationList.columns.title.tooltip.description') } },
                    width   : '384px',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'jobs', group: 'programmeLocation', get label(){ return t('table.programmeLocationList.columns.jobs.label') },
                    tooltip : { get title(){ return t('table.programmeLocationList.columns.jobs.tooltip.title') }, get description(){ return t('table.programmeLocationList.columns.jobs.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'placements', group: 'programmeLocation', get label(){ return t('table.programmeLocationList.columns.placements.label') },
                    tooltip : { get title(){ return t('table.programmeLocationList.columns.placements.tooltip.title') }, get description(){ return t('table.programmeLocationList.columns.placements.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'contractors', group: 'programmeLocation', get label(){ return t('table.programmeLocationList.columns.contractors.label') },
                    tooltip : { get title(){ return t('table.programmeLocationList.columns.contractors.tooltip.title') }, get description(){ return t('table.programmeLocationList.columns.contractors.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'title', 'jobs', 'placements', 'contractors' ] }
            ]
        }
    },

    agencyList: //DONE
    {
        grid  : { columns: 4, gap: '24px' },
        table :
        {
            groups:
            [
                { id: 'agency', get label(){ return t('table.agencyList.groups.agency.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'agency', get label(){ return t('table.agencyList.columns.title.label') },
                    tooltip : { get title(){ return t('table.agencyList.columns.title.tooltip.title') }, get description(){ return t('table.agencyList.columns.title.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer' ],
                    sort    : { asc: 'title_asc', desc: 'title_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'title', get title() { return t('common.export.columns.agencyName') }, data: ( item, ctx ) => { return item?.name } },
                            { id: 'region_level', get title() { return t('common.export.columns.regionLevel') }, data: ( item, ctx ) => { return item?.summary?.regionLevel } },
                        ]
                    }
                },
                {
                    id      : 'tags', group: 'agency', get label(){ return t('table.agencyList.columns.tags.label') },
                    tooltip : { get title(){ return t('table.agencyList.columns.tags.tooltip.title') }, get description(){ return t('table.agencyList.columns.tags.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'tags', get title() { return t('common.export.columns.tags') }, data: ( item, ctx ) => { return item?.tags?.map( t => t.name )?.join(', ') } }
                        ]
                    }
                },
                {
                    id      : 'completeness', group: 'agency', get label(){ return t('table.agencyList.columns.completeness.label') },
                    tooltip : { get title(){ return t('table.agencyList.columns.completeness.tooltip.title') }, get description(){ return t('table.agencyList.columns.completeness.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'completeness', get title() { return t('common.export.columns.profileCompleteness') }, data: ( item, ctx ) => { return item?.completeness } },
                        ]
                    }
                },
                {
                    id      : 'onboarded', group: 'agency', get label(){ return t('table.agencyList.columns.onboarded.label') },
                    tooltip : { get title(){ return t('table.agencyList.columns.onboarded.tooltip.title') }, get description(){ return t('table.agencyList.columns.onboarded.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'onboarded', get title() { return t('common.export.columns.onboardedPrograms') }, data: ( item, ctx ) => {
                                if (item.onboardings.length === 1) {
                                    return item.onboardings[0].status
                                }

                                return item.onboardings.length
                            } },
                        ]
                    }
                },
                {
                    id      : 'social', group: 'agency', get label(){ return t('table.agencyList.columns.social.label') },
                    tooltip : { get title(){ return t('table.agencyList.columns.social.tooltip.title') }, get description(){ return t('table.agencyList.columns.social.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'website', get title() { return t('common.export.columns.website') }, data: ( item, ctx ) => { return item?.contact?.website } },
                            { id: 'linkedin', get title() { return t('common.export.columns.linkedin') }, data: ( item, ctx ) => { return item?.contact?.externalURLs?.linkedin } }
                        ]
                    }
                },
                {
                    id      : 'coc_signed', group: 'agency', get label(){ return t('table.agencyList.columns.coc_signed.label') },
                    tooltip : { get title(){ return t('table.agencyList.columns.coc_signed.tooltip.title') }, get description(){ return t('table.agencyList.columns.coc_signed.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ],
                    //sort   : { asc: 'coc_asc', desc: 'coc_desc' },
                    export :
                    {
                        columns:
                        [
                            { id: 'coc_signed', get title() { return t('common.export.columns.codeOfConducts') }, data: ( item, ctx ) => { return item?.summary?.CoCSigned === 'Yes' ? 'Available' : 'Unknown' } }
                        ]
                    }
                },
                {
                    id      : 'location', group: 'agency', get label(){ return t('table.agencyList.columns.location.label') },
                    tooltip : { get title(){ return t('table.agencyList.columns.location.tooltip.title') }, get description(){ return t('table.agencyList.columns.location.tooltip.description') } },
                    scope   : [ 'admin', 'employer' ],
                    //sort   : { asc: 'locations_asc', desc: 'locations_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'location', get title() { return t('common.export.columns.locationBased') }, data: ( item, ctx ) => { return item?.location?.name } }
                        ]
                    }
                },
                {
                    id      : 'most_placements', group: 'agency', get label(){ return t('table.agencyList.columns.most_placements.label') },
                    tooltip : { get title(){ return t('table.agencyList.columns.most_placements.tooltip.title') }, get description(){ return t('table.agencyList.columns.most_placements.tooltip.description') } },
                    scope   : [ 'admin', 'employer' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'most_placements', get title() { return t('common.export.columns.categoryWithMostPlacements') }, data: ( item, ctx ) => { return item?.summary?.topCategory?.label } }
                        ]
                    }
                },
                /*
                {
                    id      : 'agency_fee', group: 'agency', get label(){ return t('table.agencyList.columns.agency_fee.label') },
                    tooltip : { get title(){ return t('table.agencyList.columns.agency_fee.tooltip.title') }, get description(){ return t('table.agencyList.columns.agency_fee.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ],
                    //sort   : { asc: 'agencyFee_asc', desc: 'agencyFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'agency_fee', get title() { return t('common.export.columns.agencyFeeIn') }, data: ( item, ctx ) => { return item?.summary?.avgAgencyFee } }
                        ]
                    }
                },
                */
                {
                    id      : 'fill_rate', group: 'agency', get label(){ return t('table.agencyList.columns.fill_rate.label') },
                    tooltip : { get title(){ return t('table.agencyList.columns.fill_rate.tooltip.title') }, get description(){ return t('table.agencyList.columns.fill_rate.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ],
                    //sort   : { asc: 'fillRate_asc', desc: 'fillRate_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'fill_rate', get title() { return t('common.export.columns.averageFillRateIn') }, data: ( item, ctx ) => { return item?.summary?.avgFillRate } }
                        ]
                    }
                },
                {
                    id      : 'recruiters_onboarded', group: 'agency', get label(){ return t('table.agencyList.columns.recruiters_onboarded.label') },
                    tooltip : { get title(){ return t('table.agencyList.columns.recruiters_onboarded.tooltip.title') }, get description(){ return t('table.agencyList.columns.recruiters_onboarded.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin' ],
                    //sort   : { asc: 'recruitersTotal_asc', desc: 'recruitersTotal_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'recruiters_onboarded', get title() { return t('common.export.columns.recruitersOnboarded') }, data: ( item, ctx ) => { return item?.summary?.recruiters } }
                        ]
                    }
                },
                {
                    id      : 'jobs_total', group: 'agency', get label(){ return t('table.agencyList.columns.jobs_total.label') },
                    tooltip : { get title(){ return t('table.agencyList.columns.jobs_total.tooltip.title') }, get description(){ return t('table.agencyList.columns.jobs_total.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ],
                    sort    : { asc: 'jobsTotal_asc', desc: 'jobsTotal_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'jobs_total', get title() { return t('common.export.columns.jobRequisitionsTotal') }, data: ( item, ctx ) => { return item?.summary?.jobs } }
                        ]
                    }
                },
                {
                    id      : 'applications_total', group: 'agency', get label(){ return t('table.agencyList.columns.applications_total.label') },
                    tooltip : { get title(){ return t('table.agencyList.columns.applications_total.tooltip.title') }, get description(){ return t('table.agencyList.columns.applications_total.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ],
                    sort    : { asc: 'applicationsTotal_asc', desc: 'applicationsTotal_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'applications_total', get title() { return t('common.export.columns.applicationsTotal') }, data: ( item, ctx ) => { return item?.summary?.applications } }
                        ]
                    }
                },
                {
                    id      : 'placements_total', group: 'agency', get label(){ return t('table.agencyList.columns.placements_total.label') },
                    tooltip : { get title(){ return t('table.agencyList.columns.placements_total.tooltip.title') }, get description(){ return t('table.agencyList.columns.placements_total.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ],
                    sort    : { asc: 'placementsTotal_asc', desc: 'placementsTotal_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'placements_total', get title() { return t('common.export.columns.placementsTotal') }, data: ( item, ctx ) => { return item?.summary?.placements } }
                        ]
                    }
                },
                {
                    id      : 'contractors_total', group: 'agency', get label(){ return t('table.agencyList.columns.contractors_total.label') },
                    tooltip : { get title(){ return t('table.agencyList.columns.contractors_total.tooltip.title') }, get description(){ return t('table.agencyList.columns.contractors_total.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ],
                    sort    : { asc: 'contractorsTotal_asc', desc: 'contractorsTotal_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'contractors_total', get title() { return t('common.export.columns.assignmentsTotal') }, data: ( item, ctx ) => { return item?.summary?.contractors } }
                        ]
                    }
                },
                {
                    id      : 'created', group: 'agency', get label(){ return t('table.agencyList.columns.created.label') },
                    tooltip : { get title(){ return t('table.agencyList.columns.created.tooltip.title') }, get description(){ return t('table.agencyList.columns.created.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ],
                    sort    : { asc: 'createdDate_asc', desc: 'createdDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'created', get title() { return t('common.export.columns.created') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.created )
                                    {
                                        return new Date( item.events.created ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                }
            ],

            presets:
            [
                { id: 'admin', name: 'default', columns: [ "title", "tags", "completeness", "most_placements", "location", "onboarded", "jobs_total", "placements_total", "contractors_total" ] },
                { id: 'employer', name: 'default', columns: [ "title", "tags", /*"completeness", "agency_fee",*/ "fill_rate", "placements_total", "contractors_total" ] }
            ]
        }
    },

    employerList: //DONE
    {
        grid  : { columns: 4, gap: '24px' },
        table :
        {
            groups:
            [
                { id: 'employer', get label(){ return t('table.employerList.groups.employer.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'employer', get label(){ return t('table.employerList.columns.title.label') },
                    tooltip : { get title(){ return t('table.employerList.columns.title.tooltip.title') }, get description(){ return t('table.employerList.columns.title.tooltip.description') } },
                    width   : '256px',
                    sort    : { asc: 'title_asc', desc: 'title_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'title', get title() { return t('common.export.columns.agencyName') }, data: ( item, ctx ) => { return item?.name } },
                            { id: 'region_level', get title() { return t('common.export.columns.regionLevel') }, data: ( item, ctx ) => { return item?.summary?.regionLevel } },
                        ]
                    }
                },
                {
                    id      : 'completeness', group: 'employer', get label(){ return t('table.employerList.columns.completeness.label') },
                    tooltip : { get title(){ return t('table.employerList.columns.completeness.tooltip.title') }, get description(){ return t('table.employerList.columns.completeness.tooltip.description') } },
                    width   : '256px',
                    export  :
                    {
                        columns:
                        [
                            { id: 'completeness', get title() { return t('common.export.columns.profileCompleteness') }, data: ( item, ctx ) => { return item?.completeness } },
                        ]
                    }
                },
                {
                    id      : 'source', group: 'employer', get label(){ return t('table.employerList.columns.source.label') },
                    tooltip : { get title(){ return t('table.employerList.columns.source.tooltip.title') }, get description(){ return t('table.employerList.columns.source.tooltip.description') } },
                    export  :
                    {
                        columns:
                        [
                            { id: 'source', get title() { return t('common.export.columns.source') }, data: ( item, ctx ) => { return 'TODO' } }
                        ]
                    }
                },
                {
                    id      : 'location', group: 'employer', get label(){ return t('table.employerList.columns.location.label') },
                    tooltip : { get title(){ return t('table.employerList.columns.location.tooltip.title') }, get description(){ return t('table.employerList.columns.location.tooltip.description') } },
                    //sort   : { asc: 'locations_asc', desc: 'locations_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'location', get title() { return t('common.export.columns.headquartersLocation') }, data: ( item, ctx ) => { return item?.location?.name } }
                        ]
                    }
                },
                {
                    id      : 'onboarded', group: 'employer', get label(){ return t('table.employerList.columns.onboarded.label') },
                    tooltip : { get title(){ return t('table.employerList.columns.onboarded.tooltip.title') }, get description(){ return t('table.employerList.columns.onboarded.tooltip.description') } },
                    align   : 'center',
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'onboarded', get title() { return t('common.export.columns.onboardedAgencies') }, data: ( item, ctx ) =>
                                {
                                    if( item.onboardings.length === 1 ) { return item.onboardings[0].status }

                                    return item.onboardings.length
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'jobs_open', group: 'employer', get label(){ return t('table.employerList.columns.jobs_open.label') },
                    tooltip : { get title(){ return t('table.employerList.columns.jobs_open.tooltip.title') }, get description(){ return t('table.employerList.columns.jobs_open.tooltip.description') } },
                    align   : 'center',
                    sort    : { asc: 'jobsOpen_asc', desc: 'jobsOpen_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'jobs_open', get title() { return t('common.export.columns.openJobs') }, data: ( item, ctx ) => { return item?.summary?.jobs } }
                        ]
                    }
                },
                /*{
                    id      : 'jobs_total', group: 'employer', get label(){ return t('table.employerList.columns.jobs_total.label') },
                    tooltip : { get title(){ return t('table.employerList.columns.jobs_total.tooltip.title') }, get description(){ return t('table.employerList.columns.jobs_total.tooltip.description') } },
                    align   : 'center',
                    sort    : { asc: 'jobsTotal_asc', desc: 'jobsTotal_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'jobs_total', get title() { return t('common.export.columns.jobRequisitionsTotal') }, data: ( item, ctx ) => { return item?.summary?.jobs } }
                        ]
                    }
                },*/
                {
                    id      : 'applications_active', group: 'employer', get label(){ return t('table.employerList.columns.applications_active.label') },
                    tooltip : { get title(){ return t('table.employerList.columns.applications_active.tooltip.title') }, get description(){ return t('table.employerList.columns.applications_active.tooltip.description') } },
                    align   : 'center',
                    sort    : { asc: 'applicationsActive_asc', desc: 'applicationsActive_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'applications_active', get title() { return t('common.export.columns.activeApplications') }, data: ( item, ctx ) => { return item?.summary?.applications } }
                        ]
                    }
                },
                /*{
                    id      : 'applications_total', group: 'employer', get label(){ return t('table.employerList.columns.applications_total.label') },
                    tooltip : { get title(){ return t('table.employerList.columns.applications_total.tooltip.title') }, get description(){ return t('table.employerList.columns.applications_total.tooltip.description') } },
                    align   : 'center',
                    sort    : { asc: 'applicationsTotal_asc', desc: 'applicationsTotal_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'applications_total', get title() { return t('common.export.columns.applicationsTotal') }, data: ( item, ctx ) => { return item?.summary?.applications } }
                        ]
                    }
                },
                {
                    id      : 'placements_total', group: 'employer', get label(){ return t('table.employerList.columns.placements_total.label') },
                    tooltip : { get title(){ return t('table.employerList.columns.placements_total.tooltip.title') }, get description(){ return t('table.employerList.columns.placements_total.tooltip.description') } },
                    align   : 'center',
                    sort    : { asc: 'placementsTotal_asc', desc: 'placementsTotal_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'placements_total', get title() { return t('common.export.columns.placementsTotal') }, data: ( item, ctx ) => { return item?.summary?.placements } }
                        ]
                    }
                },
                {
                    id      : 'contractors_total', group: 'employer', get label(){ return t('table.employerList.columns.contractors_total.label') },
                    tooltip : { get title(){ return t('table.employerList.columns.contractors_total.tooltip.title') }, get description(){ return t('table.employerList.columns.contractors_total.tooltip.description') } },
                    align   : 'center',
                    sort    : { asc: 'contractorsTotal_asc', desc: 'contractorsTotal_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'contractors_total', get title() { return t('common.export.columns.assignmentsTotal') }, data: ( item, ctx ) => { return item?.summary?.contractors } }
                        ]
                    }
                },
                {
                    id      : 'workers_total', group: 'employer', get label(){ return t('table.employerList.columns.workers_total.label') },
                    tooltip : { get title(){ return t('table.employerList.columns.workers_total.tooltip.title') }, get description(){ return t('table.employerList.columns.workers_total.tooltip.description') } },
                    align   : 'center',
                    sort    : { asc: 'workersTotal_asc', desc: 'workersTotal_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'workers_total', get title() { return t('common.export.columns.workersTotal') }, data: ( item, ctx ) => { return item?.summary?.contractors } }
                        ]
                    }
                },
                {
                    id      : 'category_placements', group: 'employer', get label(){ return t('table.employerList.columns.category_placements.label') },
                    tooltip : { get title(){ return t('table.employerList.columns.category_placements.tooltip.title') }, get description(){ return t('table.employerList.columns.category_placements.tooltip.description') } },
                    export  :
                    {
                        columns:
                        [
                            { id: 'category_placements', get title() { return t('common.export.columns.categoryWithMostPlacements') }, data: ( item, ctx ) => { return item?.summary?.topCategory?.label } }
                        ]
                    }
                },
                {
                    id      : 'location_placements', group: 'employer', get label(){ return t('table.employerList.columns.location_placements.label') },
                    tooltip : { get title(){ return t('table.employerList.columns.location_placements.tooltip.title') }, get description(){ return t('table.employerList.columns.location_placements.tooltip.description') } },
                    export  :
                    {
                        columns:
                        [
                            { id: 'location_placements', get title() { return t('common.export.columns.locationWithMostPlacements') }, data: ( item, ctx ) => { return item?.summary?.topCategory?.label } }
                        ]
                    }
                },*/
                {
                    id      : 'last_activity', group: 'employer', get label(){ return t('table.employerList.columns.last_activity.label') },
                    tooltip : { get title(){ return t('table.employerList.columns.last_activity.tooltip.title') }, get description(){ return t('table.employerList.columns.last_activity.tooltip.description') } },
                    align   : 'center',
                    //sort    : { asc: 'createdDate_asc', desc: 'createdDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'created', get title() { return t('common.export.columns.lastActivity') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.created )
                                    {
                                        return new Date( item.events.created ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'created', group: 'employer', get label(){ return t('table.employerList.columns.created.label') },
                    tooltip : { get title(){ return t('table.employerList.columns.created.tooltip.title') }, get description(){ return t('table.employerList.columns.created.tooltip.description') } },
                    align   : 'center',
                    sort    : { asc: 'createdDate_asc', desc: 'createdDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'created', get title() { return t('common.export.columns.created') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.created )
                                    {
                                        return new Date( item.events.created ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                }
            ],

            presets:
            [
                { id: 'admin', name: 'default', columns: [ "title", "source", "location", "onboarded", "jobs_open", "applications_active", "completeness", "last_activity", "created" ] },
            ]
        }
    },

    agencyOnboardingList:
    {
        grid    : { columns : 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'agencyOnboarding', get label(){ return t('table.agencyOnboardingList.groups.agencyOnboarding.label') } }
            ],

            columns:
            [
                {
                    id      : 'agency', group: 'agencyOnboarding', get label(){ return t('table.agencyOnboardingList.columns.agency.label') },
                    tooltip : { get title(){ return t('table.agencyOnboardingList.columns.agency.tooltip.title') }, get description(){ return t('table.agencyOnboardingList.columns.agency.tooltip.description') } },
                    width   : '384px',
                    scope   : [ 'admin', 'employer' ], 
                    //sort    : { asc: 'title_asc', desc: 'title_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'agency', get title() { return t('common.export.columns.agency') }, data: ( item, ctx ) => { return item?.agency?.name } }
                        ]
                    }
                },
                {
                    id      : 'title', group: 'agencyOnboarding', get label(){ return t('table.agencyOnboardingList.columns.title.label') },
                    tooltip : { get title(){ return t('table.agencyOnboardingList.columns.title.tooltip.title') }, get description(){ return t('table.agencyOnboardingList.columns.title.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'title_asc', desc: 'title_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'title', get title() { return t('common.export.columns.program') }, data: ( item, ctx ) => { return item?.programme?.title } }
                        ]
                    }
                },
                {
                    id      : 'status', group: 'agencyOnboarding', get label(){ return t('table.agencyOnboardingList.columns.status.label') },
                    tooltip : { get title(){ return t('table.agencyOnboardingList.columns.status.tooltip.title') }, get description(){ return t('table.agencyOnboardingList.columns.status.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'status_asc', desc: 'status_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'status', get title() { return t('common.export.columns.status') }, data: ( item, ctx ) => { return item?.status ? item.status.capitalize() : '' } }
                        ]
                    }
                },
                {
                    id      : 'compliant', group: 'agencyOnboarding', get label(){ return t('table.agencyOnboardingList.columns.compliant.label') },
                    tooltip : { get title(){ return t('table.agencyOnboardingList.columns.compliant.tooltip.title') }, get description(){ return t('table.agencyOnboardingList.columns.compliant.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'compliant_asc', desc: 'compliant_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'compliant', get title() { return t('common.export.columns.compliant') }, data: ( item, ctx ) => { return item?.hasOwnProperty('compliant') ? (item.compliant ? 'Compliant' : 'Non-compliant') : '' } }
                        ]
                    }
                },
                {
                    id      : 'type', group: 'agencyOnboarding', get label(){ return t('table.agencyOnboardingList.columns.type.label') },
                    tooltip : { get title(){ return t('table.agencyOnboardingList.columns.type.tooltip.title') }, get description(){ return t('table.agencyOnboardingList.columns.type.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'recruiter_asc', desc: 'recruiter_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'type', get title() { return t('common.export.columns.onboardingType') }, data: ( item, ctx ) => { return item?.onboardingStatus ? item.onboardingStatus.capitalize() : '' } }
                        ]
                    }
                },
                {
                    id      : 'inviter', group: 'agencyOnboarding', get label(){ return t('table.agencyOnboardingList.columns.inviter.label') },
                    tooltip : { get title(){ return t('table.agencyOnboardingList.columns.inviter.tooltip.title') }, get description(){ return t('table.agencyOnboardingList.columns.inviter.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'inviter_asc', desc: 'inviter_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'inviter', get title() { return t('common.export.columns.inviter') }, data: ( item, ctx ) => { return item?.senderAccount?.name } },
                            { id: 'inviter_organization', get title() { return t('common.export.columns.inviterOrganization') }, data: ( item, ctx ) => { return item?.senderAccount?.organization?.name } },
                        ]
                    }
                },
                {
                    id      : 'created', group: 'agencyOnboarding', get label(){ return t('table.agencyOnboardingList.columns.created.label') },
                    tooltip : { get title(){ return t('table.agencyOnboardingList.columns.created.tooltip.title') }, get description(){ return t('table.agencyOnboardingList.columns.created.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'createdDate_asc', desc: 'createdDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'created', get title() { return t('common.export.columns.created') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.created )
                                    {
                                        return new Date( item.events.created ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                }
            ],

            presets:
            [
                { id: 'admin', name: 'default', columns: [ "agency", "title", "status", "compliant", "type", "inviter", "created" ] },
                { id: 'employer', name: 'default', columns: [ "agency", "title", "status", "compliant", "type", "inviter", "created" ] },
                { id: 'ramp.recruitment.programme.employer', name: 'default', columns: [ "agency", "title", "status", "compliant", "type", "inviter", "created" ] },
                { id: 'recruiter', name: 'default', columns: [ "title", "status", "compliant", "inviter", "created" ] },
                { id: 'ramp.recruitment.programme.agency', name: 'default', columns: [ "title", "status", "compliant", "inviter", "created" ] },
            ]
        }
    },

    jobList: //DONE
    {
        grid    : { columns : 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'job', get label(){ return t('table.jobList.groups.job.label') } },
            ],

            columns:
            [
                {
                    id      : 'open_jobs', group: 'job', get label(){ return t('table.jobList.columns.open_jobs.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.open_jobs.tooltip.title') }, get description(){ return t('table.jobList.columns.open_jobs.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'openJobsTotal_asc', desc: 'openJobsTotal_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'open_jobs', get title() { return t('common.export.columns.openJobs') }, data: ( item, ctx ) => { return item?.summary?.positions?.open } }
                        ]
                    }
                },
                {
                    id      : 'rag_jobs', group: 'job', get label(){ return t('table.jobList.columns.rag_jobs.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.rag_jobs.tooltip.title') }, get description(){ return t('table.jobList.columns.rag_jobs.tooltip.description') } },
                    align   : 'left',
                    scope   : [ 'admin' ],
                    //sort    : { asc: 'openJobsTotal_asc', desc: 'openJobsTotal_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'rag_jobs_status', get title() { return t('common.export.columns.rAGStatus') }, data: ( item, ctx ) => { return item?.summary?.rag?.status } },
                            { id: 'rag_jobs_reason', get title() { return t('common.export.columns.rAGReason') }, data: ( item, ctx ) => { return item?.summary?.rag?.reason } }
                        ]
                    }
                },
                {
                    id      : 'on_hold_reason', group: 'job', get label(){ return t('table.jobList.columns.on_hold_reason.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.on_hold_reason.tooltip.title') }, get description(){ return t('table.jobList.columns.on_hold_reason.tooltip.description') } },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'openJobsTotal_asc', desc: 'openJobsTotal_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'on_hold_reason', get title() { return t('common.export.columns.onHoldReason') }, data: ( item, ctx ) => { return ( item?.summary?.positions?.reason || '' ) + ( item?.summary?.positions.note?.length ? '; note: ' + item?.summary?.positions.note.replace(/<[^>]*>/g, '') : '' ) } }
                        ]
                    }
                },
                {
                    id      : 'title', group: 'job', get label(){ return t('table.jobList.columns.title.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.title.tooltip.title') }, get description(){ return t('table.jobList.columns.title.tooltip.description') } },
                    width   : '384px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'title_asc', desc: 'title_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'reference', get title() { return t('common.export.columns.reference') }, data: ( item, ctx ) => { return item?.reference } },
                            { id: 'status', get title() { return t('common.export.columns.status') }, data: ( item, ctx ) => { return item?.status } },
                            { id: 'title', get title() { return t('common.export.columns.title') }, data: ( item, ctx ) => { return item?.title } },
                            { id: 'contractType', get title() { return t('common.export.columns.contractType') }, data: ( item, ctx ) => { return item?.employment?.type } },
                        ]
                    }
                },
                {
                    id      : 'reference', group: 'job', get label(){ return t('table.jobList.columns.reference.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.reference.tooltip.title') }, get description(){ return t('table.jobList.columns.reference.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'reference', get title() { return t('common.export.columns.reference') }, data: ( item, ctx ) => { return item?.reference } }
                        ]
                    }
                },
                {
                    id      : 'stage', group: 'job', get label(){ return t('table.jobList.columns.stage.label') },
                    tooltip :
                    {
                        get title(){ return t('table.jobList.columns.stage.tooltip.title') },
                        description: `Reflects the current phase of the hiring process for this job.
                        <br/>
                        <br/>
                        <table>
                            <tr><td><b>Posted:</b></td> <td>Job is live and open for applications.</td></tr>
                            <tr><td><b>Engaged:</b></td> <td>Agencies have been engaged to recruit for this position.</td></tr>
                            <tr><td><b>Application:</b></td> <td>Applications have been received and are under review.</td></tr>
                            <tr><td><b>Offer:</b></td> <td>A candidate has been offered the position.</td></tr>
                        </table>
                        <br/>
                        <i>Hover over any stage to see more details about what it entails.</i>`
                    },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ],
                    sort    : { asc: 'stage_asc', desc: 'stage_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'stage', get title() { return t('common.export.columns.stage') }, data: ( item, ctx ) => { return item?.summary?.stage } }
                        ]
                    }
                },
                {
                    id      : 'job_closing_reason', group: 'job', get label(){ return t('table.jobList.columns.job_closing_reason.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.job_closing_reason.tooltip.title') }, get description(){ return t('table.jobList.columns.job_closing_reason.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'job_closing_reason', get title() { return t('common.export.columns.jobClosingReason') }, data: ( item, ctx ) => { return item?.closeReason } }
                        ]
                    }
                },
                {
                    id      : 'category', group: 'job', get label(){ return t('table.jobList.columns.category.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.category.tooltip.title') }, get description(){ return t('table.jobList.columns.category.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'category_asc', desc: 'category_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'category', get title() { return t('common.export.columns.category') }, data: ( item, ctx ) => { return item?.category?.label } }
                        ]
                    }
                },
                {
                    id      : 'skills', group: 'job', get label(){ return t('table.jobList.columns.skills.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.skills.tooltip.title') }, get description(){ return t('table.jobList.columns.skills.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'skills_asc', desc: 'skills_desc' },
                    export :
                    {
                        columns:
                        [
                            { id: 'skills', get title() { return t('common.export.columns.skills') }, data: ( item, ctx ) => { return item?.skills?.map( s => s.label )?.join(', ') } }
                        ]
                    }
                },
                {
                    id      : 'location', group: 'job', get label(){ return t('table.jobList.columns.location.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.location.tooltip.title') }, get description(){ return t('table.jobList.columns.location.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'locations_asc', desc: 'locations_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'location', get title() { return t('common.export.columns.location') }, data: ( item, ctx ) => { return item?.locations?.map( s => s.name )?.join(', ') } }
                        ]
                    }
                },
                {
                    id      : 'languages', group: 'job', get label(){ return t('table.jobList.columns.languages.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.languages.tooltip.title') }, get description(){ return t('table.jobList.columns.languages.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'locations_asc', desc: 'locations_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'languages', get title() { return t('common.export.columns.languages') }, data: ( item, ctx ) => { return item?.languages?.map( s => s.name )?.join(', ') } }
                        ]
                    }
                },
                {
                    id      : 'work_mode', group: 'job', get label(){ return t('table.jobList.columns.work_mode.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.work_mode.tooltip.title') }, get description(){ return t('table.jobList.columns.work_mode.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'remoteWork_asc', desc: 'remoteWork_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'work_mode', get title() { return t('common.export.columns.workType') }, data: ( item, ctx ) => { return item?.workMode } }
                        ]
                    }
                },
                {
                    id      : 'confidential_role', group: 'job', get label(){ return t('table.jobList.columns.confidential_role.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.confidential_role.tooltip.title') }, get description(){ return t('table.jobList.columns.confidential_role.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'confidentialRole_asc', desc: 'confidentialRole_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'confidential_role', get title() { return t('common.export.columns.confidentialRole') }, data: ( item, ctx ) => { return item?.confidential ? 'Yes' : 'No' } }
                        ]
                    }
                },
                {
                    id      : 'programme', group: 'job', get label(){ return t('table.jobList.columns.programme.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.programme.tooltip.title') }, get description(){ return t('table.jobList.columns.programme.tooltip.description') } },
                    scope   : [ 'admin', 'employer' ],
                    //sort   : { asc: 'programme_asc', desc: 'programme_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'programme', get title() { return t('common.export.columns.program') }, data: ( item, ctx ) => { return item?.programme?.title } },
                            { id: 'programme_location', get title() { return t('common.export.columns.programLocation') }, data: ( item, ctx ) => { return item?.programmeLocation?.title } },
                        ]
                    }
                },
                {
                    id      : 'recruiter', group: 'job', get label(){ return t('table.jobList.columns.recruiter.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.recruiter.tooltip.title') }, get description(){ return t('table.jobList.columns.recruiter.tooltip.description') } },
                    scope   : [ 'recruiter' ],
                    //sort   : { asc: 'employer_asc', desc: 'employer_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'recruiter', get title() { return t('common.export.columns.jobManager') }, data: ( item, ctx ) => { return item?.employers?.[0]?.name } }
                        ]
                    }
                },
                {
                    id      : 'employer', group: 'job', get label(){ return t('table.jobList.columns.employer.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.employer.tooltip.title') }, get description(){ return t('table.jobList.columns.employer.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'employer_asc', desc: 'employer_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'employer', get title() { return t('common.export.columns.jobManager') }, data: ( item, ctx ) => { return item?.employers?.[0]?.name } },
                            { id: 'employer_organization', get title() { return t('common.export.columns.jobManagerOrganization') }, data: ( item, ctx ) => { return item?.employers?.[0]?.organization?.name } },
                        ]
                    }
                },
                {
                    id      : 'account_manager', group: 'job', get label(){ return t('table.jobList.columns.account_manager.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.account_manager.tooltip.title') }, get description(){ return t('table.jobList.columns.account_manager.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'accountManager_asc', desc: 'accountManager_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'account_manager', get title() { return t('common.export.columns.accountManager') }, data: ( item, ctx ) => { return item?.accountManagers?.[0]?.name } },
                            { id: 'account_manager_organization', get title() { return t('common.export.columns.accountManagerOrganization') }, data: ( item, ctx ) => { return item?.accountManagers?.[0]?.organization?.name } },
                        ]
                    }
                },
                {
                    id      : 'salary', group: 'job', get label(){ return t('table.jobList.columns.salary.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.salary.tooltip.title') }, get description(){ return t('table.jobList.columns.salary.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'salary_asc', desc: 'salary_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'salary', get title() { return t('common.export.columns.salaryRate') }, data: ( item, ctx ) =>
                                {
                                    if( item.employment?.salary?.range?.min )
                                    {
                                        if( !Helpers.equals( item.employment?.salary?.range?.min, item.employment?.salary?.range?.max ) )
                                        {
                                            return `${ Commercials.convertCurrency( item.employment.salary.range.min, item.employment.salary.currency, ctx?.$defaultCurrency || item.employment?.salary.currency ).toFixed(2) } - ${ Commercials.convertCurrency( item.employment.salary.range.max, item.employment.salary.currency, ctx?.$defaultCurrency || item.employment.salary.currency ).toFixed(2) }`;
                                        }
                                        else
                                        {
                                            return `${ Commercials.convertCurrency( item.employment.salary.range.min, item.employment.salary.currency, ctx?.$defaultCurrency || item.employment.salary.currency ).toFixed(2) }`;
                                        }
                                    }
                                    else
                                    {
                                        return `To be confirmed`;
                                    }
                                }
                            },
                            {
                                id: 'salary_currency', get title() { return t('common.export.columns.currency') }, data: ( item, ctx ) =>
                                {
                                    if( item.employment?.salary?.range?.min )
                                    {
                                        return ( ctx?.$defaultCurrency || item?.employment?.salary?.currency );
                                    }
                                }
                            },
                            {
                                id: 'salary_rate', get title() { return t('common.export.columns.salaryRateFrequency') }, data: ( item, ctx ) =>
                                {
                                    if( item.employment?.salary?.range?.min )
                                    {
                                        return item?.employment?.salary?.rate;
                                    }
                                    else
                                    {
                                        return 'Negotiable';
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'recruitment_fee', group: 'job', get label(){ return t('table.jobList.columns.recruitment_fee.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.recruitment_fee.tooltip.title') }, get description(){ return t('table.jobList.columns.recruitment_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'recruiter' ],
                    //sort   : { asc: 'recruitmentFee_asc', desc: 'recruitmentFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'recruitment_fee_amount', get title() { return t('common.export.columns.agencyFeeAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item?.summary?.fees?.recruitment?.range?.min?.amount )
                                    {
                                        if( !Helpers.equals( item.summary.fees.recruitment.range.min.amount, item.summary.fees.recruitment.range.max.amount ) )
                                        {
                                            return `${ Commercials.convertCurrency( item.summary.fees.recruitment.range.min.amount, item.summary.fees.recruitment.range.min.currency, ctx?.$defaultCurrency || item.employment.salary.currency ).toFixed(2) } - ${ Commercials.convertCurrency( item.summary.fees.recruitment.range.max.amount, item.summary.fees.recruitment.range.max.currency, ctx?.$defaultCurrency || item.employment.salary.currency ).toFixed(2) }`;
                                        }
                                        else
                                        {
                                            return `${ Commercials.convertCurrency( item.summary.fees.recruitment.range.min.amount, item.summary.fees.recruitment.range.min.currency, ctx?.$defaultCurrency || item.employment.salary.currency ).toFixed(2) }`;
                                        }
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_currency', get title() { return t('common.export.columns.agencyFeeCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.range?.min?.amount )
                                    {
                                        return ( ctx?.$defaultCurrency || item.employment.salary.currency );
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_percentage', get title() { return t('common.export.columns.agencyFeeIn') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.range?.min?.markup )
                                    {
                                        if( !Helpers.equals( item.summary.fees.recruitment.range.min.markup, item.summary.fees.recruitment.range.max.markup ) )
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.markup } - ${ item.summary.fees.recruitment.range.max.markup }`;
                                        }
                                        else
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.markup }`;
                                        }
                                    }
                                }
                            }
                        ]
                    }
                },
                /*
                {
                    id      : 'supplier_fee', group: 'job', get label(){ return t('table.jobList.columns.supplier_fee.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.supplier_fee.tooltip.title') }, get description(){ return t('table.jobList.columns.supplier_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin' ],
                    //sort   : { asc: 'supplierFee_asc', desc: 'supplierFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'supplier_fee_amount', get title() { return t('common.export.columns.handlingFeeAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item?.summary?.fees?.agency?.range?.min?.amount )
                                    {
                                        if( !Helpers.equals( item.summary.fees.agency.range.min.amount, item.summary.fees.agency.range.max.amount ) )
                                        {
                                            return `${ Commercials.convertCurrency( item.summary.fees.agency.range.min.amount, item.summary.fees.agency.range.min.currency, ctx?.$defaultCurrency || item.employment.salary.currency ).toFixed(2) } - ${ Commercials.convertCurrency( item.summary.fees.agency.range.max.amount, item.summary.fees.agency.range.max.currency, ctx?.$defaultCurrency || item.employment.salary.currency ).toFixed(2) }`
                                        }
                                        else
                                        {
                                            return `${ Commercials.convertCurrency( item.summary.fees.agency.range.min.amount, item.summary.fees.agency.range.min.currency, ctx?.$defaultCurrency || item.employment.salary.currency ).toFixed(2) }`;
                                        }
                                    }
                                }
                            },
                            {
                                id: 'supplier_fee_currency', get title() { return t('common.export.columns.handlingFeeCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item?.summary.fees?.agency?.range?.min?.amount )
                                    {
                                        return ( ctx?.$defaultCurrency || item.employment.salary.currency );
                                    }
                                }
                            },
                            {
                                id: 'supplier_fee_percentage', get title() { return t('common.export.columns.handlingFeeIn') }, data: ( item, ctx ) =>
                                {
                                    if( item?.summary.fees?.agency?.range?.min?.markup )
                                    {
                                        if( !Helpers.equals( item.summary.fees.agency.range.min.markup, item.summary.fees.agency.range.max.markup ) )
                                        {
                                            return `${ item.summary.fees.agency.range.min.markup } - ${ item.summary.fees.agency.range.max.markup }`;
                                        }
                                        else
                                        {
                                            return `${ item.summary.fees.agency.range.min.markup }`;
                                        }
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'employer_fee', group: 'job', get label(){ return t('table.jobList.columns.employer_fee.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.employer_fee.tooltip.title') }, get description(){ return t('table.jobList.columns.employer_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin' ],
                    //sort   : { asc: 'employerFee_asc', desc: 'employerFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'employer_fee_amount', get title() { return t('common.export.columns.employerHandlingFeeAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item?.summary.fees?.employer?.range?.min?.amount )
                                    {
                                        if( !Helpers.equals( item.summary.fees.employer.range.min.amount, item.summary.fees.employer.range.max.amount ) )
                                        {
                                            return `${ Commercials.convertCurrency( item.summary.fees.employer.range.min.amount, item.summary.fees.employer.range.min.currency, ctx?.$defaultCurrency || item.employment.salary.currency ).toFixed(2) } - ${ Commercials.convertCurrency( item.summary.fees.employer.range.max.amount, item.summary.fees.employer.range.max.currency, ctx?.$defaultCurrency || item.employment.salary.currency ).toFixed(2) }`
                                        }
                                        else
                                        {
                                            return `${ Commercials.convertCurrency( item.summary.fees.employer.range.min.amount, item.summary.fees.employer.range.min.currency, ctx?.$defaultCurrency || item.employment.salary.currency ).toFixed(2) }`;
                                        }
                                    }
                                }
                            },
                            {
                                id: 'employer_fee_currency', get title() { return t('common.export.columns.employerHandlingFeeCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item?.summary.fees?.employer?.range?.min?.amount )
                                    {
                                         return ( ctx?.$defaultCurrency || item.employment.salary.currency );
                                    }
                                }
                            },
                            {
                                id: 'employer_fee_percentage', get title() { return t('common.export.columns.employerHandlingFeeIn') }, data: ( item, ctx ) =>
                                {
                                    if( item?.summary.fees?.employer?.range?.min?.markup )
                                    {
                                        if( !Helpers.equals( item.summary.fees.employer.range.min.markup, item.summary.fees.employer.range.max.markup ) )
                                        {
                                            return `${ item.summary.fees.employer.range.min.markup } - ${ item.summary.fees.employer.range.max.markup }`;
                                        }
                                        else
                                        {
                                            return `${ item.summary.fees.employer.range.min.markup }`;
                                        }
                                    }
                                }
                            }
                        ]
                    }
                },
                */
                {
                    id      : 'positions_total', group: 'job', get label(){ return t('table.jobList.columns.positions_total.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.positions_total.tooltip.title') }, get description(){ return t('table.jobList.columns.positions_total.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'positionsTotal_asc', desc: 'positionsTotal_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'positions_total', get title() { return t('common.export.columns.positionsTotal') }, data: ( item, ctx ) => { return item?.summary?.positions?.total } }
                        ]
                    }
                },
                {
                    id      : 'engagements_active', group: 'job', get label(){ return t('table.jobList.columns.engagements_active.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.engagements_active.tooltip.title') }, get description(){ return t('table.jobList.columns.engagements_active.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ],
                    sort    : { asc: 'engagementsActive_asc', desc: 'engagementsActive_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'engagements_active', get title() { return t('common.export.columns.activeEngagements') }, data: ( item, ctx ) => { return item?.summary?.engagements?.active } }
                        ]
                    }
                },
                {
                    id      : 'applications_active', group: 'job', get label(){ return t('table.jobList.columns.applications_active.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.applications_active.tooltip.title') }, get description(){ return t('table.jobList.columns.applications_active.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'recruiter', 'employer' ],
                    sort    : { asc: 'applicationsActive_asc', desc: 'applicationsActive_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'applications_active', get title() { return t('common.export.columns.activeApplications') }, data: ( item, ctx ) => { return item?.summary?.applications?.active } }
                        ]
                    }
                },
                {
                    id      : 'applications_total', group: 'job', get label(){ return t('table.jobList.columns.applications_total.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.applications_total.tooltip.title') }, get description(){ return t('table.jobList.columns.applications_total.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'recruiter', 'employer' ],
                    //sort    : { asc: 'applicationsTotal_asc', desc: 'applicationsTotal_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'applications_total', get title() { return t('common.export.columns.totalApplications') }, data: ( item, ctx ) => { return item?.summary?.applications?.total } }
                        ]
                    }
                },
                {
                    id      : 'latest_interaction', group: 'job', get label(){ return t('table.jobList.columns.latest_interaction.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.latest_interaction.tooltip.title') }, get description(){ return t('table.jobList.columns.latest_interaction.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'latestInteract_asc', desc: 'latestInteract_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'latest_interaction', get title() { return t('common.export.columns.latestInteraction') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.refreshed )
                                    {
                                        return new Date( item.events.refreshed ).toUTCDate()
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'start_date', group: 'job', get label(){ return t('table.jobList.columns.start_date.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.start_date.tooltip.title') }, get description(){ return t('table.jobList.columns.start_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'startDate_asc', desc: 'startDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'start_date', get title() { return t('common.export.columns.startDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.employment?.interval?.start )
                                    {
                                        return new Date( item.employment.interval.start ).toUTCDate()
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'end_date', group: 'job', get label(){ return t('table.jobList.columns.end_date.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.end_date.tooltip.title') }, get description(){ return t('table.jobList.columns.end_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'endDate_asc', desc: 'endDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'end_date', get title() { return t('common.export.columns.endDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.employment?.interval?.end )
                                    {
                                        return new Date( item.employment.interval.end ).toUTCDate()
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'created', group: 'job', get label(){ return t('table.jobList.columns.created.label') },
                    tooltip : { get title(){ return t('table.jobList.columns.created.tooltip.title') }, get description(){ return t('table.jobList.columns.created.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'createdDate_asc', desc: 'createdDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'createdDate', get title() { return t('common.export.columns.created') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.created )
                                    {
                                        return new Date( item.events.created ).toUTCDate()
                                    }
                                }
                            }
                        ]
                    }
                },
            ],

            presets:
            [
                { id: 'admin', name: 'default', columns: [ "open_jobs", "rag_jobs", "title", "reference", "stage", "location", "engagements_active", "applications_active", "employer", "account_manager", "latest_interaction", "created" ] },
                { id: 'employer', name: 'default', columns: [ "open_jobs", "title", "reference", "stage", "salary", "location", "engagements_active", "applications_active", "account_manager", "latest_interaction", "created" ] },
                { id: 'recruiter', name: 'default', columns: [ "open_jobs", "title", "reference", "salary", "recruitment_fee", "location", "applications_active", "skills", "recruiter", "employer", "account_manager", "latest_interaction", "created" ] },
            ]
        }
    },

    invitationList: //DONE
    {
        grid    : { columns : 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'invitation', get label(){ return t('table.invitationList.groups.invitation.label') } }
            ],

            columns:
            [
                {
                    id      : 'open_jobs', group: 'job', get label(){ return t('table.invitationList.columns.open_jobs.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.open_jobs.tooltip.title') }, get description(){ return t('table.invitationList.columns.open_jobs.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'openJobsTotal_asc', desc: 'openJobsTotal_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'open_jobs', get title() { return t('common.export.columns.openJobs') }, data: ( item, ctx ) => { return item?.job?.summary?.positions?.open } }
                        ]
                    }
                },
                {
                    id      : 'title', group: 'invitation', get label(){ return t('table.invitationList.columns.title.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.title.tooltip.title') }, get description(){ return t('table.invitationList.columns.title.tooltip.description') } },
                    width   : '384px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'title_asc', desc: 'title_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'reference', get title() { return t('common.export.columns.reference') }, data: ( item, ctx ) => { return item?.job?.reference } },
                            { id: 'status', get title() { return t('common.export.columns.requisitionStatus') }, data: ( item, ctx ) => { return item?.job?.status } },
                            { id: 'title', get title() { return t('common.export.columns.title') }, data: ( item, ctx ) => { return item?.job?.title } },
                            { id: 'contractType', get title() { return t('common.export.columns.contractType') }, data: ( item, ctx ) => { return item?.job?.employment?.type } },
                        ]
                    }
                },
                {
                    id      : 'reference', group: 'job', get label(){ return t('table.invitationList.columns.reference.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.reference.tooltip.title') }, get description(){ return t('table.invitationList.columns.reference.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'reference', get title() { return t('common.export.columns.reference') }, data: ( item, ctx ) => { return item?.job?.reference } }
                        ]
                    }
                },
                {
                    id      : 'status', group: 'invitation', get label(){ return t('table.invitationList.columns.status.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.status.tooltip.title') }, get description(){ return t('table.invitationList.columns.status.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'status_asc', desc: 'status_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'status', get title() { return t('common.export.columns.invitationStatus') }, data: ( item, ctx ) => { return item?.status } },
                        ]
                    }
                },
                {
                    id      : 'tags', group: 'agency', get label(){ return t('table.invitationList.columns.tags.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.tags.tooltip.title') }, get description(){ return t('table.invitationList.columns.tags.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'tags', get title() { return t('common.export.columns.tags') }, data: ( item, ctx ) => { return item?.recruiterAccount?.organization?.tags?.map( t => t.name )?.join(', ') } }
                        ]
                    }
                },
                {
                    id      : 'category', group: 'invitation', get label(){ return t('table.invitationList.columns.category.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.category.tooltip.title') }, get description(){ return t('table.invitationList.columns.category.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'category_asc', desc: 'category_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'category', get title() { return t('common.export.columns.category') }, data: ( item, ctx ) => { return item?.job?.category?.label } }
                        ]
                    }
                },
                {
                    id      : 'salary', group: 'invitation', get label(){ return t('table.invitationList.columns.salary.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.salary.tooltip.title') }, get description(){ return t('table.invitationList.columns.salary.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'salary_asc', desc: 'salary_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'salary', get title() { return t('common.export.columns.salaryRate') }, data: ( item, ctx ) =>
                                {
                                    if( item.job.employment?.salary?.range?.min )
                                    {
                                        if( !Helpers.equals( item.job.employment?.salary?.range?.min, item.job.employment?.salary?.range?.max ) )
                                        {
                                            return `${ Commercials.convertCurrency( item.job.employment.salary.range.min, item.job.employment.salary.currency, ctx?.$defaultCurrency || item.job.employment?.salary.currency ).toFixed(2) } - ${ Commercials.convertCurrency( item.job.employment.salary.range.max, item.job.employment.salary.currency, ctx?.$defaultCurrency || item.job.employment.salary.currency ).toFixed(2) }`;
                                        }
                                        else
                                        {
                                            return `${ Commercials.convertCurrency( item.job.employment.salary.range.min, item.job.employment.salary.currency, ctx?.$defaultCurrency || item.job.employment.salary.currency ).toFixed(2) }`;
                                        }
                                    }
                                    else
                                    {
                                        return `To be confirmed`;
                                    }
                                }
                            },
                            {
                                id: 'salary_currency', get title() { return t('common.export.columns.currency') }, data: ( item, ctx ) =>
                                {
                                    if( item.job.employment?.salary?.range?.min )
                                    {
                                        return ( ctx?.$defaultCurrency || item.job?.employment?.salary?.currency );
                                    }
                                }
                            },
                            {
                                id: 'salary_rate', get title() { return t('common.export.columns.salaryRateFrequency') }, data: ( item, ctx ) =>
                                {
                                    if( item.job.employment?.salary?.range?.min )
                                    {
                                        return item.job?.employment?.salary?.rate;
                                    }
                                    else
                                    {
                                        return 'Negotiable';
                                    }
                                }
                            },
                        ]
                    }
                },
                {
                    id      : 'recruitment_fee', group: 'invitation', get label(){ return t('table.invitationList.columns.recruitment_fee.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.recruitment_fee.tooltip.title') }, get description(){ return t('table.invitationList.columns.recruitment_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'agencyFee_asc', desc: 'agencyFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'recruitment_fee_amount', get title() { return t('common.export.columns.agencyFeeAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.range?.min?.amount )
                                    {
                                        if( !Helpers.equals( item.summary.fees.recruitment.range.min.amount, item.summary.fees.recruitment.range.max.amount ) )
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.amount.toFixed(2) } - ${ item.summary.fees.recruitment.range.max.amount.toFixed(2) }`;
                                        }
                                        else
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.amount.toFixed(2) }`;
                                        }
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_currency', get title() { return t('common.export.columns.agencyFeeCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.range?.min?.amount )
                                    {
                                        return  item.summary.fees.recruitment.range.min.currency;
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_percentage', get title() { return t('common.export.columns.agencyFeeIn') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.range?.min?.markup )
                                    {
                                        if( !Helpers.equals( item.summary.fees.recruitment.range.min.markup, item.summary.fees.recruitment.range.max.markup ) )
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.markup } - ${ item.summary.fees.recruitment.range.max.markup }`;
                                        }
                                        else
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.markup }`;
                                        }
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'agency_recruitment_fee', group: 'invitation', get label(){ return t('table.invitationList.columns.agency_recruitment_fee.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.agency_recruitment_fee.tooltip.title') }, get description(){ return t('table.invitationList.columns.agency_recruitment_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin' ],
                    //sort    : { asc: 'agencyFee_asc', desc: 'agencyFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'recruitment_fee_amount', get title() { return t('common.export.columns.agencyFeeAmountAgency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.agencyRecruitment?.range?.min?.amount )
                                    {
                                        if( !Helpers.equals( item.summary.fees.agencyRecruitment.range.min.amount, item.summary.fees.agencyRecruitment.range.max.amount ) )
                                        {
                                            return `${ item.summary.fees.agencyRecruitment.range.min.amount.toFixed(2) } - ${ item.summary.fees.agencyRecruitment.range.max.amount.toFixed(2) }`;
                                        }
                                        else
                                        {
                                            return `${ item.summary.fees.agencyRecruitment.range.min.amount.toFixed(2) }`;
                                        }
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_currency', get title() { return t('common.export.columns.agencyFeeCurrencyAgency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.agencyRecruitment?.range?.min?.amount )
                                    {
                                        return item.summary.fees.agencyRecruitment.range.min.currency;
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_percentage', get title() { return t('common.export.columns.agencyFeeInAgency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.agencyRecruitment?.range?.min?.markup )
                                    {
                                        if( !Helpers.equals( item.summary.fees.agencyRecruitment.range.min.markup, item.summary.fees.agencyRecruitment.range.max.markup ) )
                                        {
                                            return `${ item.summary.fees.agencyRecruitment.range.min.markup } - ${ item.summary.fees.agencyRecruitment.range.max.markup }`;
                                        }
                                        else
                                        {
                                            return `${ item.summary.fees.agencyRecruitment.range.min.markup }`;
                                        }
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'employer_recruitment_fee', group: 'invitation', get label(){ return t('table.invitationList.columns.employer_recruitment_fee.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.employer_recruitment_fee.tooltip.title') }, get description(){ return t('table.invitationList.columns.employer_recruitment_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin' ],
                    //sort    : { asc: 'agencyFee_asc', desc: 'agencyFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'recruitment_fee_amount', get title() { return t('common.export.columns.agencyFeeAmountEmployer') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.range?.min?.amount )
                                    {
                                        if( !Helpers.equals( item.summary.fees.recruitment.range.min.amount, item.summary.fees.recruitment.range.max.amount ) )
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.amount.toFixed(2) } - ${ item.summary.fees.recruitment.range.max.amount.toFixed(2) }`;
                                        }
                                        else
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.amount.toFixed(2) }`;
                                        }
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_currency', get title() { return t('common.export.columns.agencyFeeCurrencyEmployer') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.range?.min?.amount )
                                    {
                                        return item.summary.fees.recruitment.range.min.currency;
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_percentage', get title() { return t('common.export.columns.agencyFeeInEmployer') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.range?.min?.markup )
                                    {
                                        if( !Helpers.equals( item.summary.fees.recruitment.range.min.markup, item.summary.fees.recruitment.range.max.markup ) )
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.markup } - ${ item.summary.fees.recruitment.range.max.markup }`;
                                        }
                                        else
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.markup }`;
                                        }
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'engagement_price', group: 'invitation', get label(){ return t('table.invitationList.columns.engagement_price.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.engagement_price.tooltip.title') }, get description(){ return t('table.invitationList.columns.engagement_price.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'recruiter' ],
                    //sort    : { asc: 'engagementPrice_asc', desc: 'engagementPrice_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'engagement_price', get title() { return t('common.export.columns.engagementPrice') }, data: ( item, ctx ) =>
                                {
                                    if( item?.engagement?.price )
                                    {
                                        return Format.currency( Commercials.convertCurrency( item.engagement.price, item.engagement.currency, ctx?.$defaultCurrency || item.engagement.currency ), ctx?.$defaultCurrency || item.engagement.currency );
                                    }
                                    else
                                    {
                                        return 'Free to engage';
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'inviter', group: 'invitation', get label(){ return t('table.invitationList.columns.inviter.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.inviter.tooltip.title') }, get description(){ return t('table.invitationList.columns.inviter.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'inviter_asc', desc: 'inviter_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'inviter', get title() { return t('common.export.columns.inviter') }, data: ( item, ctx ) => { return item?.senderAccount?.name } },
                            { id: 'inviter_organization', get title() { return t('common.export.columns.inviterOrganization') }, data: ( item, ctx ) => { return item?.senderAccount?.organization?.name } },
                        ]
                    }
                },
                {
                    id      : 'recruiter', group: 'invitation', get label(){ return t('table.invitationList.columns.recruiter.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.recruiter.tooltip.title') }, get description(){ return t('table.invitationList.columns.recruiter.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'recruiter_asc', desc: 'recruiter_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'recruiter', get title() { return t('common.export.columns.recruiter') }, data: ( item, ctx ) => { return item?.recruiterAccount?.name } },
                            { id: 'recruiter_organization', get title() { return t('common.export.columns.recruiterOrganization') }, data: ( item, ctx ) => { return item?.recruiterAccount?.organization?.name } },
                        ]
                    }
                },
                {
                    id      : 'agency', group: 'invitation', get label(){ return t('table.invitationList.columns.agency.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.agency.tooltip.title') }, get description(){ return t('table.invitationList.columns.agency.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'recruiter_asc', desc: 'recruiter_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'agency', get title() { return t('common.export.columns.agency') }, data: ( item, ctx ) => { return item?.recruiterAccount?.organization?.name } },
                            { id: 'agency_organization', get title() { return t('common.export.columns.agencyRecruiter') }, data: ( item, ctx ) => { return item?.recruiterAccount?.name } },
                        ]
                    }
                },
                {
                    id      : 'programme', group: 'invitation', get label(){ return t('table.invitationList.columns.programme.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.programme.tooltip.title') }, get description(){ return t('table.invitationList.columns.programme.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'programme_asc', desc: 'programme_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'programme', get title() { return t('common.export.columns.program') }, data: ( item, ctx ) => { return item?.programme?.title } },
                            { id: 'programme_location', get title() { return t('common.export.columns.programLocation') }, data: ( item, ctx ) => { return item.job?.programmeLocation?.title } },
                        ]
                    }
                },
                {
                    id      : 'release', group: 'invitation', get label(){ return t('table.invitationList.columns.release.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.release.tooltip.title') }, get description(){ return t('table.invitationList.columns.release.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'release_asc', desc: 'release_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'release', get title() { return t('common.export.columns.releaseType') }, data: ( item, ctx ) => { return item.release.capitalize() } },
                        ]
                    }
                },
                {
                    id      : 'created', group: 'invitation', get label(){ return t('table.invitationList.columns.created.label') },
                    tooltip : { get title(){ return t('table.invitationList.columns.created.tooltip.title') }, get description(){ return t('table.invitationList.columns.created.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'createdDate_asc', desc: 'createdDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'createdDate', get title() { return t('common.export.columns.created') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.created )
                                    {
                                        return new Date( item.events.created ).toUTCDate()
                                    }
                                }
                            }
                        ]
                    }
                }
            ],

            presets:
            [
                { id: "admin", name: "default", columns: [ "open_jobs", "title", "reference", "status", "category", "engagement_price", "agency_recruitment_fee", "employer_recruitment_fee", "salary", "inviter", "recruiter", "programme", "created" ] },
                { id: "employer", name: "default", columns: [ "open_jobs", "title", "reference", "status", "category", "recruitment_fee", "salary", "inviter", "recruiter", "programme", "created" ] },
                { id: "recruiter", name: "default", columns: [ "open_jobs", "title", "reference", "status", "category", "engagement_price", "recruitment_fee", "salary", "inviter", "recruiter", "programme", "created" ] },
                { id: "ramp.recruitment.job.invitation", name: "default", columns: [ "agency", "status", "recruitment_fee", "inviter", "release", "created" ] },
                { id: "72fdacd2bfc938feb30a28f0", name: "Tiers", columns: [ "agency", "status", "tags", "recruitment_fee", "inviter", "release", "created" ] }
            ]
        }
    },

    engagementList:
    {
        grid    : { columns : 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'engagement', get label(){ return t('table.engagementList.groups.engagement.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'engagement', get label(){ return t('table.engagementList.columns.title.label') },
                    tooltip : { get title(){ return t('table.engagementList.columns.title.tooltip.title') }, get description(){ return t('table.engagementList.columns.title.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'engagement_title_asc', desc: 'engagement_title_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'agency', get title() { return t('common.export.columns.agency') }, data: ( item, ctx ) => { return item?.recruiter?.organization?.name } },
                            { id: 'agency_user', get title() { return t('common.export.columns.agencyUser') }, data: ( item, ctx ) => { return item?.recruiter?.name } }
                        ]
                    }
                },
                {
                    id      : 'status', group: 'engagement', get label(){ return t('table.engagementList.columns.status.label') },
                    tooltip : { get title(){ return t('table.engagementList.columns.status.tooltip.title') }, get description(){ return t('table.engagementList.columns.status.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'engagement_status_asc', desc: 'engagement_status_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'status', get title() { return t('common.export.columns.engagementStatus') }, data: ( item, ctx ) => { return item?.status?.capitalize() } }
                        ]
                    }
                },
                {
                    id      : 'agency_recruitment_fee', group: 'engagement', get label(){ return t('table.engagementList.columns.agency_recruitment_fee.label') },
                    tooltip : { get title(){ return t('table.engagementList.columns.agency_recruitment_fee.tooltip.title') }, get description(){ return t('table.engagementList.columns.agency_recruitment_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin' ],
                    sort    : { asc: 'engagement_recruitmentFee_asc', desc: 'engagement_recruitmentFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'agencyRecruitment_fee_amount', get title() { return t('common.export.columns.agencyFeeAmountAgency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.agencyRecruitment?.range?.min?.amount )
                                    {
                                        if( !Helpers.equals( item.summary.fees.agencyRecruitment.range.min.amount, item.summary.fees.agencyRecruitment.range.max.amount ) )
                                        {
                                            return `${ item.summary.fees.agencyRecruitment.range.min.amount.toFixed(2) } - ${ item.summary.fees.agencyRecruitment.range.max.amount.toFixed(2) }`;
                                        }
                                        else
                                        {
                                            return `${ item.summary.fees.agencyRecruitment.range.min.amount.toFixed(2) }`;
                                        }
                                    }
                                }
                            },
                            {
                                id: 'agencyRecruitment_fee_currency', get title() { return t('common.export.columns.agencyFeeCurrencyAgency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.agencyRecruitment?.range?.min?.amount )
                                    {
                                        return item.summary.fees.agencyRecruitment.range.min.currency;
                                    }
                                }
                            },
                            {
                                id: 'agencyRecruitment_fee_percentage', get title() { return t('common.export.columns.agencyFeeInAgency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.agencyRecruitment?.range?.min?.markup )
                                    {
                                        if( !Helpers.equals( item.summary.fees.agencyRecruitment.range.min.markup, item.summary.fees.agencyRecruitment.range.max.markup ) )
                                        {
                                            return `${ item.summary.fees.agencyRecruitment.range.min.markup } - ${ item.summary.fees.agencyRecruitment.range.max.markup }`;
                                        }
                                        else
                                        {
                                            return `${ item.summary.fees.agencyRecruitment.range.min.markup }`;
                                        }
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'employer_recruitment_fee', group: 'engagement', get label(){ return t('table.engagementList.columns.employer_recruitment_fee.label') },
                    tooltip : { get title(){ return t('table.engagementList.columns.employer_recruitment_fee.tooltip.title') }, get description(){ return t('table.engagementList.columns.employer_recruitment_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin' ],
                    sort    : { asc: 'engagement_recruitmentFee_asc', desc: 'engagement_recruitmentFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'recruitment_fee_amount', get title() { return t('common.export.columns.agencyFeeAmountEmployer') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.range?.min?.amount )
                                    {
                                        if( !Helpers.equals( item.summary.fees.recruitment.range.min.amount, item.summary.fees.recruitment.range.max.amount ) )
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.amount.toFixed(2) } - ${ item.summary.fees.recruitment.range.max.amount.toFixed(2) }`;
                                        }
                                        else
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.amount.toFixed(2) }`;
                                        }
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_currency', get title() { return t('common.export.columns.agencyFeeCurrencyEmployer') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.range?.min?.amount )
                                    {
                                        return item.summary.fees.recruitment.range.min.currency;
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_percentage', get title() { return t('common.export.columns.agencyFeeInEmployer') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.range?.min?.markup )
                                    {
                                        if( !Helpers.equals( item.summary.fees.recruitment.range.min.markup, item.summary.fees.recruitment.range.max.markup ) )
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.markup } - ${ item.summary.fees.recruitment.range.max.markup }`;
                                        }
                                        else
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.markup }`;
                                        }
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'recruitment_fee', group: 'engagement', get label(){ return t('table.engagementList.columns.recruitment_fee.label') },
                    tooltip : { get title(){ return t('table.engagementList.columns.recruitment_fee.tooltip.title') }, get description(){ return t('table.engagementList.columns.recruitment_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'employer', 'recruiter' ],
                    sort    : { asc: 'engagement_recruitmentFee_asc', desc: 'engagement_recruitmentFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'recruitment_fee_amount', get title() { return t('common.export.columns.agencyFeeAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.range?.min?.amount )
                                    {
                                        if( !Helpers.equals( item.summary.fees.recruitment.range.min.amount, item.summary.fees.recruitment.range.max.amount ) )
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.amount.toFixed(2) } - ${ item.summary.fees.recruitment.range.max.amount.toFixed(2) }`;
                                        }
                                        else
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.amount.toFixed(2) }`;
                                        }
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_currency', get title() { return t('common.export.columns.agencyFeeCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.range?.min?.amount )
                                    {
                                        return item.summary.fees.recruitment.range.min.currency;
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_percentage', get title() { return t('common.export.columns.agencyFeeIn') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.range?.min?.markup )
                                    {
                                        if( !Helpers.equals( item.summary.fees.recruitment.range.min.markup, item.summary.fees.recruitment.range.max.markup ) )
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.markup } - ${ item.summary.fees.recruitment.range.max.markup }`;
                                        }
                                        else
                                        {
                                            return `${ item.summary.fees.recruitment.range.min.markup }`;
                                        }
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'candidates', group: 'engagement', get label(){ return t('table.engagementList.columns.candidates.label') },
                    tooltip : { get title(){ return t('table.engagementList.columns.candidates.tooltip.title') }, get description(){ return t('table.engagementList.columns.candidates.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'engagement_candidates_asc', desc: 'engagement_candidates_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'candidates', get title() { return t('common.export.columns.applications') }, data: ( item, ctx ) => { return item?.applications?.length } }
                        ]
                    }
                },
                {
                    id      : 'slots', group: 'engagement', get label(){ return t('table.engagementList.columns.slots.label') },
                    tooltip : { get title(){ return t('table.engagementList.columns.slots.tooltip.title') }, get description(){ return t('table.engagementList.columns.slots.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'engagement_cv_slots_asc', desc: 'engagement_cv_slots_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'slots', get title() { return t('common.export.columns.cVSlots') }, data: ( item, ctx ) => { return item?.cvs } }
                        ]
                    }
                },
                {
                    id      : 'tags', group: 'agency', get label(){ return t('table.engagementList.columns.tags.label') },
                    tooltip : { get title(){ return t('table.engagementList.columns.tags.tooltip.title') }, get description(){ return t('table.engagementList.columns.tags.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'tags', get title() { return t('common.export.columns.tags') }, data: ( item, ctx ) => { return item?.recruiter?.organization?.tags?.map( t => t.name )?.join(', ') } }
                        ]
                    }
                },
                {
                    id      : 'engagementDate', group: 'engagement', get label(){ return t('table.engagementList.columns.engagementDate.label') },
                    tooltip : { get title(){ return t('table.engagementList.columns.engagementDate.tooltip.title') }, get description(){ return t('table.engagementList.columns.engagementDate.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'engagement_engagementDate_asc', desc: 'engagement_engagementDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'date', get title() { return t('common.export.columns.engagementDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.created )
                                    {
                                        return new Date( item.events.created ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'disengagementDate', group: 'engagement', get label(){ return t('table.engagementList.columns.disengagementDate.label') },
                    tooltip : { get title(){ return t('table.engagementList.columns.disengagementDate.tooltip.title') }, get description(){ return t('table.engagementList.columns.disengagementDate.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'engagement_disengagementDate_asc', desc: 'engagement_disengagementDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'date', get title() { return t('common.export.columns.disengagementDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.created )
                                    {
                                        return new Date( item.events.closed ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                }
            ],

            presets:
            [
                //{ id: 'default', name: 'default', columns: [ 'title', /*'recruitment_fee',*/ 'candidates', 'date' ] },
                { id: 'admin', name: 'default', columns: [ 'title', 'status', 'agency_recruitment_fee', 'employer_recruitment_fee', 'candidates', 'slots', 'engagementDate', 'disengagementDate' ] },
                { id: 'employer', name: 'default', columns: [ 'title', 'status', 'recruitment_fee', 'candidates', 'slots', 'engagementDate', 'disengagementDate' ] },
                { id: 'recruiter', name: 'default', columns: [ 'title', 'status', 'recruitment_fee', 'candidates', 'slots', 'engagementDate', 'disengagementDate' ] },

                //STRADA
                { id: '72fdacd2bfc938feb30a28f0', name: 'Tiers', columns: [ 'title', 'status', 'tags', 'recruitment_fee', 'candidates', 'slots', 'engagementDate', 'disengagementDate' ] }
            ]
        }
    },

    recruitmentList:
    {
        grid    : { columns : 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'recruitment', get label(){ return t('table.recruitmentList.groups.recruitment.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'recruitment', get label(){ return t('table.recruitmentList.columns.title.label') },
                    tooltip : { get title(){ return t('table.recruitmentList.columns.title.tooltip.title') }, get description(){ return t('table.recruitmentList.columns.title.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'recruitment', get title() { return t('common.export.columns.agencyUser') }, data: ( item, ctx ) => { return item?.name } },
                            { id: 'recruitment_position', get title() { return t('common.export.columns.position') }, data: ( item, ctx ) => { return item?.position?.title } }
                        ]
                    }
                },
                {
                    id      : 'location', group: 'recruitment', get label(){ return t('table.recruitmentList.columns.location.label') },
                    tooltip : { get title(){ return t('table.recruitmentList.columns.location.tooltip.title') }, get description(){ return t('table.recruitmentList.columns.location.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'location', get title() { return t('common.export.columns.recruiterLocation') }, data: ( item, ctx ) => { return item?.position?.location.name } }
                        ]
                    }
                },
                {
                    id      : 'fill_rate', group: 'recruitment', get label(){ return t('table.recruitmentList.columns.fill_rate.label') },
                    tooltip : { get title(){ return t('table.recruitmentList.columns.fill_rate.tooltip.title') }, get description(){ return t('table.recruitmentList.columns.fill_rate.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'fill_rate', get title() { return t('common.export.columns.avgFillRate') }, data: ( item, ctx ) => { return item?.summary?.avgFillRate } }
                        ]
                    }
                },
                {
                    id      : 'jobs', group: 'recruitment', get label(){ return t('table.recruitmentList.columns.jobs.label') },
                    tooltip : { get title(){ return t('table.recruitmentList.columns.jobs.tooltip.title') }, get description(){ return t('table.recruitmentList.columns.jobs.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'jobs', get title() { return t('common.export.columns.jobs') }, data: ( item, ctx ) => { return item?.summary?.jobs } }
                        ]
                    }
                },
                {
                    id      : 'applications', group: 'recruitment', get label(){ return t('table.recruitmentList.columns.applications.label') },
                    tooltip : { get title(){ return t('table.recruitmentList.columns.applications.tooltip.title') }, get description(){ return t('table.recruitmentList.columns.applications.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'applications', get title() { return t('common.export.columns.applications') }, data: ( item, ctx ) => { return item?.summary?.applications } }
                        ]
                    }
                },
                {
                    id      : 'placements', group: 'recruitment', get label(){ return t('table.recruitmentList.columns.placements.label') },
                    tooltip : { get title(){ return t('table.recruitmentList.columns.placements.tooltip.title') }, get description(){ return t('table.recruitmentList.columns.placements.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'placements', get title() { return t('common.export.columns.placements') }, data: ( item, ctx ) => { return item?.summary?.placements } }
                        ]
                    }
                },
                {
                    id      : 'contracts', group: 'recruitment', get label(){ return t('table.recruitmentList.columns.contracts.label') },
                    tooltip : { get title(){ return t('table.recruitmentList.columns.contracts.tooltip.title') }, get description(){ return t('table.recruitmentList.columns.contracts.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'contracts', get title() { return t('common.export.columns.assignments') }, data: ( item, ctx ) => { return item?.summary?.contractors } }
                        ]
                    }
                },
                {
                    id      : 'email', group: 'recruitment', get label(){ return t('table.recruitmentList.columns.email.label') },
                    tooltip : { get title(){ return t('table.recruitmentList.columns.email.tooltip.title') }, get description(){ return t('table.recruitmentList.columns.email.tooltip.description') } },
                    align   : 'left',
                    scope   : [ 'admin' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'email', get title() { return t('common.export.columns.email') }, data: ( item, ctx ) => { return item?.email } }
                        ]
                    }
                },
                {
                    id      : 'phone', group: 'recruitment', get label(){ return t('table.recruitmentList.columns.phone.label') },
                    tooltip : { get title(){ return t('table.recruitmentList.columns.phone.tooltip.title') }, get description(){ return t('table.recruitmentList.columns.phone.tooltip.description') } },
                    align   : 'left',
                    scope   : [ 'admin' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'phone', get title() { return t('common.export.columns.phone') }, data: ( item, ctx ) => { return item?.contact?.phone } }
                        ]
                    }
                }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'title', 'location', 'fill_rate', 'jobs', 'applications', 'placements', 'contracts' ] }
            ]
        }
    },

    applicationList: //DONE
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'application', get label(){ return t('table.applicationList.groups.application.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'application', get label(){ return t('table.applicationList.columns.title.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.title.tooltip.title') }, get description(){ return t('table.applicationList.columns.title.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'title_asc', desc: 'title_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'candidate_name', get title() { return t('common.export.columns.candidateName') }, data: ( item, ctx ) => { return item?.candidate?.name } },
                            { id: 'job_title', get title() { return t('common.export.columns.jobTitle') }, data: ( item, ctx ) => { return item?.job?.title } },
                            { id: 'employment_type', get title() { return t('common.export.columns.employmentType') }, data: ( item, ctx ) => { return item?.job?.employment?.type } },
                        ]
                    }
                },
                {
                    id      : 'reference', group: 'application', get label(){ return t('table.applicationList.columns.reference.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.reference.tooltip.title') }, get description(){ return t('table.applicationList.columns.reference.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'reference', get title() { return t('common.export.columns.reference') }, data: ( item, ctx ) => { return item?.jobReference } }
                        ]
                    }
                },
                {
                    id      : 'phone', group: 'application', get label(){ return t('table.applicationList.columns.phone.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.phone.tooltip.title') }, description: '' },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'phone', get title() { return t('common.export.columns.phone') }, data: ( item, ctx ) => { return item?.candidate?.phone } }
                        ]
                    }
                },
                {
                    id      : 'email', group: 'application', get label(){ return t('table.applicationList.columns.email.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.email.tooltip.title') }, description: '' },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'phone', get title() { return t('common.export.columns.email') }, data: ( item, ctx ) => { return item?.candidate?.email } }
                        ]
                    }
                },
                {
                    id      : 'nationality', group: 'application', get label(){ return t('table.applicationList.columns.nationality.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.nationality.tooltip.title') }, description: '' },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'nationality', get title() { return t('common.export.columns.nationality') }, data: ( item, ctx ) => { return item?.candidate?.nationality } }
                        ]
                    }
                },
                {
                    id      : 'sponsorship', group: 'application', get label(){ return t('table.applicationList.columns.sponsorship.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.sponsorship.tooltip.title') }, description: '' },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'sponsorship', get title() { return t('common.export.columns.sponsorshipRequired') }, data: ( item, ctx ) => { return item?.candidate?.sponsorship } }
                        ]
                    }
                },
                {
                    id      : 'duration', group: 'application', get label(){ return t('table.applicationList.columns.duration.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.duration.tooltip.title') }, description: '' },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'duration_value', get title() { return t('common.export.columns.jobDurationValue') }, data: ( item, ctx ) => { return item?.job.employment?.duration?.value } },
                            { id: 'duration_unit', get title() { return t('common.export.columns.jobDurationUnit') }, data: ( item, ctx ) => { return item?.job.employment.duration?.unit } }
                        ]
                    }
                },
                {
                    id      : 'status', group: 'application', get label(){ return t('table.applicationList.columns.status.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.status.tooltip.title') }, get description(){ return t('table.applicationList.columns.status.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'status_asc', desc: 'status_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'status', get title() { return t('common.export.columns.status') }, data: ( item, ctx ) => { return item?.status } },
                        ]
                    }
                },
                {
                    id      : 'availability', group: 'application', get label(){ return t('table.applicationList.columns.availability.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.availability.tooltip.title') }, get description(){ return t('table.applicationList.columns.availability.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'availability_asc', desc: 'availability_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'availability', get title() { return t('common.export.columns.availability') }, data: ( item, ctx ) => { return 'Unknown' } }, // TODO AVAILABILITY
                        ]
                    }
                },
                {
                    id      : 'category', group: 'application', get label(){ return t('table.applicationList.columns.category.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.category.tooltip.title') }, get description(){ return t('table.applicationList.columns.category.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'category_asc', desc: 'category_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'category', get title() { return t('common.export.columns.category') }, data: ( item, ctx ) => { return item?.job?.category?.label } },
                        ]
                    }
                },
                {
                    id      : 'skills', group: 'application', get label(){ return t('table.applicationList.columns.skills.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.skills.tooltip.title') }, get description(){ return t('table.applicationList.columns.skills.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'skills_asc', desc: 'skills_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'skills', get title() { return t('common.export.columns.skills') }, data: ( item, ctx ) => { return item?.skills?.map( s => s.label )?.join(', ')  } },
                        ]
                    }
                },
                {
                    id      : 'location', group: 'application', get label(){ return t('table.applicationList.columns.location.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.location.tooltip.title') }, get description(){ return t('table.applicationList.columns.location.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'locations_asc', desc: 'locations_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'location_name', get title() { return t('common.export.columns.residenceLocationName') }, data: ( item, ctx ) => { return item?.candidate?.residence?.name } },
                            { id: 'location_address', get title() { return t('common.export.columns.residenceLocationAddress') }, data: ( item, ctx ) => { return item?.candidate?.residence?.snippet?.address } }
                        ]
                    }
                },
                {
                    id      : 'work_mode', group: 'application', get label(){ return t('table.applicationList.columns.work_mode.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.work_mode.tooltip.title') }, get description(){ return t('table.applicationList.columns.work_mode.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'remoteWork_asc', desc: 'remoteWork_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'work_mode', get title() { return t('common.export.columns.workType') }, data: ( item, ctx ) => { return item?.workMode } },
                        ]
                    }
                },
                {
                    id      : 'programme', group: 'application', get label(){ return t('table.applicationList.columns.programme.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.programme.tooltip.title') }, get description(){ return t('table.applicationList.columns.programme.tooltip.description') } },
                    scope   : [ 'admin', 'employer' ],
                    //sort   : { asc: 'programme_asc', desc: 'programme_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'programme', get title() { return t('common.export.columns.program') }, data: ( item, ctx ) => { return item?.programme?.title } },
                            { id: 'programme_location', get title() { return t('common.export.columns.programLocation') }, data: ( item, ctx ) => { return item?.programmeLocation?.title } },
                        ]
                    }
                },
                {
                    id      : 'recruiter', group: 'application', get label(){ return t('table.applicationList.columns.recruiter.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.recruiter.tooltip.title') }, get description(){ return t('table.applicationList.columns.recruiter.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'recruiter_asc', desc: 'recruiter_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'recruiter', get title() { return t('common.export.columns.agencyName') }, data: ( item, ctx ) => { return item.recruiter?.organization?.name } },
                            { id: 'recruiter_user', get title() { return t('common.export.columns.agencyUser') }, data: ( item, ctx ) => { return item.recruiter?.name } },
                        ]
                    }
                },
                {
                    id      : 'employer', group: 'application', get label(){ return t('table.applicationList.columns.employer.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.employer.tooltip.title') }, get description(){ return t('table.applicationList.columns.employer.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'employer_asc', desc: 'employer_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'employer', get title() { return t('common.export.columns.jobManagerName') }, data: ( item, ctx ) => { return item?.employers?.[0]?.name } },
                            { id: 'employer_organization', get title() { return t('common.export.columns.jobManagerOrganization') }, data: ( item, ctx ) => { return item?.employers?.[0]?.organization?.name } },
                        ]
                    }
                },
                {
                    id      : 'account_manager', group: 'application', get label(){ return t('table.applicationList.columns.account_manager.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.account_manager.tooltip.title') }, get description(){ return t('table.applicationList.columns.account_manager.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'accountManager_asc', desc: 'accountManager_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'account_manager', get title() { return t('common.export.columns.accountManager') }, data: ( item, ctx ) => { return item?.accountManagers?.[0]?.name } },
                            { id: 'account_manager_organization', get title() { return t('common.export.columns.accountManagerOrganization') }, data: ( item, ctx ) => { return item?.accountManagers?.[0]?.name } },
                        ]
                    }
                },
                {
                    id      : 'salary', group: 'application', get label(){ return t('table.applicationList.columns.salary.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.salary.tooltip.title') }, get description(){ return t('table.applicationList.columns.salary.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'salary_asc', desc: 'salary_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'salary', get title() { return t('common.export.columns.salaryRate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.salary?.amount )
                                    {
                                        return Commercials.convertCurrency( item.salary.amount, item.salary.currency, ctx?.$defaultCurrency || item.salary.currency ).toFixed(2)
                                    }
                                }
                            },
                            {
                                id: 'salary_currency', get title() { return t('common.export.columns.currency') }, data: ( item, ctx ) =>
                                {
                                    if( item?.salary?.amount )
                                    {
                                        return ( ctx?.$defaultCurrency || item.salary.currency )
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'recruitment_fee', group: 'application', get label(){ return t('table.applicationList.columns.recruitment_fee.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.recruitment_fee.tooltip.title') }, get description(){ return t('table.applicationList.columns.recruitment_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'employer', 'recruiter' ],
                    //sort   : { asc: 'recruitmentFee_asc', desc: 'recruitmentFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'recruitment_fee', get title() { return t('common.export.columns.agencyFeeAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.amount.toFixed(2);
                                    }
                                },
                            },
                            {
                                id: 'recruitment_fee_currency', get title() { return t('common.export.columns.agencyFeeCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.range?.min?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.currency;
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_percentage', get title() { return t('common.export.columns.agencyFeeIn') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.markup;
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'agency_recruitment_fee', group: 'application', get label(){ return t('table.applicationList.columns.agency_recruitment_fee.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.agency_recruitment_fee.tooltip.title') }, get description(){ return t('table.applicationList.columns.agency_recruitment_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin' ],
                    //sort   : { asc: 'recruitmentFee_asc', desc: 'recruitmentFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'agencyRecruitment_fee', get title() { return t('common.export.columns.agencyFeeAmountAgency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary.fees?.agencyRecruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.agencyRecruitment.amount.amount.toFixed(2);
                                    }
                                },
                            },
                            {
                                id: 'agencyRecruitment_fee_currency', get title() { return t('common.export.columns.agencyFeeCurrencyAgency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.agencyRecruitment.amount.currency;
                                    }
                                }
                            },
                            {
                                id: 'agencyRecruitment_fee_percentage', get title() { return t('common.export.columns.agencyFeeInAgency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary.fees?.agencyRecruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.agencyRecruitment.amount.markup;
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'employer_recruitment_fee', group: 'application', get label(){ return t('table.applicationList.columns.employer_recruitment_fee.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.employer_recruitment_fee.tooltip.title') }, get description(){ return t('table.applicationList.columns.employer_recruitment_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin' ],
                    //sort   : { asc: 'recruitmentFee_asc', desc: 'recruitmentFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'recruitment_fee', get title() { return t('common.export.columns.agencyFeeAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.amount.toFixed(2);
                                    }
                                },
                            },
                            {
                                id: 'recruitment_fee_currency', get title() { return t('common.export.columns.agencyFeeCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.currency;
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_percentage', get title() { return t('common.export.columns.agencyFeeIn') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.markup;
                                    }
                                }
                            }
                        ]
                    }
                },
                /*
                {
                    id      : 'supplier_fee', group: 'application', get label(){ return t('table.applicationList.columns.supplier_fee.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.supplier_fee.tooltip.title') }, get description(){ return t('table.applicationList.columns.supplier_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'employer' ],
                    //sort   : { asc: 'supplierFee_asc', desc: 'supplierFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'supplier_fee', get title() { return t('common.export.columns.agencyHandlingFeeAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item?.summary?.fees?.agency?.amount?.amount )
                                    {
                                        return item.summary.fees.agency.amount.amount.toFixed(2);
                                    }
                                },
                            },
                            {
                                id: 'supplier_fee_currency', get title() { return t('common.export.columns.agencyHandlingFeeCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item?.summary?.fees?.agency?.amount?.amount )
                                    {
                                        return item.summary.fees.agency.amount.currency;
                                    }
                                },
                            },
                            {
                                id: 'supplier_fee_percentage', get title() { return t('common.export.columns.agencyHandlingFeeIn') }, data: ( item, ctx ) =>
                                {
                                    if( item?.summary?.fees?.agency?.amount?.amount )
                                    {
                                        return item.summary.fees.agency.amount.markup;
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'employer_fee', group: 'application', get label(){ return t('table.applicationList.columns.employer_fee.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.employer_fee.tooltip.title') }, get description(){ return t('table.applicationList.columns.employer_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'employer' ],
                    //sort   : { asc: 'employerFee_asc', desc: 'employerFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'employer_fee', get title() { return t('common.export.columns.employerHandlingFeeAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.employer?.amount?.amount )
                                    {
                                        return item.summary.fees.employer.amount.amount.toFixed(2);
                                    }
                                },
                            },
                            {
                                id: 'employer_fee_currency', get title() { return t('common.export.columns.employerHandlingFeeCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.employer?.amount?.amount )
                                    {
                                        return item.summary.fees.employer.amount.currency;
                                    }
                                },
                            },
                            {
                                id: 'employer_fee_percentage', get title() { return t('common.export.columns.agencyHandlingFeeIn') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.employer?.amount?.amount )
                                    {
                                        return item.summary.fees.employer.amount.markup;
                                    }
                                }
                            }
                        ]
                    }
                },
                */
                {
                    id      : 'updated_date', group: 'application', get label(){ return t('table.applicationList.columns.updated_date.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.updated_date.tooltip.title') }, get description(){ return t('table.applicationList.columns.updated_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'updatedDate_asc', desc: 'updatedDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'updated_date', get title() { return t('common.export.columns.updated') }, data: ( item, ctx ) => { return new Date( item.events.updated ).toUTCDate() } },
                        ]
                    }
                },
                {
                    id      : 'created_date', group: 'application', get label(){ return t('table.applicationList.columns.created_date.label') },
                    tooltip : { get title(){ return t('table.applicationList.columns.created_date.tooltip.title') }, get description(){ return t('table.applicationList.columns.created_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'createdDate_asc', desc: 'createdDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'created_date', get title() { return t('common.export.columns.created') }, data: ( item, ctx ) => { return new Date( item.events.created ).toUTCDate() } },
                        ]
                    }
                }
            ],

            presets:
            [
                { id: 'admin', name: 'default', columns: [ "title", "status", "recruiter", "agency_recruitment_fee", "employer_recruitment_fee", "employer", "updated_date", "created_date" ] },
                { id: 'employer', name: 'default', columns: [ "title", "status", "salary", "recruitment_fee", "availability", "location", "recruiter", "account_manager", "updated_date", "created_date" ] },
                { id: 'recruiter', name: 'default', columns: [ "title", "status", "salary", "recruitment_fee", "employer", "account_manager", "updated_date", "created_date" ] },
            ]
        }
    },

    placementList: //DONE
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'placement', get label(){ return t('table.placementList.groups.placement.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'placement', get label(){ return t('table.placementList.columns.title.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.title.tooltip.title') }, get description(){ return t('table.placementList.columns.title.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'title_asc', desc: 'title_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'name', get title() { return t('common.export.columns.employeeName') }, data: ( item, ctx ) => { return item?.employee?.name } },
                            { id: 'type', get title() { return t('common.export.columns.employmentType') }, data: ( item, ctx ) => { return item?.employment?.type } },
                        ]
                    }
                },
                {
                    id      : 'reference', group: 'placement', get label(){ return t('table.placementList.columns.reference.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.reference.tooltip.title') }, get description(){ return t('table.placementList.columns.reference.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'reference', get title() { return t('common.export.columns.reference') }, data: ( item, ctx ) => { return item?.jobReference } }
                        ]
                    }
                },
                {
                    id      : 'phone', group: 'placement', get label(){ return t('table.placementList.columns.phone.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.phone.tooltip.title') }, description: '' },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'phone', get title() { return t('common.export.columns.phone') }, data: ( item, ctx ) => { return item?.candidate?.phone } }
                        ]
                    }
                },
                {
                    id      : 'email', group: 'placement', get label(){ return t('table.placementList.columns.email.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.email.tooltip.title') }, description: '' },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'phone', get title() { return t('common.export.columns.email') }, data: ( item, ctx ) => { return item?.candidate?.email } }
                        ]
                    }
                },
                {
                    id      : 'nationality', group: 'placement', get label(){ return t('table.placementList.columns.nationality.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.nationality.tooltip.title') }, description: '' },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'nationality', get title() { return t('common.export.columns.nationality') }, data: ( item, ctx ) => { return item?.candidate?.nationality } }
                        ]
                    }
                },
                {
                    id      : 'sponsorship', group: 'placement', get label(){ return t('table.placementList.columns.sponsorship.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.sponsorship.tooltip.title') }, description: '' },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'sponsorship', get title() { return t('common.export.columns.sponsorshipRequired') }, data: ( item, ctx ) => { return item?.candidate?.sponsorship } }
                        ]
                    }
                },
                {
                    id      : 'duration', group: 'placement', get label(){ return t('table.placementList.columns.duration.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.duration.tooltip.title') }, description: '' },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'duration_value', get title() { return t('common.export.columns.jobDurationValue') }, data: ( item, ctx ) => { return item?.job.employment?.duration?.value } },
                            { id: 'duration_unit', get title() { return t('common.export.columns.jobDurationUnit') }, data: ( item, ctx ) => { return item?.job.employment.duration?.unit } }
                        ]
                    }
                },
                {
                    id      : 'status', group: 'placement', get label(){ return t('table.placementList.columns.status.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.status.tooltip.title') }, get description(){ return t('table.placementList.columns.status.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'status_asc', desc: 'status_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'status', get title() { return t('common.export.columns.status') }, data: ( item, ctx ) => { return item?.status } }
                        ]
                    }
                },
                {
                    id      : 'job', group: 'placement', get label(){ return t('table.placementList.columns.job.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.job.tooltip.title') }, get description(){ return t('table.placementList.columns.job.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'job_asc', desc: 'job_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'job', get title() { return t('common.export.columns.jobRequisition') }, data: ( item, ctx ) => { return item?.title } }
                        ]
                    }
                },
                {
                    id      : 'category', group: 'placement', get label(){ return t('table.placementList.columns.category.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.category.tooltip.title') }, get description(){ return t('table.placementList.columns.category.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'category_asc', desc: 'category_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'category', get title() { return t('common.export.columns.category') }, data: ( item, ctx ) => { return item?.category?.label } }
                        ]
                    }
                },
                {
                    id      : 'skills', group: 'placement', get label(){ return t('table.placementList.columns.skills.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.skills.tooltip.title') }, get description(){ return t('table.placementList.columns.skills.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'skills_asc', desc: 'skills_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'skills', get title() { return t('common.export.columns.skills') }, data: ( item, ctx ) => { return item?.skills?.map( s => s.label )?.join(', ') } }
                        ]
                    }
                },
                {
                    id      : 'location', group: 'placement', get label(){ return t('table.placementList.columns.location.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.location.tooltip.title') }, get description(){ return t('table.placementList.columns.location.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'location_asc', desc: 'location_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'location', get title() { return t('common.export.columns.location') }, data: ( item, ctx ) => { return item?.location?.name } }
                        ]
                    }
                },
                {
                    id      : 'candidate_location', group: 'placement', get label(){ return t('table.placementList.columns.candidate_location.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.candidate_location.tooltip.title') }, description: '' },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'locations_asc', desc: 'locations_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'location_name', get title() { return t('common.export.columns.residenceLocationName') }, data: ( item, ctx ) => { return item?.employee?.location?.name } },
                            { id: 'location_address', get title() { return t('common.export.columns.residenceLocationAddress') }, data: ( item, ctx ) => { return item?.employee?.location?.snippet?.address } }
                        ]
                    }
                },
                {
                    id      : 'work_mode', group: 'placement', get label(){ return t('table.placementList.columns.work_mode.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.work_mode.tooltip.title') }, get description(){ return t('table.placementList.columns.work_mode.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'remoteWork_asc', desc: 'remoteWork_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'work_mode', get title() { return t('common.export.columns.workType') }, data: ( item, ctx ) => { return item?.workMode } }
                        ]
                    }
                },
                {
                    id      : 'programme', group: 'placement', get label(){ return t('table.placementList.columns.programme.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.programme.tooltip.title') }, get description(){ return t('table.placementList.columns.programme.tooltip.description') } },
                    scope   : [ 'admin', 'employer' ],
                    //sort   : { asc: 'programme_asc', desc: 'programme_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'programme', get title() { return t('common.export.columns.program') }, data: ( item, ctx ) => { return item?.programme?.title } },
                            { id: 'programme_location', get title() { return t('common.export.columns.programLocation') }, data: ( item, ctx ) => { return item?.programmeLocation?.title } }
                        ]
                    }
                },
                {
                    id      : 'confidential_role', group: 'job', get label(){ return t('table.placementList.columns.confidential_role.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.confidential_role.tooltip.title') }, get description(){ return t('table.placementList.columns.confidential_role.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'confidentialRole_asc', desc: 'confidentialRole_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'confidential_role', get title() { return t('common.export.columns.confidentialRole') }, data: ( item, ctx ) => { return item?.confidential ? 'Yes' : 'No' } }
                        ]
                    }
                },
                {
                    id      : 'recruiter', group: 'placement', get label(){ return t('table.placementList.columns.recruiter.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.recruiter.tooltip.title') }, get description(){ return t('table.placementList.columns.recruiter.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'recruiter_asc', desc: 'recruiter_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'recruiter', get title() { return t('common.export.columns.agency') }, data: ( item, ctx ) => { return item?.recruiter?.organization?.name } },
                            { id: 'recruiter_user', get title() { return t('common.export.columns.agencyUser') }, data: ( item, ctx ) => { return item?.recruiter?.name } },
                        ]
                    }
                },
                {
                    id      : 'employer', group: 'placement', get label(){ return t('table.placementList.columns.employer.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.employer.tooltip.title') }, get description(){ return t('table.placementList.columns.employer.tooltip.description') } },
                    scope   : [ 'admin', 'recruiter', 'recruiter' ],
                    //sort   : { asc: 'employer_asc', desc: 'employer_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'employer', get title() { return t('common.export.columns.jobManager') }, data: ( item, ctx ) => { return item?.employers?.[0]?.name } },
                            { id: 'employer_organization', get title() { return t('common.export.columns.jobManagerOrganization') }, data: ( item, ctx ) => { return item?.employers?.[0]?.organization?.name } },
                        ]
                    }
                },
                {
                    id      : 'account_manager', group: 'placement', get label(){ return t('table.placementList.columns.account_manager.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.account_manager.tooltip.title') }, get description(){ return t('table.placementList.columns.account_manager.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'accountManager_asc', desc: 'accountManager_desc' },
                    export :
                    {
                        columns:
                        [
                            { id: 'account_manager', get title() { return t('common.export.columns.accountManager') }, data: ( item, ctx ) => { return item?.contacts?.accountManagers?.[0]?.name } },
                            { id: 'account_manager_organization', get title() { return t('common.export.columns.accountManagerOrganization') }, data: ( item, ctx ) => { return item?.contacts?.accountManagers?.[0]?.organization?.name } },
                        ]
                    }
                },
                {
                    id      : 'salary', group: 'placement', get label(){ return t('table.placementList.columns.salary.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.salary.tooltip.title') }, get description(){ return t('table.placementList.columns.salary.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'salary_asc', desc: 'salary_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'salary', get title() { return t('common.export.columns.salaryRate') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.salary?.amount )
                                    {
                                        return Commercials.convertCurrency( item.summary.fees.salary.amount, item.summary.fees.salary.currency, ctx?.$defaultCurrency || item.summary.fees.salary.currency ).toFixed( 2 );
                                    }
                                }
                            },
                            {
                                id: 'salary_currency', get title() { return t('common.export.columns.currency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.salary?.amount )
                                    {
                                        return ( ctx?.$defaultCurrency || item.summary.fees.salary.currency );
                                    }
                                }
                            },
                            { id: 'salary_rate', get title() { return t('common.export.columns.salaryRateFrequency') }, data: ( item, ctx ) => { return item.summary.fees.salary.rate } },
                        ]
                    }
                },
                {
                    id      : 'recruitment_fee', group: 'placement', get label(){ return t('table.placementList.columns.recruitment_fee.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.recruitment_fee.tooltip.title') }, get description(){ return t('table.placementList.columns.recruitment_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'employer', 'recruiter' ],
                    //sort   : { asc: 'recruitmentFee_asc', desc: 'recruitmentFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'recruitment_fee', get title() { return t('common.export.columns.agencyFeeAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.amount.toFixed( 2 );
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_currency', get title() { return t('common.export.columns.agencyFeeCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.currency;
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_percentage', get title() { return t('common.export.columns.agencyFeeIn') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.markup;
                                    }
                                }
                            },
                        ]
                    }
                },
                {
                    id      : 'agency_recruitment_fee', group: 'placement', get label(){ return t('table.placementList.columns.agency_recruitment_fee.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.agency_recruitment_fee.tooltip.title') }, get description(){ return t('table.placementList.columns.agency_recruitment_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin' ],
                    //sort   : { asc: 'recruitmentFee_asc', desc: 'recruitmentFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'recruitment_fee', get title() { return t('common.export.columns.agencyFeeAmountAgency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.amount.toFixed( 2 );
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_currency', get title() { return t('common.export.columns.agencyFeeCurrencyAgency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.currency;
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_percentage', get title() { return t('common.export.columns.agencyFeeInAgency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.markup;
                                    }
                                }
                            },
                        ]
                    }
                },
                {
                    id      : 'employer_recruitment_fee', group: 'placement', get label(){ return t('table.placementList.columns.employer_recruitment_fee.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.employer_recruitment_fee.tooltip.title') }, get description(){ return t('table.placementList.columns.employer_recruitment_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin' ],
                    //sort   : { asc: 'recruitmentFee_asc', desc: 'recruitmentFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'recruitment_fee', get title() { return t('common.export.columns.agencyFeeAmountEmployer') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.amount.toFixed( 2 );
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_currency', get title() { return t('common.export.columns.agencyFeeCurrencyEmployer') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.currency;
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_percentage', get title() { return t('common.export.columns.agencyFeeInEmployer') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.markup;
                                    }
                                }
                            },
                        ]
                    }
                },
                {
                    id      : 'supplier_fee', group: 'placement', get label(){ return t('table.placementList.columns.supplier_fee.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.supplier_fee.tooltip.title') }, get description(){ return t('table.placementList.columns.supplier_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'recruiter' ],
                    //sort   : { asc: 'supplierFee_asc', desc: 'supplierFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'supplier_fee', get title() { return t('common.export.columns.rAMPHandlingFeeAgencyAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.agency?.amount?.amount )
                                    {
                                        return item.summary.fees.agency.amount.amount.toFixed( 2 );
                                    }
                                }
                            },
                            {
                                id: 'supplier_fee_currency', get title() { return t('common.export.columns.rAMPHandlingFeeAgencyCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.agency?.amount?.amount )
                                    {
                                        return item.summary.fees.agency.amount.currency;
                                    }
                                }
                            },
                            {
                                id: 'supplier_fee_percentage', get title() { return t('common.export.columns.rAMPHandlingFeeAgencyIn') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.agency?.amount?.amount )
                                    {
                                        return item.summary.fees.agency.amount.markup;
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'employer_fee', group: 'placement', get label(){ return t('table.placementList.columns.employer_fee.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.employer_fee.tooltip.title') }, get description(){ return t('table.placementList.columns.employer_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'employer' ],
                    //sort   : { asc: 'employerFee_asc', desc: 'employerFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'employer_fee', get title() { return t('common.export.columns.rAMPHandlingFeeEmployerAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.employer?.amount?.amount )
                                    {
                                        return item.summary.fees.employer.amount.amount.toFixed( 2 );
                                    }
                                }
                            },
                            {
                                id: 'employer_fee_currency', get title() { return t('common.export.columns.rAMPHandlingFeeEmployerCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.employer?.amount?.amount )
                                    {
                                        return item.summary.fees.employer.amount.currency;
                                    }
                                }
                            },
                            {
                                id: 'employer_fee_percentage', get title() { return t('common.export.columns.rAMPHandlingFeeEmployerIn') }, data: ( item, ctx ) =>
                                {
                                    if( item?.summary?.fees?.employer?.amount?.markup )
                                    {
                                        return item.summary.fees.employer.amount.markup;
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'rebate_period', group: 'placement', get label(){ return t('table.placementList.columns.rebate_period.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.rebate_period.tooltip.title') }, get description(){ return t('table.placementList.columns.rebate_period.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'rebatePeriod_asc', desc: 'rebatePeriod_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'rebate_period', get title() { return t('common.export.columns.rebatePeriod') }, data: ( item, ctx ) =>
                                {
                                    if( item?.summary?.rebate?.daysTillZero > 0 )
                                    {
                                        return `${ item.summary.rebate.daysTillZero } days left`;
                                    }
                                    else
                                    {
                                        return 'Expired';
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'employer_invoice', group: 'placement', get label(){ return t('table.placementList.columns.employer_invoice.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.employer_invoice.tooltip.title') }, get description(){ return t('table.placementList.columns.employer_invoice.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer' ],
                    //sort   : { asc: 'employerInvoice_asc', desc: 'employerInvoice_desc' },
                    export :
                    {
                        columns:
                        [
                            {
                                id: 'employer_invoice',get title() { return t('common.export.columns.employerInvoice') }, data: ( item, ctx ) => { return item?.summary?.invoices?.employer?.status; }
                            }
                        ]
                    }
                },
                /*
                {
                    id     : 'employer_billing_entity', group: 'placement', get label(){ return t('table.placementList.columns.employer_billing_entity.label') },
                    align  : 'center', tooltip: '<b>Hover</b> on any column to get <b>detailed info</b>!',
                    scope  : [ 'admin', 'employer' ],
                    //sort   : { asc: 'employerBillingEntity_asc', desc: 'employerBillingEntity_desc' },
                    export :
                    {
                        columns: [] // TODO
                    }
                },
                */
                {
                    id      : 'agency_invoice', group: 'placement', get label(){ return t('table.placementList.columns.agency_invoice.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.agency_invoice.tooltip.title') }, get description(){ return t('table.placementList.columns.agency_invoice.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'recruiter' ],
                    //sort   : { asc: 'agencyInvoice_asc', desc: 'agencyInvoice_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'agency_invoice', get title() { return t('common.export.columns.agencyInvoice') }, data: ( item, ctx ) => { return item?.summary?.invoices?.agency?.status } }
                        ]
                    }
                },
                {
                    id      : 'start_date', group: 'placement', get label(){ return t('table.placementList.columns.start_date.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.start_date.tooltip.title') }, get description(){ return t('table.placementList.columns.start_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'startDate_asc', desc: 'startDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'start_date', get title() { return t('common.export.columns.startDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.employment?.interval?.start )
                                    {
                                        return new Date( item.employment.interval.start ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'end_date', group: 'placement', get label(){ return t('table.placementList.columns.end_date.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.end_date.tooltip.title') }, get description(){ return t('table.placementList.columns.end_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'endDate_asc', desc: 'endDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'end_date', get title() { return t('common.export.columns.endDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.employment?.interval?.end )
                                    {
                                        return new Date( item.employment.interval.end ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'updated_date', group: 'placement', get label(){ return t('table.placementList.columns.updated_date.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.updated_date.tooltip.title') }, get description(){ return t('table.placementList.columns.updated_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'updatedDate_asc', desc: 'updatedDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'updated_date', get title() { return t('common.export.columns.updatedDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.updated )
                                    {
                                        return new Date( item.events.updated ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'created_date', group: 'placement', get label(){ return t('table.placementList.columns.created_date.label') },
                    tooltip : { get title(){ return t('table.placementList.columns.created_date.tooltip.title') }, get description(){ return t('table.placementList.columns.created_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'createdDate_asc', desc: 'createdDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'created_date', get title() { return t('common.export.columns.createdDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.created )
                                    {
                                        return new Date( item.events.created ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                }
            ],

            presets:
            [
                { id: 'admin', name: 'default', columns: [ "title", "status", "salary", "agency_recruitment_fee", "employer_recruitment_fee", "supplier_fee", "employer_fee", "employer_invoice", "agency_invoice", "recruiter", "created_date" ] },
                { id: 'employer', name: 'default', columns: [ "title", "status", "job", "salary", "recruitment_fee", "employer_fee", "recruiter", "employer_invoice", "rebate_period" ] },
                { id: 'recruiter', name: 'default', columns: [ "title", "status", "job", "salary", "recruitment_fee", "supplier_fee", "agency_invoice", "rebate_period" ] }
            ]
        }
    },

    contractList: //DONE
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'contract', get label(){ return t('table.contractList.groups.contract.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'contract', get label(){ return t('table.contractList.columns.title.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.title.tooltip.title') }, get description(){ return t('table.contractList.columns.title.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'title_asc', desc: 'title_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'title', get title() { return t('common.export.columns.worker') }, data: ( item, ctx ) => { return item?.contractor?.name } }
                        ]
                    }
                },
                {
                    id      : 'reference', group: 'contract', get label(){ return t('table.contractList.columns.reference.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.reference.tooltip.title') }, get description(){ return t('table.contractList.columns.reference.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'reference', get title() { return t('common.export.columns.reference') }, data: ( item, ctx ) => { return item?.jobReference } }
                        ]
                    }
                },
                {
                    id      : 'phone', group: 'contract', get label(){ return t('table.contractList.columns.phone.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.phone.tooltip.title') }, get description(){ return t('table.contractList.columns.phone.tooltip.description') } },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'phone', get title() { return t('common.export.columns.phone') }, data: ( item, ctx ) => { return item?.candidate?.phone } }
                        ]
                    }
                },
                {
                    id      : 'email', group: 'contract', get label(){ return t('table.contractList.columns.email.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.email.tooltip.title') }, get description(){ return t('table.contractList.columns.email.tooltip.description') } },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'phone', get title() { return t('common.export.columns.email') }, data: ( item, ctx ) => { return item?.candidate?.email } }
                        ]
                    }
                },
                {
                    id      : 'nationality', group: 'contract', get label(){ return t('table.contractList.columns.nationality.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.nationality.tooltip.title') }, get description(){ return t('table.contractList.columns.nationality.tooltip.description') } },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'nationality', get title() { return t('common.export.columns.nationality') }, data: ( item, ctx ) => { return item?.candidate?.nationality } }
                        ]
                    }
                },
                {
                    id      : 'sponsorship', group: 'contract', get label(){ return t('table.contractList.columns.sponsorship.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.sponsorship.tooltip.title') }, get description(){ return t('table.contractList.columns.sponsorship.tooltip.description') } },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'sponsorship', get title() { return t('common.export.columns.sponsorshipRequired') }, data: ( item, ctx ) => { return item?.candidate?.sponsorship } }
                        ]
                    }
                },
                {
                    id      : 'duration', group: 'contract', get label(){ return t('table.contractList.columns.duration.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.duration.tooltip.title') }, get description(){ return t('table.contractList.columns.duration.tooltip.description') } },
                    align   : 'left',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort    : { asc: 'reference_asc', desc: 'reference_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'duration_value', get title() { return t('common.export.columns.jobDurationValue') }, data: ( item, ctx ) => { return item?.job.employment?.duration?.value } },
                            { id: 'duration_unit', get title() { return t('common.export.columns.jobDurationUnit') }, data: ( item, ctx ) => { return item?.job.employment.duration?.unit } }
                        ]
                    }
                },
                {
                    id      : 'status', group: 'contract', get label(){ return t('table.contractList.columns.status.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.status.tooltip.title') }, get description(){ return t('table.contractList.columns.status.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'status_asc', desc: 'status_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'status', get title() { return t('common.export.columns.status') }, data: ( item, ctx ) => { return item?.status?.capitalize() } }
                        ]
                    }
                },
                {
                    id      : 'job', group: 'contract', get label(){ return t('table.contractList.columns.job.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.job.tooltip.title') }, get description(){ return t('table.contractList.columns.job.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'job_asc', desc: 'job_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'job', get title() { return t('common.export.columns.jobRequisition') }, data: ( item, ctx ) => { return item?.title } }
                        ]
                    }
                },
                {
                    id      : 'category', group: 'contract', get label(){ return t('table.contractList.columns.category.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.category.tooltip.title') }, get description(){ return t('table.contractList.columns.category.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'category_asc', desc: 'category_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'category', get title() { return t('common.export.columns.category') }, data: ( item, ctx ) => { return item?.category?.label } }
                        ]
                    }
                },
                {
                    id      : 'skills', group: 'contract', get label(){ return t('table.contractList.columns.skills.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.skills.tooltip.title') }, get description(){ return t('table.contractList.columns.skills.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'skills_asc', desc: 'skills_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'skills', get title() { return t('common.export.columns.skills') }, data: ( item, ctx ) => { return item?.skills?.map( skill => skill.label ).join(', ') } }
                        ]
                    }
                },
                {
                    id      : 'location', group: 'contract', get label(){ return t('table.contractList.columns.location.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.location.tooltip.title') }, get description(){ return t('table.contractList.columns.location.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'location_asc', desc: 'location_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'location',  get title() { return t('common.export.columns.jobLocation') }, data: ( item, ctx ) => { return item?.location?.name } }
                        ]
                    }
                },
                {
                    id      : 'candidate_location', group: 'contract', get label(){ return t('table.contractList.columns.candidate_location.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.candidate_location.tooltip.title') }, get description(){ return t('table.contractList.columns.candidate_location.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'locations_asc', desc: 'locations_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'location_name', get title() { return t('common.export.columns.residenceLocationName') }, data: ( item, ctx ) => { return item?.contractor?.location?.name } },
                            { id: 'location_address', get title() { return t('common.export.columns.residenceLocationAddress') }, data: ( item, ctx ) => { return item?.contractor?.location?.snippet?.address } }
                        ]
                    }
                },
                {
                    id      : 'work_mode', group: 'contract', get label(){ return t('table.contractList.columns.work_mode.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.work_mode.tooltip.title') }, get description(){ return t('table.contractList.columns.work_mode.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'remoteWork_asc', desc: 'remoteWork_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'work_mode', get title() { return t('common.export.columns.workType') }, data: ( item, ctx ) => { return item.workMode } }
                        ]
                    }
                },
                {
                    id      : 'confidential_role', group: 'job', get label(){ return t('table.contractList.columns.confidential_role.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.confidential_role.tooltip.title') }, get description(){ return t('table.contractList.columns.confidential_role.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'confidentialRole_asc', desc: 'confidentialRole_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'confidential_role', get title() { return t('common.export.columns.confidentialRole') }, data: ( item, ctx ) => { return item?.confidential ? 'Yes' : 'No' } }
                        ]
                    }
                },
                {
                    id      : 'programme', group: 'contract', get label(){ return t('table.contractList.columns.programme.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.programme.tooltip.title') }, get description(){ return t('table.contractList.columns.programme.tooltip.description') } },
                    scope   : [ 'admin', 'employer' ],
                    //sort   : { asc: 'programme_asc', desc: 'programme_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'programme', get title() { return t('common.export.columns.program') }, data: ( item, ctx ) => { return item?.programme?.title } },
                            { id: 'programme_location', get title() { return t('common.export.columns.programLocation') }, data: ( item, ctx ) => { return item?.programmeLocation?.title } }
                        ]
                    }
                },
                {
                    id      : 'recruiter', group: 'contract', get label(){ return t('table.contractList.columns.recruiter.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.recruiter.tooltip.title') }, get description(){ return t('table.contractList.columns.recruiter.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'recruiter_asc', desc: 'recruiter_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'recruiter', get title() { return t('common.export.columns.agency') }, data: ( item, ctx ) => { return item?.recruiter?.organization?.name } },
                            { id: 'recruiter_user', get title() { return t('common.export.columns.agencyUser') }, data: ( item, ctx ) => { return item?.recruiter?.name } },
                        ]
                    }
                },
                {
                    id      : 'employer', group: 'contract', get label(){ return t('table.contractList.columns.employer.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.employer.tooltip.title') }, get description(){ return t('table.contractList.columns.employer.tooltip.description') } },
                    scope   : [ 'admin', 'recruiter', 'recruiter' ],
                    //sort   : { asc: 'employer_asc', desc: 'employer_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'employer', get title() { return t('common.export.columns.jobManager') }, data: ( item, ctx ) => { return item?.employers?.[0]?.name } },
                            { id: 'employer_organization', get title() { return t('common.export.columns.jobManagerOrganization') }, data: ( item, ctx ) => { return item?.employers?.[0]?.organization?.name } },
                        ]
                    }
                },
                {
                    id      : 'account_manager', group: 'contract', get label(){ return t('table.contractList.columns.account_manager.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.account_manager.tooltip.title') }, get description(){ return t('table.contractList.columns.account_manager.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'accountManager_asc', desc: 'accountManager_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'account_manager', get title() { return t('common.export.columns.accountManager') }, data: ( item, ctx ) => { return item?.contacts?.accountManagers?.[0]?.name } },
                            { id: 'account_manager_organization', get title() { return t('common.export.columns.accountManagerOrganization') }, data: ( item, ctx ) => { return item?.contacts?.accountManagers?.[0]?.organization?.name } }
                        ]
                    }
                },
                {
                    id      : 'hiring_manager', group: 'contract', get label(){ return t('table.contractList.columns.hiring_manager.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.hiring_manager.tooltip.title') }, get description(){ return t('table.contractList.columns.hiring_manager.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'accountManager_asc', desc: 'accountManager_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'hiring_manager', get title() { return t('common.export.columns.hiringManager') }, data: ( item, ctx ) => { return item?.contacts?.hiringManager } }
                        ]
                    }
                },
                {
                    id      : 'approved_by', group: 'contract', get label(){ return t('table.contractList.columns.approved_by.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.approved_by.tooltip.title') }, get description(){ return t('table.contractList.columns.approved_by.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'accountManager_asc', desc: 'accountManager_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'approved_by', get title() { return t('common.export.columns.approvedBy') }, data: ( item, ctx ) => { return item?.contacts?.approverAccount?.name } }
                        ]
                    }
                },
                {
                    id      : 'billing_entity', group: 'contract', get label(){ return t('table.contractList.columns.billing_entity.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.billing_entity.tooltip.title') }, get description(){ return t('table.contractList.columns.billing_entity.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'accountManager_asc', desc: 'accountManager_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'billing_entity', get title() { return t('common.export.columns.billingEntity') }, data: ( item, ctx ) => { return item?.billingEntity?.name } }
                        ]
                    }
                },
                {
                    id      : 'salary', group: 'contract', get label(){ return t('table.contractList.columns.salary.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.salary.tooltip.title') }, get description(){ return t('table.contractList.columns.salary.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'salary_asc', desc: 'salary_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'salary', get title() { return t('common.export.columns.billRate') }, data: ( item, ctx ) =>
                                {
                                    if( item.employment?.salary?.amount )
                                    {
                                        return Commercials.convertCurrency( item.employment.salary.amount, item.employment.salary.currency, ctx?.$defaultCurrency || item.employment.salary.currency ).toFixed( 2 );
                                    }
                                }
                            },
                            {
                                id: 'salary_currency', get title() { return t('common.export.columns.billRateCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item.employment?.salary?.amount )
                                    {
                                        return ( ctx?.$defaultCurrency || item.employment.salary.currency );
                                    }
                                }
                            },
                            {
                                id: 'salary_rate', get title() { return t('common.export.columns.billRateFrequency') }, data: ( item, ctx ) =>
                                {
                                    if( item?.employment?.salary?.rate )
                                    {
                                        return item.employment.salary.rate;
                                    }
                                }
                            }
                        ]
                    }
                },

                {
                    id      : 'recruitment_fee', group: 'contract', get label(){ return t('table.contractList.columns.recruitment_fee.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.recruitment_fee.tooltip.title') }, get description(){ return t('table.contractList.columns.recruitment_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'recruitmentFee_asc', desc: 'recruitmentFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'recruitment_fee', get title() { return t('common.export.columns.agencyFeeMSPAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.msp?.agency.fee.amount.amount )
                                    {
                                        return item.summary?.fees?.msp?.agency.fee.amount.amount.toFixed(2);
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_currency', get title() { return t('common.export.columns.agencyFeeMSPCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.msp?.agency.fee.amount.currency )
                                    {
                                        return item.summary?.fees?.msp?.agency.fee.amount.currency;
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_percentage', get title() { return t('common.export.columns.agencyFeeMSPIn') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.msp?.agency.fee.amount.margin )
                                    {
                                        return item.summary?.fees?.msp?.agency.fee.amount.margin;
                                    }
                                }
                            },
                        ]
                    }
                },
                {
                    id      : 'recruitment_rate', group: 'contract', get label(){ return t('table.contractList.columns.recruitment_rate.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.recruitment_rate.tooltip.title') }, get description(){ return t('table.contractList.columns.recruitment_rate.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'recruitmentFee_asc', desc: 'recruitmentFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'recruitment_rate', get title() { return t('common.export.columns.agencyRateMSPAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.msp?.agency.salary )
                                    {
                                        return item.summary?.fees?.msp?.agency.salary
                                    }
                                }
                            },
                            {
                                id: 'recruitment_rate_currency', get title() { return t('common.export.columns.agencyRateMSPCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.msp?.agency.fee.amount.currency )
                                    {
                                        return item.summary?.fees?.msp?.agency.fee.amount.currency;
                                    }
                                }
                            },
                            {
                                id: 'recruitment_rate_percentage', get title() { return t('common.export.columns.agencyRateMSPIn') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.msp?.agency.fee.amount.margin )
                                    {
                                        return item.summary?.fees?.msp?.agency.fee.amount.margin;
                                    }
                                }
                            },
                        ]
                    }
                },

                {
                    id      : 'employer_fee', group: 'contract', get label(){ return t('table.contractList.columns.employer_fee.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.employer_fee.tooltip.title') }, get description(){ return t('table.contractList.columns.employer_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'recruitmentFee_asc', desc: 'recruitmentFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'employer_fee', get title() { return t('common.export.columns.employerFeeMSPAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.msp?.employer.fee.amount.amount )
                                    {
                                        return item.summary?.fees?.msp?.employer.fee.amount.amount.toFixed(2);
                                    }
                                }
                            },
                            {
                                id: 'employer_fee_currency', get title() { return t('common.export.columns.employerFeeMSPCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.msp?.employer.fee.amount.currency )
                                    {
                                        return item.summary?.fees?.msp?.employer.fee.amount.currency;
                                    }
                                }
                            },
                            {
                                id: 'employer_fee_percentage', get title() { return t('common.export.columns.employerFeeMSPIn') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.msp?.employer.fee.amount.markup )
                                    {
                                        return item.summary?.fees?.msp?.employer.fee.amount.markup;
                                    }
                                }
                            },
                        ]
                    }
                },
                {
                    id      : 'employer_rate', group: 'contract', get label(){ return t('table.contractList.columns.employer_rate.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.employer_rate.tooltip.title') }, get description(){ return t('table.contractList.columns.employer_rate.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'recruitmentFee_asc', desc: 'recruitmentFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'employer_rate', get title() { return t('common.export.columns.employerRateMSPAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.msp?.employer.salary )
                                    {
                                        return item.summary?.fees?.msp?.employer.salary
                                    }
                                }
                            },
                            {
                                id: 'employer_rate_currency', get title() { return t('common.export.columns.employerRateMSPCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.msp?.employer.fee.amount.currency )
                                    {
                                        return item.summary?.fees?.msp?.employer.fee.amount.currency;
                                    }
                                }
                            },
                            {
                                id: 'employer_rate_percentage', get title() { return t('common.export.columns.employerRateMSPIn') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.msp?.employer.fee.amount.markup )
                                    {
                                        return item.summary?.fees?.msp?.employer.fee.amount.markup;
                                    }
                                }
                            }
                        ]
                    }
                },

                /*
                {
                    id      : 'agency_recruitment_fee', group: 'contract', get label(){ return t('table.contractList.columns.agency_recruitment_fee.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.agency_recruitment_fee.tooltip.title') }, get description(){ return t('table.contractList.columns.agency_recruitment_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin' ],
                    //sort   : { asc: 'recruitmentFee_asc', desc: 'recruitmentFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'agencyRecruitment_fee', get title() { return t('common.export.columns.agencyFeeAmountAgency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.agencyRecruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.agencyRecruitment.amount.amount.toFixed(2);
                                    }
                                }
                            },
                            {
                                id: 'agencyRecruitment_fee_currency', get title() { return t('common.export.columns.agencyFeeCurrencyAgency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.agencyRecruitment?.amount?.amount )
                                    {
                                        return  item.summary.fees.agencyRecruitment.amount.currency;
                                    }
                                }
                            },
                            {
                                id: 'agencyRecruitment_fee_percentage', get title() { return t('common.export.columns.agencyFeeInAgency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.agencyRecruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.agencyRecruitment.amount.markup;
                                    }
                                }
                            },
                        ]
                    }
                },
                {
                    id      : 'employer_recruitment_fee', group: 'contract', get label(){ return t('table.contractList.columns.employer_recruitment_fee.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.employer_recruitment_fee.tooltip.title') }, get description(){ return t('table.contractList.columns.employer_recruitment_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin' ],
                    //sort   : { asc: 'recruitmentFee_asc', desc: 'recruitmentFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'recruitment_fee', get title() { return t('common.export.columns.agencyFeeAmountEmployer') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.amount.toFixed(2);
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_currency', get title() { return t('common.export.columns.agencyFeeCurrencyEmployer') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.currency;
                                    }
                                }
                            },
                            {
                                id: 'recruitment_fee_percentage', get title() { return t('common.export.columns.agencyFeeInEmployer') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.recruitment?.amount?.amount )
                                    {
                                        return item.summary.fees.recruitment.amount.markup;
                                    }
                                }
                            },
                        ]
                    }
                },
                {
                    id      : 'supplier_fee', group: 'contract', get label(){ return t('table.contractList.columns.supplier_fee.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.supplier_fee.tooltip.title') }, get description(){ return t('table.contractList.columns.supplier_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'recruiter' ],
                    //sort   : { asc: 'supplierFee_asc', desc: 'supplierFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'supplier_fee', get title() { return t('common.export.columns.agencyHandlingFeeAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.agency?.amount?.amount )
                                    {
                                        return item.summary.fees.agency.amount.amount.toFixed(2);
                                    }
                                }
                            },
                            {
                                id: 'supplier_fee_currency', get title() { return t('common.export.columns.agencyHandlingFeeCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.agency?.amount?.amount )
                                    {
                                        return item.summary.fees.agency.amount.currency;
                                    }
                                }
                            },
                            {
                                id: 'supplier_fee_percentage', get title() { return t('common.export.columns.agencyHandlingFeeIn') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.agency?.amount?.amount )
                                    {
                                        return item.summary.fees.agency.amount.markup;
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'employer_fee', group: 'contract', get label(){ return t('table.contractList.columns.employer_fee.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.employer_fee.tooltip.title') }, get description(){ return t('table.contractList.columns.employer_fee.tooltip.description') } },
                    align   : 'right',
                    scope   : [ 'admin', 'employer' ],
                    //sort   : { asc: 'employerFee_asc', desc: 'employerFee_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'employer_fee', get title() { return t('common.export.columns.employerHandlingFeeAmount') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.employer?.amount?.amount )
                                    {
                                        return item.summary.fees.employer.amount.amount.toFixed(2);
                                    }
                                }
                            },
                            {
                                id: 'employer_fee_currency', get title() { return t('common.export.columns.employerHandlingFeeCurrency') }, data: ( item, ctx ) =>
                                {
                                    if( item.summary?.fees?.employer?.amount?.amount )
                                    {
                                        return item.summary.fees.employer.amount.currency;
                                    }
                                }
                            },
                            {
                                id: 'employer_fee_percentage', get title() { return t('common.export.columns.employerHandlingFeeIn') }, data: ( item, ctx ) =>
                                {
                                    if( item?.summary?.fees?.employer?.amount?.markup )
                                    {
                                        return item.summary.fees.employer.amount.markup;
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id     : 'employer_billing_entity', group: 'placement', get label(){ return t('table.contractList.columns.employer_billing_entity.label') },
                    tooltip: '<b>Hover</b> on any column to get <b>detailed info</b>!',
                    scope  : [ 'admin', 'employer' ],
                    //sort   : { asc: 'employerBillingEntity_asc', desc: 'employerBillingEntity_desc' },
                    export :
                    {
                        columns: [] // TODO
                    }
                },
                {
                    id     : 'invoices', group: 'contract', get label(){ return t('table.contractList.columns.invoices.label') },
                    tooltip: '<b>Hover</b> on any column to get <b>detailed info</b>!',
                    scope  : [ 'admin', 'employer', 'recruiter' ],
                    //sort   : { asc: 'invoices_asc', desc: 'invoices_desc' },
                    export :
                    {
                        columns:
                        [
                            { id: 'invoices', get title() { return t('common.export.columns.invoices') }, data: ( item, ctx ) => { return item?.invoices?.length } }
                        ]
                    }
                },
                */
                {
                    id      : 'documents', group: 'contract', get label(){ return t('table.contractList.columns.documents.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.documents.tooltip.title') }, get description(){ return t('table.contractList.columns.documents.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'documents_asc', desc: 'documents_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'documents', get title() { return t('common.export.columns.documents') }, data: ( item, ctx ) => { return item?.documents?.length } }
                        ]
                    }
                },
                {
                    id      : 'assignment_type', group: 'contract', get label(){ return t('table.contractList.columns.assignment_type.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.assignment_type.tooltip.title') }, get description(){ return t('table.contractList.columns.assignment_type.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'assignment_type_asc', desc: 'assignment_type_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'assignment_type', get title() { return t('common.export.columns.assignmentType') }, data: ( item, ctx ) => { return item?.employment?.extension ? 'Extension' : 'New' } }
                        ]
                    }
                },
                {
                    id      : 'start_date', group: 'contract', get label(){ return t('table.contractList.columns.start_date.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.start_date.tooltip.title') }, get description(){ return t('table.contractList.columns.start_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'startDate_asc', desc: 'startDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'start_date', get title() { return t('common.export.columns.startDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.employment?.interval?.start )
                                    {
                                        return new Date( item.employment.interval.start ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'end_date', group: 'contract', get label(){ return t('table.contractList.columns.end_date.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.end_date.tooltip.title') }, get description(){ return t('table.contractList.columns.end_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'endDate_asc', desc: 'endDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'end_date', get title() { return t('common.export.columns.endDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.employment?.interval?.end )
                                    {
                                        return new Date( item.employment.interval.end ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'updated_date', group: 'contract', get label(){ return t('table.contractList.columns.updated_date.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.updated_date.tooltip.title') }, get description(){ return t('table.contractList.columns.updated_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'updatedDate_asc', desc: 'updatedDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'updated_date', get title() { return t('common.export.columns.updatedDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.updated )
                                    {
                                        return new Date( item.events.updated ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'created_date', group: 'contract', get label(){ return t('table.contractList.columns.created_date.label') },
                    tooltip : { get title(){ return t('table.contractList.columns.created_date.tooltip.title') }, get description(){ return t('table.contractList.columns.created_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'createdDate_asc', desc: 'createdDate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'created_date', get title() { return t('common.export.columns.createdDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.created )
                                    {
                                        return new Date( item.events.created ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                }
            ],

            presets:
            [
                { id: 'admin', name: 'default', columns: [ "title", "status", "candidate_location", "salary", "recruitment_fee", "recruitment_rate", "employer_fee", "employer_rate", "recruiter", "documents", "assignment_type", "start_date", "end_date" ] },
                { id: 'employer', name: 'default', columns: [ "title", "status", "candidate_location", "salary", "recruitment_fee", "recruitment_rate", "employer_fee", "employer_rate", "documents", "assignment_type", "recruiter", "start_date", "end_date" ] },
                { id: 'recruiter', name: 'default', columns: [ "title", "status", "salary", "recruitment_fee", "recruitment_rate", "employer_fee", "employer_rate", "documents", "assignment_type", "start_date", "end_date" ] }
            ]
        }
    },

    timesheetList: //DONE
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'timesheet', get label(){ return t('table.timesheetList.groups.timesheet.label') } },
            ],

            columns:
            [
                {
                    id      : 'interval', group: 'timesheet', get label(){ return t('table.timesheetList.columns.interval.label') },
                    tooltip : { get title(){ return t('table.timesheetList.columns.interval.tooltip.title') }, get description(){ return t('table.timesheetList.columns.interval.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'interval', get title() { return t('common.export.columns.interval') }, data: ( item, ctx ) => { return `${ new Date( item.interval.start ).toUTCDate() } - ${ new Date( item.interval.end ).toUTCDate() }`; } }
                        ]
                    }
                },
                {
                    id      : 'duration', group: 'timesheet', get label(){ return t('table.timesheetList.columns.duration.label') },
                    tooltip : { get title(){ return t('table.timesheetList.columns.duration.tooltip.title') }, get description(){ return t('table.timesheetList.columns.duration.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'duration', get title() { return t('common.export.columns.duration') }, data: ( item, ctx ) => { return `${item.duration.value} ${item.duration.unit}`; } }
                        ]
                    }
                },
                {
                    id      : 'rate', group: 'timesheet', get label(){ return t('table.timesheetList.columns.rate.label') },
                    tooltip : { get title(){ return t('table.timesheetList.columns.rate.tooltip.title') }, get description(){ return t('table.timesheetList.columns.rate.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'rate', get title() { return t('common.export.columns.rate') }, data: ( item, ctx ) => { return Commercials.convertCurrency( item.salary / item.duration.value, ctx.Detail.employment.salary.currency, ctx?.$defaultCurrency || ctx.Detail.employment.salary.currency ).toFixed( 2 ); } },
                            { id: 'rate_currency', get title() { return t('common.export.columns.rateCurrency') }, data: ( item, ctx ) => { return ( ctx?.$defaultCurrency || ctx.Detail.employment.salary.currency ); } }
                        ]
                    }
                },
                {
                    id      : 'salary', group: 'timesheet', get label(){ return t('table.timesheetList.columns.salary.label') },
                    tooltip : { get title(){ return t('table.timesheetList.columns.salary.tooltip.title') }, get description(){ return t('table.timesheetList.columns.salary.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'salary', get title() { return t('common.export.columns.totalBilledAmount') }, data: ( item, ctx ) => { return Commercials.convertCurrency( item.salary, ctx.Detail.employment.salary.currency, ctx?.$defaultCurrency || ctx.Detail.employment.salary.currency ).toFixed( 2 ) } },
                            { id: 'salary_currency', get title() { return t('common.export.columns.totalBilledCurrency') }, data: ( item, ctx ) => { return ( ctx?.$defaultCurrency || ctx.Detail.employment.salary.currency ) } },
                        ]
                    }
                }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'interval', 'duration', 'rate', 'salary' ] }
            ]
        }
    },

    documentList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'document', get label(){ return t('table.documentList.groups.document.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'document', get label(){ return t('table.documentList.columns.title.label') },
                    tooltip : { get title(){ return t('table.documentList.columns.title.tooltip.title') }, get description(){ return t('table.documentList.columns.title.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'title', get title() { return t('common.export.columns.name') }, data: ( item, ctx ) => { return item?.title; } }
                        ]
                    }
                },
                {
                    id      : 'status', group: 'document', get label(){ return t('table.documentList.columns.status.label') },
                    tooltip : { get title(){ return t('table.documentList.columns.status.tooltip.title') }, get description(){ return t('table.documentList.columns.status.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'status', get title() { return t('common.export.columns.status') }, data: ( item, ctx ) => { return 'TODO'; } }
                        ]
                    }
                },
                {
                    id      : 'type', group: 'document', get label(){ return t('table.documentList.columns.type.label') },
                    tooltip : { get title(){ return t('table.documentList.columns.type.tooltip.title') }, get description(){ return t('table.documentList.columns.type.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'type', get title() { return t('common.export.columns.fileType') }, data: ( item, ctx ) => { return item.type; } },
                        ]
                    }
                },
                {
                    id      : 'signatories', group: 'document', get label(){ return t('table.documentList.columns.signatories.label') },
                    tooltip : { get title(){ return t('table.documentList.columns.signatories.tooltip.title') }, get description(){ return t('table.documentList.columns.signatories.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'signatories', get title() { return t('common.export.columns.signatories') }, data: ( item, ctx ) => { return 'TODO' } }
                        ]
                    }
                },
                {
                    id      : 'relations', group: 'document', get label(){ return t('table.documentList.columns.relations.label') },
                    tooltip : { get title(){ return t('table.documentList.columns.relations.tooltip.title') }, get description(){ return t('table.documentList.columns.relations.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'relations', get title() { return t('common.export.columns.relations') }, data: ( item, ctx ) => { return 'TODO' } }
                        ]
                    }
                },
                {
                    id      : 'author', group: 'document', get label(){ return t('table.documentList.columns.author.label') },
                    tooltip : { get title(){ return t('table.documentList.columns.author.tooltip.title') }, get description(){ return t('table.documentList.columns.author.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'size', get title() { return t('common.export.columns.uploaderName') }, data: ( item, ctx ) => { return item?.uploaderAccount?.name; } },
                            { id: 'mime', get title() { return t('common.export.columns.uploaderCompany') }, data: ( item, ctx ) => { return item?.uploaderAccount?.organization?.name; } }
                        ]
                    }
                },
                {
                    id      : 'version', group: 'document', get label(){ return t('table.documentList.columns.version.label') },
                    tooltip : { get title(){ return t('table.documentList.columns.version.tooltip.title') }, get description(){ return t('table.documentList.columns.version.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'version', get title() { return t('common.export.columns.version') }, data: ( item, ctx ) => { return 'TODO' } }
                        ]
                    }
                },
                {
                    id      : 'size', group: 'document', get label(){ return t('table.documentList.columns.size.label') },
                    tooltip : { get title(){ return t('table.documentList.columns.size.tooltip.title') }, get description(){ return t('table.documentList.columns.size.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'size', get title() { return t('common.export.columns.fileSize') }, data: ( item, ctx ) => { return Format.fileSize( item?.size, true ); } },
                            { id: 'mime', get title() { return t('common.export.columns.mimeType') }, data: ( item, ctx ) => { return item?.mime } }
                        ]
                    }
                },
                {
                    id      : 'expiry_date', group: 'document', get label(){ return t('table.documentList.columns.expiry_date.label') },
                    tooltip : { get title(){ return t('table.documentList.columns.expiry_date.tooltip.title') }, get description(){ return t('table.documentList.columns.expiry_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'expiry_date', get title() { return t('common.export.columns.expiryDate') }, data: ( item, ctx ) =>
                                {
                                    return 'TODO'
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'created_date', group: 'document', get label(){ return t('table.documentList.columns.created_date.label') },
                    tooltip : { get title(){ return t('table.documentList.columns.created_date.tooltip.title') }, get description(){ return t('table.documentList.columns.created_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'created_date', get title() { return t('common.export.columns.createdDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.created )
                                    {
                                        return new Date( item.events.created ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                },
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'title', 'status', 'type', 'author', 'version', 'size', 'expiry_date', 'created_date' ] }
            ]
        }
    },

    invoiceList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'invoice', get label(){ return t('table.invoiceList.groups.invoice.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'invoice', get label(){ return t('table.invoiceList.columns.title.label') },
                    tooltip : { get title(){ return t('table.invoiceList.columns.title.tooltip.title') }, get description(){ return t('table.invoiceList.columns.title.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'invoice_no', get title() { return t('common.export.columns.invoiceNo') }, data: ( item, ctx ) => { return item?.invoiceNumber; } },
                            { id: 'invoice_reference', get title() { return t('common.export.columns.invoiceReference') }, data: ( item, ctx ) => { return item?.reference; } }
                        ]
                    }
                },
                {
                    id      : 'status', group: 'invoice', get label(){ return t('table.invoiceList.columns.status.label') },
                    tooltip : { get title(){ return t('table.invoiceList.columns.status.tooltip.title') }, get description(){ return t('table.invoiceList.columns.status.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'status', get title() { return t('common.export.columns.status') }, data: ( item, ctx ) => { return item?.status; } }
                        ]
                    }
                },
                {
                    id      : 'amount', group: 'invoice', get label(){ return t('table.invoiceList.columns.amount.label') },
                    tooltip : { get title(){ return t('table.invoiceList.columns.amount.tooltip.title') }, get description(){ return t('table.invoiceList.columns.amount.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'amount', get title() { return t('common.export.columns.amount') }, data: ( item, ctx ) =>
                                {
                                    if( item?.amount?.total )
                                    {
                                        return Commercials.convertCurrency( item.amount.total, item.amount.currency, ctx?.$defaultCurrency || item.amount.currency ).toFixed(2);
                                    }
                                }
                            },
                            {
                                id: 'currency', get title() { return t('common.export.columns.currency') }, data: ( item, ctx ) =>
                                {
                                    if( item?.amount?.total )
                                    {
                                        return ( ctx?.$defaultCurrency || item.amount.currency );
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'tax', group: 'invoice', get label(){ return t('table.invoiceList.columns.tax.label') },
                    tooltip : { get title(){ return t('table.invoiceList.columns.tax.tooltip.title') }, get description(){ return t('table.invoiceList.columns.tax.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'amount', get title() { return t('common.export.columns.amount') }, data: ( item, ctx ) =>
                                {
                                    if( item?.amount?.tax )
                                    {
                                        return Commercials.convertCurrency( item.amount.tax, item.amount.currency, ctx?.$defaultCurrency || item.amount.currency ).toFixed(2);
                                    }
                                }
                            },
                            {
                                id: 'currency', get title() { return t('common.export.columns.currency') }, data: ( item, ctx ) =>
                                {
                                    if( item?.amount?.total )
                                    {
                                        return ( ctx?.$defaultCurrency || item.amount.currency );
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'created_date', group: 'invoice', get label(){ return t('table.invoiceList.columns.created_date.label') },
                    tooltip : { get title(){ return t('table.invoiceList.columns.created_date.tooltip.title') }, get description(){ return t('table.invoiceList.columns.created_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'created_date', get title() { return t('common.export.columns.invoiceDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.created )
                                    {
                                        return new Date( item.events.created ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'due_date', group: 'invoice', get label(){ return t('table.invoiceList.columns.due_date.label') },
                    tooltip : { get title(){ return t('table.invoiceList.columns.due_date.tooltip.title') }, get description(){ return t('table.invoiceList.columns.due_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'due_date', get title() { return t('common.export.columns.dueDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.due )
                                    {
                                        return new Date( item.events.due ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'title', 'amount', 'tax', 'created_date', 'due_date', 'status' ] }
            ]
        }
    },

    contactList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups: [],

            columns: [],

            presets:
            [
                { id: 'default', name: 'default', columns: [] }
            ]
        }
    },

    exceptionList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'exception', get label(){ return t('table.exceptionList.groups.exception.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'exception', get label(){ return t('table.exceptionList.columns.title.label') },
                    tooltip : { get title(){ return t('table.exceptionList.columns.title.tooltip.title') }, get description(){ return t('table.exceptionList.columns.title.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'title', get title() { return t('common.export.columns.name') }, data: ( item, ctx ) => { return item?.name; } }
                        ]
                    }
                },
                {
                    id      : 'created_date', group: 'exception', get label(){ return t('table.exceptionList.columns.created_date.label') },
                    tooltip : { get title(){ return t('table.exceptionList.columns.created_date.tooltip.title') }, get description(){ return t('table.exceptionList.columns.created_date.tooltip.description') } },
                    width   : '192px',
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'created_date', get title() { return t('common.export.columns.createdDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.created )
                                    {
                                        return new Date( item.events.created ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                },
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'title', 'created_date' ] }
            ]
        }
    },

    exclusionList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'exception', get label(){ return t('table.exclusionList.groups.exception.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'exception', get label(){ return t('table.exclusionList.columns.title.label') },
                    tooltip : { get title(){ return t('table.exclusionList.columns.title.tooltip.title') }, get description(){ return t('table.exclusionList.columns.title.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'title', get title() { return t('common.export.columns.name') }, data: ( item, ctx ) => { return item?.name; } }
                        ]
                    }
                },
                {
                    id      : 'created_date', group: 'exception', get label(){ return t('table.exclusionList.columns.created_date.label') },
                    tooltip : { get title(){ return t('table.exclusionList.columns.created_date.tooltip.title') }, get description(){ return t('table.exclusionList.columns.created_date.tooltip.description') } },
                    width   : '192px',
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'created_date', get title() { return t('common.export.columns.createdDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.created )
                                    {
                                        return new Date( item.events.created ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                },
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'title', 'created_date' ] }
            ]
        }
    },

    accessInvitationList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'invitation', get label(){ return t('table.accessInvitationList.groups.invitation.label') } },
            ],

            columns:
            [
                {
                    id      : 'name', group: 'invitation', get label(){ return t('table.accessInvitationList.columns.name.label') },
                    tooltip : { get title(){ return t('table.accessInvitationList.columns.name.tooltip.title') }, get description(){ return t('table.accessInvitationList.columns.name.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'name', get title() { return t('common.export.columns.name') }, data: ( item, ctx ) => { return item?.name; } }
                        ]
                    }
                },
                {
                    id      : 'inviter', group: 'invitation', get label(){ return t('table.accessInvitationList.columns.inviter.label') },
                    tooltip : { get title(){ return t('table.accessInvitationList.columns.inviter.tooltip.title') }, get description(){ return t('table.accessInvitationList.columns.inviter.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'inviter', get title() { return t('common.export.columns.inviter') }, data: ( item, ctx ) => { return item?.inviter?.name; } }
                        ]
                    }
                },
                {
                    id      : 'status', group: 'invitation', get label(){ return t('table.accessInvitationList.columns.status.label') },
                    tooltip : { get title(){ return t('table.accessInvitationList.columns.status.tooltip.title') }, get description(){ return t('table.accessInvitationList.columns.status.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'status', get title() { return t('common.export.columns.status') }, data: ( item, ctx ) => { return item?.status; } }
                        ]
                    }
                }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'name', 'inviter', 'status' ] }
            ]
        }
    },

    companyUsersList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'user', get label(){ return t('table.companyUsersList.groups.user.label') } },
            ],

            columns:
            [
                {
                    id      : 'name', group: 'user', get label(){ return t('table.companyUsersList.columns.name.label') },
                    tooltip : { get title(){ return t('table.companyUsersList.columns.name.tooltip.title') }, get description(){ return t('table.companyUsersList.columns.name.tooltip.description') } },
                    width   : '128px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'name', get title() { return t('common.export.columns.name') }, data: ( item, ctx ) => { return item?.name; } }
                        ]
                    }
                },
                {
                    id      : 'manager', group: 'user', get label(){ return t('table.companyUsersList.columns.manager.label') },
                    tooltip : { get title(){ return t('table.companyUsersList.columns.manager.tooltip.title') }, get description(){ return t('table.companyUsersList.columns.manager.tooltip.description') } },
                    width   : '128px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'manager', get title() { return t('common.export.columns.manager') }, data: ( item, ctx ) => { return 'TODO'; } }
                        ]
                    }
                },
                {
                    id      : 'permission', group: 'user', get label(){ return t('table.companyUsersList.columns.permission.label') },
                    tooltip : { get title(){ return t('table.companyUsersList.columns.permission.tooltip.title') }, get description(){ return t('table.companyUsersList.columns.permission.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'permission', get title() { return t('common.export.columns.permissions') }, data: ( item, ctx ) => { return 'TODO'; } }
                        ]
                    }
                },
                {
                    id      : 'inviter', group: 'user', get label(){ return t('table.companyUsersList.columns.inviter.label') },
                    tooltip : { get title(){ return t('table.companyUsersList.columns.inviter.tooltip.title') }, get description(){ return t('table.companyUsersList.columns.inviter.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'inviter', get title() { return t('common.export.columns.inviter') }, data: ( item, ctx ) => { return item?.inviter?.name; } }
                        ]
                    }
                },
                {
                    id      : 'status', group: 'user', get label(){ return t('table.companyUsersList.columns.status.label') },
                    tooltip : { get title(){ return t('table.companyUsersList.columns.status.tooltip.title') }, get description(){ return t('table.companyUsersList.columns.status.tooltip.description') } },
                    width   : '96px',
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            { id: 'status', get title() { return t('common.export.columns.status') }, data: ( item, ctx ) => { return item?.status; } }
                        ]
                    }
                }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'name', 'manager', 'permission', 'status' ] }
            ]
        }
    },

    tagList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'tags', get label(){ return t('table.tagList.groups.tags.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'tags', get label(){ return t('table.tagList.columns.title.label') },
                    tooltip : { get title(){ return t('table.tagList.columns.title.tooltip.title') }, get description(){ return t('table.tagList.columns.title.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'title' ] }
            ]
        }
    },

    billingEntityList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'billingEntity', get label(){ return t('table.billingEntityList.groups.billingEntity.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'billingEntity', get label(){ return t('table.billingEntityList.columns.title.label') },
                    tooltip : { get title(){ return t('table.billingEntityList.columns.title.tooltip.title') }, get description(){ return t('table.billingEntityList.columns.title.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                },
                {
                    id      : 'location', group: 'billingEntity', get label(){ return t('table.billingEntityList.columns.location.label') },
                    tooltip : { get title(){ return t('table.billingEntityList.columns.location.tooltip.title') }, get description(){ return t('table.billingEntityList.columns.location.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                },
                {
                    id      : 'crn', group: 'billingEntity', get label(){ return t('table.billingEntityList.columns.crn.label') },
                    tooltip : { get title(){ return t('table.billingEntityList.columns.crn.tooltip.title') }, get description(){ return t('table.billingEntityList.columns.crn.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                },
                {
                    id      : 'tax', group: 'billingEntity', get label(){ return t('table.billingEntityList.columns.tax.label') },
                    tooltip : { get title(){ return t('table.billingEntityList.columns.tax.tooltip.title') }, get description(){ return t('table.billingEntityList.columns.tax.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                },
                {
                    id      : 'vat', group: 'billingEntity', get label(){ return t('table.billingEntityList.columns.vat.label') },
                    tooltip : { get title(){ return t('table.billingEntityList.columns.vat.tooltip.title') }, get description(){ return t('table.billingEntityList.columns.vat.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                },
                {
                    id      : 'locations', group: 'billingEntity', get label(){ return t('table.billingEntityList.columns.locations.label') },
                    tooltip : { get title(){ return t('table.billingEntityList.columns.locations.tooltip.title') }, get description(){ return t('table.billingEntityList.columns.locations.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: ['title','location','crn','tax','vat'/*,'locations'*/] }
            ]
        }
    },

    invoicingContactList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'invoicingContact', get label(){ return t('table.invoicingContactList.groups.invoicingContact.label') } },
            ],

            columns:
            [
                {
                    id      : 'title', group: 'invoicingContact', get label(){ return t('table.invoicingContactList.columns.title.label') },
                    tooltip : { get title(){ return t('table.invoicingContactList.columns.title.tooltip.title') }, get description(){ return t('table.invoicingContactList.columns.title.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                },
                {
                    id      : 'email', group: 'invoicingContact', get label(){ return t('table.invoicingContactList.columns.email.label') },
                    tooltip : { get title(){ return t('table.invoicingContactList.columns.email.tooltip.title') }, get description(){ return t('table.invoicingContactList.columns.email.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                },
                {
                    id      : 'phone', group: 'invoicingContact', get label(){ return t('table.invoicingContactList.columns.phone.label') },
                    tooltip : { get title(){ return t('table.invoicingContactList.columns.phone.tooltip.title') }, get description(){ return t('table.invoicingContactList.columns.phone.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: ['title', 'email', 'phone'] }
            ]
        }
    },

    noteList:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'note', get label(){ return t('table.noteList.groups.note.label') } },
            ],

            columns:
            [
                {
                    id      : 'creator', group: 'note', get label(){ return t('table.noteList.columns.creator.label') },
                    width   : '56px',
                    tooltip : { get title(){ return t('table.noteList.columns.creator.tooltip.title') }, get description(){ return t('table.noteList.columns.creator.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'relation', group: 'note', get label(){ return t('table.noteList.columns.relation.label') },
                    width   : '72px',
                    tooltip : { get title(){ return t('table.noteList.columns.relation.tooltip.title') }, get description(){ return t('table.noteList.columns.relation.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'note', group: 'note', get label(){ return t('table.noteList.columns.note.label') },
                    tooltip : { get title(){ return t('table.noteList.columns.note.tooltip.title') }, get description(){ return t('table.noteList.columns.note.tooltip.description') } },
                    scope   : [ 'admin', 'employer', 'recruiter' ]
                },
                {
                    id      : 'created_date', group: 'note', get label(){ return t('table.noteList.columns.created_date.label') },
                    width   : '48px',
                    tooltip : { get title(){ return t('table.noteList.columns.created_date.tooltip.title') }, get description(){ return t('table.noteList.columns.created_date.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'created_date', get title() { return t('common.export.columns.createdDate') }, data: ( item, ctx ) =>
                                {
                                    if( item?.events?.created )
                                    {
                                        return new Date( item.events.created ).toUTCDate();
                                    }
                                }
                            }
                        ]
                    }
                }
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'creator', 'relation', 'note', 'created_date' ] }
            ]
        }
    },

    insightsMap:
    {
        grid    : { columns: 4, gap: '24px' },
        table   :
        {
            groups:
            [
                { id: 'jobs', get label(){ return t('table.insightsMap.groups.jobs.label') } },
            ],

            columns:
            [
                {
                    id      : 'country', group: 'jobs',  get label(){ return t('table.insightsMap.columns.country.label') },
                    tooltip : { get title(){ return t('table.insightsMap.columns.country.tooltip.title') }, get description(){ return t('table.insightsMap.columns.country.tooltip.description') } },
                    width   : '256px',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'location_asc', desc: 'location_desc' },
                    export  :
                    {
                        columns:
                        [
                            { id: 'country', get title() { return t('common.export.columns.country') }, data: ( item, ctx ) => { return item?.location.name } },
                            { id: 'currency', get title() { return t('common.export.columns.currency') }, data: ( item, ctx ) => { return ctx.$defaultCurrency || 'GBP' } },
                        ]
                    }
                },
                {
                    id      : 'junior', group: 'jobs', get label(){ return t('table.insightsMap.columns.junior.label') },
                    tooltip : { get title(){ return t('table.insightsMap.columns.junior.tooltip.title') }, get description(){ return t('table.insightsMap.columns.junior.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'junior_asc', desc: 'junior_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'junior-min', get title() { return t('common.export.columns.juniorMin') }, data: ( item, ctx ) =>
                                {
                                    return Math.round( Commercials.convertCurrency( item?.overall[10].base, item.currency, ctx.$defaultCurrency || 'GBP' ) )
                                }
                            },
                            {
                                id: 'junior-max', get title() { return t('common.export.columns.juniorMax') }, data: ( item, ctx ) =>
                                {
                                    const p10 = item?.overall[10].base;
                                    const p50 = item?.overall[50].base;
                                    return Math.round( Commercials.convertCurrency( ( p10 + 2 * p50 ) / 3, item.currency, ctx.$defaultCurrency || 'GBP' ) )
                                }
                            },
                        ]
                    }
                },
                {
                    id      : 'intermediate', group: 'jobs', get label(){ return t('table.insightsMap.columns.intermediate.label') },
                    tooltip : { get title(){ return t('table.insightsMap.columns.intermediate.tooltip.title') }, get description(){ return t('table.insightsMap.columns.intermediate.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'intermediate_asc', desc: 'intermediate_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'intermediate-min', get title() { return t('common.export.columns.intermediateMin') }, data: ( item, ctx ) =>
                                {
                                    return Math.round( Commercials.convertCurrency( item?.overall[50].base, item.currency, ctx.$defaultCurrency || 'GBP' ) )
                                }
                            },
                            {
                                id: 'intermediate-max', get title() { return t('common.export.columns.intermediateMax') }, data: ( item, ctx ) =>
                                {
                                    const p50 = item?.overall[50].base;
                                    const p75 = item?.overall[75].base;
                                    return Math.round( Commercials.convertCurrency( ( p50 + 2 * p75 ) / 3, item.currency, ctx.$defaultCurrency || 'GBP' ) )
                                }
                            }
                        ]
                    }
                },
                {
                    id      : 'senior', group: 'jobs', get label(){ return t('table.insightsMap.columns.senior.label') },
                    tooltip : { get title(){ return t('table.insightsMap.columns.senior.tooltip.title') }, get description(){ return t('table.insightsMap.columns.senior.tooltip.description') } },
                    align   : 'center',
                    scope   : [ 'admin', 'employer', 'recruiter' ],
                    sort    : { asc: 'senior_asc', desc: 'senior_desc' },
                    export  :
                    {
                        columns:
                        [
                            {
                                id: 'senior-min', get title() { return t('common.export.columns.seniorMin') }, data: ( item, ctx ) =>
                                {
                                    const p75 = item?.overall[75].base;
                                    const p90 = item?.overall[90].base;
                                    return Math.round( Commercials.convertCurrency( ( p75 + p90 ) / 2, item.currency, ctx.$defaultCurrency || 'GBP' ) )
                                }
                            },
                            {
                                id: 'senior-max', get title() { return t('common.export.columns.seniorMax') }, data: ( item, ctx ) =>
                                {
                                    const p75 = item?.overall[75].base;
                                    const p90 = item?.overall[90].base;
                                    return Math.round( Commercials.convertCurrency( ( 4 * p90 - p75 ) / 3, item.currency, ctx.$defaultCurrency || 'GBP' ) )
                                }
                            }
                        ]
                    }
                }
                /*{
                id     : '#25', group: 'jobs', get label(){ return t('table.insightsMap.columns.#25.label') }, align: 'center',
                scope  : [ 'admin', 'employer', 'recruiter' ],
                sort   : { asc: '25%_asc', desc: '25%_desc' },
                export :
                {
                    columns:
                    [
                        { id: '#25', get title() { return t('common.export.columns.25Percentile') }, data: ( item, ctx ) => { return Commercials.convertCurrency( item?.overall[25].base, item.currency, ctx.$defaultCurrency || 'GBP' ).toFixed(2) } },
                    ]
                }
                },
                {
                    id     : '#75', group: 'jobs', get label(){ return t('table.insightsMap.columns.#75.label') }, align: 'center',
                    scope  : [ 'admin', 'employer', 'recruiter' ],
                    sort   : { asc: '75%_asc', desc: '75%_desc' },
                    export :
                    {
                        columns:
                        [
                            { id: '#75', get title() { return t('common.export.columns.75Percentile') }, data: ( item, ctx ) => { return Commercials.convertCurrency( item?.overall[75].base, item.currency, ctx.$defaultCurrency || 'GBP' ).toFixed(2) } },
                        ]
                    }
                },*/
            ],

            presets:
            [
                { id: 'default', name: 'default', columns: [ 'country', 'junior', 'intermediate', 'senior' ] }
            ]
        }
    }
};

export const TableActions =
{
    'messageList': ( sections = [ 'header', 'bulk', 'quick' ], $store, $permission, $router, $dialogs, $swagger, $helpers, $updateMessageBadge ) =>
    {
        let actionList =
        {
            header :
            [
                {
                    icon     : 'isax-add',
                    get label(){ return t('table.mailboxList.actions.CreateMessage.title') },
                    condition: ( message, ctx ) => { return $permission.isVisible( 'message-create', 'global', message ) },
                    action   : { type: 'router', path: 'create' }
                }
            ],

            bulk:
            [
                {
                    icon      : 'isax-hashtag',
                    get label(){ return t('table.mailboxList.actions.Folder.title') },
                    class     : 'primary',
                    condition : ( message, ctx ) => { return $permission.isVisible( 'message-tag', 'global', message ); },
                    action    :
                    {
                        type      : 'tag',
                        source    : 'mailbox',
                        condition : ( message, ctx ) => { return $permission.isVisible( 'message-tag', 'global', message ); },
                    }
                },
                {
                    icon      : 'isax-sms',
                    get label(){ return t('table.mailboxList.actions.MarkAsRead.title') },
                    condition : ( ctx ) => { return $permission.isVisible( 'message-read', 'global' ) },
                    action    :
                    {
                        type      : 'modal',
                        id        : 'AreYouSureModal',
                        props     :
                        {
                            title          : 'Mark as read',
                            description    : () =>
                            {
                                let $_helpers = $helpers(), selectedList = [];

                                if( $_helpers.ListData.selectedItems.allSelected ) { selectedList = $_helpers.ListData.items; }
                                else { selectedList = $_helpers.ListData.items.filter( f => $_helpers.ListData.selectedItems.selected.includes( f.id ) ); }

                                return `<div style="max-width: 512px;text-align: center;">By proceeding, you will mark <b>${selectedList.length}</b> selected ${ selectedList.length > 1 ? 'messages' : 'message' } as <b>read</b>.</div>`
                            },
                            buttonText     : { close: 'Cancel', confirm: 'Mark as read', success: 'Successfully marked as read', error: 'Error' },
                            handleCallback : true,
                            callback       : async ( submitButton ) =>
                            {
                                let $_helpers = $helpers(), selectedList = [];

                                if( $_helpers.ListData.selectedItems.allSelected ) { selectedList = $_helpers.ListData.items; }
                                else { selectedList = $_helpers.ListData.items.filter( f => $_helpers.ListData.selectedItems.selected.includes( f.id ) ); }

                                await Promise.all( selectedList.map( item => $swagger.seen_conversation( item.id ) ) );

                                $store.dispatch( 'auth/user/updateMeta', { unread_conversations: await $swagger.unread_conversations() });

                                $updateMessageBadge && $updateMessageBadge();

                                submitButton.element.addEventListener('animationend', async () =>
                                {
                                    let conversationID = $_helpers.clickedItem.value ? $_helpers.clickedItem.value.id : $router.currentRoute.value.params.conversationID;

                                    if( selectedList.find( f => f.id === conversationID ) )
                                    {
                                        const { path, query } = $router.currentRoute.value

                                        const newPath = path.replace('/' + conversationID, '')

                                        $router.push({ path: newPath, query })
                                    }

                                    $dialogs['AreYouSureModal'].close();

                                    TableSelect.clearBulkSelect( $_helpers.ListData, { storagePath: `${$_helpers.storagePath}_selectedItems` } )

                                    await $_helpers.fetchItemList();

                                }, { once: true });
                            }
                        },
                        component: () => import('@/templates/components/Dialogs/AreYouSureDialog')
                    }
                },
                {
                    icon      : 'isax-sms-notification',
                    get label(){ return t('table.mailboxList.actions.MarkAsUnread.title') },
                    condition : ( ctx ) => { return $permission.isVisible( 'message-unread', 'global' ) },
                    action    :
                    {
                        type      : 'modal',
                        id        : 'AreYouSureModal',
                        props     :
                        {
                            title          : 'Mark as unread',
                            description    : () =>
                            {
                                let $_helpers = $helpers(), selectedList = [];

                                if( $_helpers.ListData.selectedItems.allSelected ) { selectedList = $_helpers.ListData.items; }
                                else { selectedList = $_helpers.ListData.items.filter( f => $_helpers.ListData.selectedItems.selected.includes( f.id ) ); }

                                return `<div style="max-width: 512px;text-align: center;">By proceeding, you will mark <b>${selectedList.length}</b> selected ${ selectedList.length > 1 ? 'messages' : 'message' } as <b>unread</b>.</div>`
                            },
                            buttonText     : { close: 'Cancel', confirm: 'Mark as unread', success: 'Successfully marked as unread', error: 'Error' },
                            handleCallback : true,
                            callback       : async ( submitButton ) =>
                            {
                                let $_helpers = $helpers(), selectedList = [];

                                if( $_helpers.ListData.selectedItems.allSelected ) { selectedList = $_helpers.ListData.items; }
                                else { selectedList = $_helpers.ListData.items.filter( f => $_helpers.ListData.selectedItems.selected.includes( f.id ) ); }

                                await Promise.all( selectedList.map( item => $swagger.unread_conversation( item.id ) ) );

                                $store.dispatch( 'auth/user/updateMeta', { unread_conversations: await $swagger.unread_conversations() });

                                $updateMessageBadge && $updateMessageBadge();

                                submitButton.element.addEventListener('animationend', async () =>
                                {
                                    let conversationID = $_helpers.clickedItem.value ? $_helpers.clickedItem.value.id : $router.currentRoute.value.params.conversationID;

                                    if( selectedList.find( f => f.id === conversationID ) )
                                    {
                                        const { path, query } = $router.currentRoute.value

                                        const newPath = path.replace('/' + conversationID, '')

                                        $router.push({ path: newPath, query })
                                    }

                                    $dialogs['AreYouSureModal'].close();

                                    TableSelect.clearBulkSelect( $_helpers.ListData, { storagePath: `${$_helpers.storagePath}_selectedItems` } )

                                    await $_helpers.fetchItemList();

                                }, { once: true });
                            }
                        },
                        component: () => import('@/templates/components/Dialogs/AreYouSureDialog')
                    }
                },
                {
                    icon      : 'isax-trash',
                    get label(){ return t('table.mailboxList.actions.DeleteMessage.title') },
                    condition : ( ctx ) => { return $permission.isVisible( 'message-delete', 'global' ) },
                    action    :
                    {
                        type      : 'modal',
                        id        : 'AreYouSureModal',
                        props     :
                        {
                            title          : t('table.mailboxList.actions.DeleteMessage.dialog.title'),
                            description    : () =>
                            {
                                let $_helpers = $helpers(), selectedList = [];

                                if( $_helpers.ListData.selectedItems.allSelected ) { selectedList = $_helpers.ListData.items; }
                                else { selectedList = $_helpers.ListData.items.filter( f => $_helpers.ListData.selectedItems.selected.includes( f.id ) ); }

                                return `<div style="max-width: 512px;text-align: center;">By proceeding, you will <b>delete</b> <b>${selectedList.length}</b> selected ${ selectedList.length > 1 ? 'messages' : 'message' }.</div>`
                            },
                            buttonText     : { close: 'Cancel', confirm: 'Delete messages', success: 'Successfully deleted', error: 'Error' },
                            handleCallback : true,
                            callback       : async ( submitButton ) =>
                            {
                                let $_helpers = $helpers(), selectedList = [];

                                if( $_helpers.ListData.selectedItems.allSelected ) { selectedList = $_helpers.ListData.items; }
                                else { selectedList = $_helpers.ListData.items.filter( f => $_helpers.ListData.selectedItems.selected.includes( f.id ) ); }

                                await Promise.all( selectedList.map( item => $swagger.delete_conversation( item.id ) ) );

                                $store.dispatch( 'auth/user/updateMeta', { unread_conversations: await $swagger.unread_conversations() });

                                $updateMessageBadge && $updateMessageBadge();

                                submitButton.element.addEventListener('animationend', async () =>
                                {
                                    let conversationID = $_helpers.clickedItem.value ? $_helpers.clickedItem.value.id : $router.currentRoute.value.params.conversationID;

                                    if( selectedList.find( f => f.id === conversationID ) )
                                    {
                                        const { path, query } = $router.currentRoute.value

                                        const newPath = path.replace('/' + conversationID, '')

                                        $router.push({ path: newPath, query })
                                    }

                                    $dialogs['AreYouSureModal'].close();

                                    TableSelect.clearBulkSelect( $_helpers.ListData, { storagePath: `${$_helpers.storagePath}_selectedItems` } )

                                    await $_helpers.fetchItemList();

                                }, { once: true });
                            }
                        },
                        component: () => import('@/templates/components/Dialogs/AreYouSureDialog')
                    }
                }
            ],

            quick: []
        }

        if( !sections.includes('header') ) { delete actionList.header; }
        if( !sections.includes('bulk') )   { delete actionList.bulk; }
        if( !sections.includes('quick') )  { delete actionList.quick; }

        return actionList;
    },

    'jobList': ( sections = [ 'header', 'bulk', 'quick' ], $permission, $router, $dialogs, $swagger, fetchItemList, $draft ) =>
    {
        let actionList =
            {
                header:
                [
                    {
                        icon      : 'isax-add',
                        get label() { return t('views.views.Detail.createRequisition') + ( $draft && $draft.get('job') ? ` ( ${t('recruitment.jobs.status.draft').toLowerCase()} )` : '' ) },
                        class     : 'pulse-block-animation',
                        get $_class() { return 'pulse-block-animation' + ( $draft && $draft.get('job') ? ' success' : '' ) },
                        condition : ( ctx ) => { return $permission.isVisible( 'job-create', 'job-list' ) },
                        action    :
                        {
                            type        : 'modal',
                            id          : 'JobModal',
                            ctx         : { method: 'create', fetchList: async () => await fetchItemList() },
                            component   : () => import('@/templates/views/recruitment/jobs/dialogs/JobDialog')
                        }
                    }
                ],

                bulk: [],

                quick:
                [
                    {
                        icon      : 'isax-search-status',
                        get label(){ return t('table.jobList.actions.Details.title') },
                        children  :
                        [
                            {
                                icon      : 'isax-eye',
                                get label(){ return t('table.jobList.actions.ShowDetails.title') },
                                action    :
                                {
                                    type   : 'function',
                                    method : ( item ) => { $router.push( { name: 'JobDetail', params: { jobID: item.id } } ) },
                                }
                            }
                        ]
                    },

                    {
                        icon      : 'isax-edit-2',
                        get label(){ return t('table.jobList.actions.Modification.title') },
                        condition : ( job, ctx ) =>
                        {
                            return $permission.isVisible( 'job-status-open', 'job-list', job ) ||
                                $permission.isVisible( 'job-status-pause', 'job-list', job ) ||
                                $permission.isVisible( 'job-status-close', 'job-list', job ) ||
                                $permission.isVisible( 'job-edit', 'job-list', job ) ||
                                $permission.isVisible( 'job-duplicate', 'job-list', job )
                        },
                        children  :
                        [
                            {
                                icon      : 'isax-notification-status4',
                                get label(){ return t('table.jobList.actions.ChangeStatus.title') },
                                condition : ( job, ctx ) =>
                                {
                                    return $permission.isVisible( 'job-status-open', 'job-list', job ) ||
                                        $permission.isVisible( 'job-status-pause', 'job-list', job ) ||
                                        $permission.isVisible( 'job-status-close', 'job-list', job )
                                },
                                children  :
                                [
                                    {
                                        icon      : 'isax-play-circle',
                                        get label(){ return t('table.jobList.actions.Open.title') },
                                        condition : ( job, ctx ) => { return $permission.isVisible( 'job-status-open', 'job-list', job ) },
                                        action    :
                                        {
                                            type      : 'modal',
                                            id        : 'StatusModal',
                                            ctx       : { method: 'open', fetchList: async () => await fetchItemList() },
                                            transform : ( store, item ) => { return { id: item.id } },
                                            component : () => import('@/templates/views/recruitment/jobs/dialogs/edit/JobStatusDialog.vue')
                                        }
                                    },
                                    {
                                        icon      : 'isax-pause-circle',
                                        get label(){ return t('table.jobList.actions.OnHold.title') },
                                        condition : ( job, ctx ) => { return $permission.isVisible( 'job-status-pause', 'job-list', job ) },
                                        action    :
                                        {
                                            type        : 'modal',
                                            id          : 'StatusModal',
                                            ctx         : { method: 'paused', fetchList: async () => await fetchItemList() },
                                            transform   : ( store, item ) => { return { id: item.id } },
                                            component   : () => import('@/templates/views/recruitment/jobs/dialogs/edit/JobStatusDialog.vue')
                                        }
                                    },
                                    {
                                        icon      : 'isax-stop-circle',
                                        get label(){ return t('table.jobList.actions.Close.title') },
                                        condition : ( job, ctx ) => { return $permission.isVisible( 'job-status-close', 'job-list', job ) },
                                        action    :
                                        {
                                            type        : 'modal',
                                            id          : 'StatusModal',
                                            ctx         : { method: 'closed', fetchList: async () => await fetchItemList() },
                                            transform   : ( store, item ) => { return { id: item.id } },
                                            component   : () => import('@/templates/views/recruitment/jobs/dialogs/edit/JobStatusDialog.vue')
                                        }
                                    }
                                ]
                            },
                            {
                                icon      : 'isax-edit',
                                get label(){ return t('table.jobList.actions.Edit.title') },
                                condition : ( job, ctx ) => { return $permission.isVisible( 'job-edit', 'job-list', job ) },
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'JobModal',
                                    ctx         : { method: 'edit', fetchList: async () => await fetchItemList() },
                                    transform   : ( store, item ) => { return { id: item.id } },
                                    component   : () => import('@/templates/views/recruitment/jobs/dialogs/JobDialog')
                                }
                            },
                            {
                                icon      : 'isax-copy',
                                get label(){ return t('table.jobList.actions.Duplicate.title') },
                                condition : ( job, ctx ) => { return $permission.isVisible( 'job-duplicate', 'job-list', job ) },
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'JobModal',
                                    ctx         : { method: 'duplicate' },
                                    transform   : ( store, item ) => { return { id: item.id } },
                                    component   : () => import('@/templates/views/recruitment/jobs/dialogs/JobDialog')
                                }
                            }
                        ]
                    },

                    {
                        icon      : 'isax-next',
                        get label(){ return t('table.jobList.actions.Actions.title') },
                        condition : ( job, ctx ) =>
                        {
                            return $permission.isVisible( 'job-invitation-create', 'job-list', job ) ||
                                $permission.isVisible( 'application-create', 'job-list', { job } ) ||
                                $permission.isVisible( 'job-briefing-edit', 'job-list', { job, briefing: undefined } )
                        },
                        children  :
                        [
                            {
                                icon      : 'isax-cloud-add4',
                                get label(){ return t('table.jobList.actions.InviteAgencies.title') },
                                condition : ( job, ctx ) => { return $permission.isVisible( 'job-invitation-create', 'job-list', job ) },
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'AgencyInvitationModal',
                                    ctx         : { fetchList: async () => await fetchItemList() },
                                    transform   : ( store, item ) => { return { id: item.id } },
                                    component   : () => import('@/templates/views/recruitment/jobs/dialogs/invitation/JobAgencyInvitationDialog.vue')
                                }
                            },
                            {
                                icon      : 'isax-edit',
                                get label(){ return t('table.jobList.actions.SubmitApplication.title') },
                                condition : ( job, ctx ) => { return $permission.isVisible( 'application-create', 'job-list', { job } ) },
                                action    :
                                {
                                    type      : 'modal',
                                    id        : 'ApplicationModal',
                                    ctx       : { method: 'create', fetchList: async () => await fetchItemList() },
                                    transform : ( store, item ) => { return { job: item } },
                                    component : () => import('@/templates/views/recruitment/applications/dialogs/ApplicationDialog')
                                }
                            },
                            {
                                icon      : 'isax-call-add',
                                get label(){ return t('table.jobList.actions.ScheduleBriefingCall.title') },
                                condition : ( job, ctx ) => { return $permission.isVisible( 'job-briefing-edit', 'job-list', { job, briefing: undefined } ) },
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'ScheduleBriefingCallModal',
                                    ctx         : { method: 'create', fetchList: async () => await fetchItemList() },
                                    transform   : ( store, item ) => { return { job: item, briefing: undefined } },
                                    component   : () => import('@/templates/views/recruitment/jobs/dialogs/briefing/JobScheduleBriefingCall.vue')
                                }
                            }
                        ]
                    },

                    {
                        icon      : 'isax-sms',
                        get label(){ return t('table.jobList.actions.SendMessage.title') },
                        condition : ( job, ctx ) => { return $permission.isVisible( 'message-employer', 'job-list', job ) || $permission.isVisible( 'message-account-manager', 'job-list', job ) },
                        children  :
                        [
                            {
                                icon      : 'isax-sms-edit',
                                get label(){ return t('table.jobList.actions.JobManager.title') },
                                condition : ( job, ctx ) => { return $permission.isVisible( 'message-employer', 'job-list', job ) },
                                action    :
                                {
                                    type   : 'function',
                                    method : ( item ) => { $router.push(`/jobs/${item.id}/create?currentTab=JobMessages${item.employers.map( e => '&recipient=' + e.id ).join('')}`) },
                                }
                            },
                            {
                                icon      : 'isax-sms-edit',
                                get label(){ return t('table.jobList.actions.AccountManager.title') },
                                condition : ( job, ctx ) => { return $permission.isVisible( 'message-account-manager', 'job-list', job ) },
                                action    :
                                {
                                    type   : 'function',
                                    method : ( item ) => { $router.push(`/jobs/${item.id}/create?currentTab=JobMessages${item.accountManagers.map( e => '&recipient=' + e.id ).join('')}`) },
                                }
                            },
                        ]
                    },

                    {
                        type: 'divider',
                        condition : ( job, ctx ) => { return $permission.isVisible( 'job-engagement-disengage', 'job-list', job ) || $permission.isVisible( 'job-delete', 'job-list', job ) },
                    },

                    {
                        icon      : 'isax-clipboard-close',
                        get label(){ return t('table.jobList.actions.Disengage.title') },
                        condition : ( job, ctx ) => { return $permission.isVisible( 'job-engagement-disengage', 'job-list', job ) },
                        action    :
                        {
                            type      : 'modal',
                            id        : 'EngagementModal',
                            ctx       : { fetchList: async () => await fetchItemList() },
                            transform : ( store, item ) => { return { engagementID: item.$actions.disengageID, jobID: item.id } },
                            component : () => import('@/templates/views/recruitment/jobs/dialogs/engagement/JobDisengageDialog.vue')
                        }
                    },
                    {
                        icon      : 'isax-trash',
                        get label(){ return t('table.jobList.actions.DeleteJob.title') },
                        condition : ( job, ctx ) => { return $permission.isVisible( 'job-delete', 'job-list', job ) },
                        action    :
                        {
                            type        : 'modal',
                            id          : 'AreYouSureModal',
                            props       :
                            {
                                title          : t('table.jobList.actions.DeleteJob.dialog.title'),
                                description    : t('table.jobList.actions.DeleteJob.dialog.description'),
                                handleCallback : true,
                                callback       : async ( submitButton ) =>
                                {
                                    await $swagger.delete_job( $dialogs['AreYouSureModal'].ctx.id );

                                    submitButton.element.addEventListener('animationend', async () =>
                                    {
                                        $dialogs['AreYouSureModal'].close(); await fetchItemList();

                                    }, { once: true });
                                }
                            },
                            component: () => import('@/templates/components/Dialogs/AreYouSureDialog')
                        }
                    }
                ]
            }

        if( !sections.includes('header') ) { delete actionList.header; }
        if( !sections.includes('bulk') )   { delete actionList.bulk; }
        if( !sections.includes('quick') )  { delete actionList.quick; }

        return actionList;
    },

    'applicationList': ( sections = [ 'header', 'bulk', 'quick' ], $permission, $router, $swagger, fetchItemList, getHelpers ) =>
    {
        let actionList =
            {
                header : [],
                bulk   :
                [
                    {
                        icon      : 'isax-card-slash',
                        get label(){ return t('table.applicationList.actions.RejectApplications.title') },
                        condition : ( applications, ctx ) => { return $permission.isVisible( 'application-reject', 'application-list-bulk', { applications } ) }, //!ctx.$permission.isRampAccount() && ctx.$permission.has(['admin','employer']) && ['open','paused'].includes( application.job.status ) && ["submitted","reviewed","interviewing","under-offer"].includes( application.status )
                        action    :
                        {
                            type      : 'modal',
                            id        : 'ApplicationRejectedModal',
                            ctx       : { type: 'bulk', fetchList: async () => await fetchItemList() },
                            transform : () =>
                            {
                                let helpers = getHelpers(), selectedList = [];

                                if( helpers.ListData.selectedItems.allSelected )
                                {
                                    selectedList = helpers.ListData.items;
                                }
                                else
                                {
                                    selectedList = helpers.ListData.items.filter( f => helpers.ListData.selectedItems.selected.includes( f.id ) );
                                }

                                return { selectedList };
                            },
                            component : () => import('@/templates/views/recruitment/applications/dialogs/progress/ApplicationRejectedDialog.vue')
                        }
                    }
                ],
                quick  :
                [
                    {
                        icon      : 'isax-search-status',
                        get label(){ return t('table.applicationList.actions.Details.title') },
                        children  :
                        [
                            {
                                icon      : 'isax-eye',
                                get label(){ return t('table.applicationList.actions.ShowDetails.title') },
                                action    :
                                {
                                    type   : 'function',
                                    method : ( item ) => { $router.push( { name: 'ApplicationDetail', params: { applicationID: item.id } } ) },
                                }
                            }
                        ]
                    },

                    {
                        icon      : 'isax-edit-2',
                        get label(){ return t('table.applicationList.actions.Modification.title') },
                        condition : ( application, ctx ) => { return  ctx.$permission.has(['admin']) || $permission.isVisible( 'application-edit', 'application-list', { application } ) || $permission.isVisible( 'application-duplicate', 'application-list', { application } ) },
                        children  :
                        [
                            {
                                icon      : 'isax-edit',
                                get label(){ return t('table.applicationList.actions.Edit.title') },
                                condition : ( application, ctx ) => { return $permission.isVisible( 'application-edit', 'application-list', { application } ) },
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'ApplicationModal',
                                    ctx         : { method: 'edit', fetchList: async () => await fetchItemList() },
                                    transform   : ( store, item ) => { return { id: item.id } },
                                    component   : () => import('@/templates/views/recruitment/applications/dialogs/ApplicationDialog')
                                }
                            },
                            {
                                icon      : 'isax-copy',
                                get label(){ return t('table.applicationList.actions.Duplicate.title') },
                                condition : ( application, ctx ) => { return $permission.isVisible( 'application-duplicate', 'application-list', { application } ) },
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'ApplicationDuplicateModal',
                                    ctx         : { method: 'duplicate' },
                                    transform   : ( store, item ) => { return { id: item.id } },
                                    component   : () => import('@/templates/views/recruitment/applications/dialogs/duplicate/ApplicationDuplicateDialog')
                                }
                            },
                            {
                                icon      : 'isax-dcube',
                                get label(){ return t('table.applicationList.actions.EditCommercials.title') },
                                condition : ( engagement, ctx ) => { return ctx.$permission.has(['admin']) }, // && props.Detail.status === 'open' && engagement.status === 'active'
                                action    :
                                {
                                    type      : 'modal',
                                    id        : 'ProgrammeLocationModal',
                                    ctx       :
                                    {
                                        source      : 'quick',
                                        method      : 'edit',
                                        fetchList   : async () => await fetchItemList(),
                                        afterSubmit : async ( data, closeElement ) =>
                                        {
                                            let commercials = { ...getHelpers().ListData.items.find( e => e.id === data.applicationID ).commercials, ...data.commercials };

                                            delete commercials.id;
                                            delete commercials.events;

                                            await $swagger.update_application( data.applicationID, { body: { commercials } } );

                                            closeElement.click();

                                            await fetchItemList();
                                        }
                                    },
                                    transform : ( store, item ) => { return { applicationID: item.id } },
                                    component : () => import('@/templates/views/recruitment/programmes/dialogs/ProgrammeLocationDialog.vue')
                                }
                            }
                        ]
                    },

                    {
                        icon      : 'isax-next',
                        get label(){ return t('table.applicationList.actions.Progression.title') },
                        condition : ( application, ctx ) =>
                        {
                            return $permission.isVisible( 'application-review', 'application-list', { application, job: application.job } ) ||
                                $permission.isVisible( 'application-interview', 'application-list', { application, job: application.job } ) ||
                                $permission.isVisible( 'application-offer', 'application-list', { application, job: application.job } ) ||
                                $permission.isVisible( 'application-offer-edit', 'application-list', { application, job: application.job } ) ||
                                $permission.isVisible( 'application-offer-confirm', 'application-list', { application, job: application.job } ) ||
                                $permission.isVisible( 'application-approve-start-date', 'application-list', { application, job: application.job } )
                        },
                        children  :
                        [
                            {
                                icon      : 'isax-flash-1',
                                get label(){ return t('table.applicationList.actions.Reviewing.title') },
                                condition : ( application, ctx ) => { return $permission.isVisible( 'application-review', 'application-list', { application, job: application.job } ) }, //ctx.$permission.has(['admin','employer']) && ['open','paused'].includes( application.job.status ) && ["submitted"].includes( application.status )
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'ApplicationReviewedModal',
                                    ctx         : { fetchList: async () => await fetchItemList() },
                                    transform   : ( store, item ) => { return { id: item.id } },
                                    component   : () => import('@/templates/views/recruitment/applications/dialogs/progress/ApplicationReviewedDialog')
                                }
                            },
                            {
                                icon      : 'isax-microphone-24',
                                get label(){ return t('table.applicationList.actions.RequestInterview.title') },
                                condition : ( application, ctx ) => { return $permission.isVisible( 'application-interview', 'application-list', { application, job: application.job } ) }, //ctx.$permission.has(['admin','employer']) && ['open','paused'].includes( application.job.status ) && ["reviewed"].includes( application.status )
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'ApplicationInterviewModal',
                                    ctx         : { fetchList: async () => await fetchItemList() },
                                    transform   : ( store, item ) => { return { id: item.id } },
                                    component   : () => import('@/templates/views/recruitment/applications/dialogs/progress/ApplicationInterviewDialog')
                                }
                            },
                            {
                                icon      : 'isax-flag4',
                                get label(){ return t('table.applicationList.actions.SubmitOffer.title') },
                                condition : ( application, ctx ) => { return $permission.isVisible( 'application-offer', 'application-list', { application, job: application.job } ) }, //( ctx.$permission.has(['admin','employer']) && ['open','paused'].includes( application.job.status ) && ["interviewing"].includes( application.status ) ) || ( ctx.$permission.has(['recruiter','employer']) && ["under-offer"].includes( application.status ) && !application.hasOwnProperty('offer') )
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'ApplicationOfferModal',
                                    ctx         : { method: 'submit', fetchList: async () => await fetchItemList() },
                                    transform   : ( store, item ) => { return { id: item.id } },
                                    component   : () => import('@/templates/views/recruitment/applications/dialogs/progress/ApplicationOfferDialog')
                                }
                            },
                            {
                                icon      : 'isax-edit4',
                                get label(){ return t('table.applicationList.actions.EditOffer.title') },
                                condition : ( application, ctx ) => { return $permission.isVisible( 'application-offer-edit', 'application-list', { application, job: application.job } ) }, //ctx.$permission.has(['admin','recruiter','employer']) && ['open','paused'].includes( application.job.status ) && ["under-offer"].includes( application.status ) && ( application.hasOwnProperty('offer') && application.offer?.proposer?.organization?.id === organizationID )
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'ApplicationOfferModal',
                                    ctx         : { method: 'submit', fetchList: async () => await fetchItemList() },
                                    transform   : ( store, item ) => { return { id: item.id } },
                                    component   : () => import('@/templates/views/recruitment/applications/dialogs/progress/ApplicationOfferDialog')
                                }
                            },
                            {
                                icon      : 'isax-money-tick',
                                get label(){ return t('table.applicationList.actions.ConfirmOffer.title') },
                                condition : ( application, ctx ) => { return $permission.isVisible( 'application-offer-confirm', 'application-list', { application, job: application.job } ) }, //ctx.$permission.has(['recruiter','employer']) && ['open','paused'].includes( application.job.status ) && ["under-offer"].includes( application.status ) && application.hasOwnProperty('offer') && application?.offer?.proposer?.organization?.id !== organizationID
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'ApplicationOfferModal',
                                    ctx         : { method: 'confirm', fetchList: async () => await fetchItemList() },
                                    transform   : ( store, item ) => { return { id: item.id } },
                                    component   : () => import('@/templates/views/recruitment/applications/dialogs/progress/ApplicationOfferDialog')
                                }
                            },
                            {
                                icon      : 'isax-money-change',
                                get label(){ return t('table.applicationList.actions.CounterOffer.title') },
                                condition : ( application, ctx ) => { return $permission.isVisible( 'application-offer-confirm', 'application-list', { application, job: application.job } ) }, //ctx.$permission.has(['recruiter','employer']) && ['open','paused'].includes( application.job.status ) && ["under-offer"].includes( application.status ) && application.hasOwnProperty('offer') && application?.offer?.proposer?.organization?.id !== organizationID
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'ApplicationOfferModal',
                                    ctx         : { method: 'counter', fetchList: async () => await fetchItemList() },
                                    transform   : ( store, item ) => { return { id: item.id } },
                                    component   : () => import('@/templates/views/recruitment/applications/dialogs/progress/ApplicationOfferDialog')
                                }
                            },
                            {
                                icon      : 'isax-money-forbidden',
                                get label(){ return t('table.applicationList.actions.RejectOffer.title') },
                                condition : ( application, ctx ) => { return $permission.isVisible( 'application-offer-confirm', 'application-list', { application, job: application.job } ) }, //ctx.$permission.has(['recruiter','employer']) && ['open','paused'].includes( application.job.status ) && ["under-offer"].includes( application.status ) && application.hasOwnProperty('offer') && application?.offer?.proposer?.organization?.id !== organizationID
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'ApplicationOfferModal',
                                    ctx         : { method: 'reject', fetchList: async () => await fetchItemList() },
                                    transform   : ( store, item ) => { return { id: item.id } },
                                    component   : () => import('@/templates/views/recruitment/applications/dialogs/progress/ApplicationOfferDialog')
                                }
                            },
                            {
                                icon      : 'isax-timer-start',
                                get label(){ return t('table.applicationList.actions.ConfirmStartDate.title') },
                                condition : ( application, ctx ) => { return $permission.isVisible( 'application-approve-start-date', 'application-list', { application, job: application.job } ) }, //ctx.$permission.has(['admin','employer']) && ["placed"].includes( application.status )
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'ApplicationStartModal',
                                    ctx         : { method: 'confirm', fetchList: async () => await fetchItemList() },
                                    transform   : ( store, item ) => { return { id: item.id } },
                                    component   : () => import('@/templates/views/recruitment/applications/dialogs/progress/ApplicationStartDialog.vue')
                                }
                            }
                        ]
                    },

                    {
                        icon      : 'isax-next',
                        get label(){ return t('table.applicationList.actions.Actions.title') },
                        condition : ( application, ctx ) => { return $permission.isVisible( 'application-briefing-create', 'application-list', { application, briefing: undefined } ) },
                        children  :
                        [
                            {
                                icon      : 'isax-call-add',
                                get label(){ return t('table.applicationList.actions.ScheduleInterviewCall.title') },
                                condition : ( application, ctx ) => { return $permission.isVisible( 'application-briefing-create', 'application-list', { application, briefing: undefined } ) },
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'ScheduleInterviewCallModal',
                                    ctx         : { method: 'create', fetchList: async () => await fetchItemList() },
                                    transform   : ( store, item ) => { return { application: item, briefing: undefined } },
                                    component   : () => import('@/templates/views/recruitment/applications/dialogs/briefing/ApplicationScheduleInterviewCall.vue')
                                }
                            }
                        ]
                    },

                    {
                        icon      : 'isax-sms',
                        get label(){ return t('table.applicationList.actions.SendMessage.title') },
                        condition : ( application, ctx ) =>
                        {
                            return $permission.isVisible( 'message-employer', 'application-list', application ) ||
                                $permission.isVisible( 'message-recruiter', 'application-list', application ) ||
                                $permission.isVisible( 'message-account-manager', 'application-list', application )
                        },
                        children  :
                        [
                            {
                                icon      : 'isax-sms-edit',
                                get label(){ return t('table.applicationList.actions.JobManager.title') },
                                condition : ( application, ctx ) => { return $permission.isVisible( 'message-employer', 'application-list', application ) },
                                action    :
                                {
                                    type   : 'function',
                                    method : ( item ) => { $router.push(`/applications/${item.id}/create?currentTab=ApplicationMessages${item.employers.map( e => '&recipient=' + e.id ).join('')}`) },
                                }
                            },
                            {
                                icon      : 'isax-sms-edit',
                                get label(){ return t('table.applicationList.actions.Recruiter.title') },
                                condition : ( application, ctx ) => { return $permission.isVisible( 'message-recruiter', 'application-list', application ) },
                                action    :
                                {
                                    type   : 'function',
                                    method : ( item ) => { $router.push(`/applications/${item.id}/create?currentTab=ApplicationMessages&recipient=${item.recruiter.id}`) },
                                }
                            },
                            {
                                icon      : 'isax-sms-edit',
                                get label(){ return t('table.applicationList.actions.AccountManager.title') },
                                condition : ( application, ctx ) => { return $permission.isVisible( 'message-account-manager', 'application-list', application ) },
                                action    :
                                {
                                    type   : 'function',
                                    method : ( item ) => { $router.push(`/applications/${item.id}/create?currentTab=ApplicationMessages${item.accountManagers.map( e => '&recipient=' + e.id ).join('')}`) },
                                }
                            }
                        ]
                    },

                    {
                        type: 'divider',
                        condition : ( application, ctx ) =>
                        {
                            return $permission.isVisible( 'application-withdraw', 'application-list', { application, job: application.job } ) ||
                                $permission.isVisible( 'application-reject', 'application-list', { application, job: application.job } ) ||
                                $permission.isVisible( 'application-dropout', 'application-list', { application } ) ||
                                $permission.isVisible( 'application-reinstate', 'application-list', { application } )
                        },
                    },

                    {
                        icon      : 'isax-card-slash',
                        get label(){ return t('table.applicationList.actions.WithdrawApplication.title') },
                        condition : ( application, ctx ) => { return $permission.isVisible( 'application-withdraw', 'application-list', { application, job: application.job } ) }, //!ctx.$permission.isRampAccount() && ctx.$permission.has(['recruiter']) && ['open','paused'].includes( application.job.status ) && ["submitted","reviewed","interviewing","under-offer"].includes( application.status )
                        action    :
                        {
                            type      : 'modal',
                            id        : 'ApplicationWithdrawnModal',
                            ctx       : { fetchList: async () => await fetchItemList() },
                            transform : ( store, item ) => { return { id: item.id } },
                            component : () => import('@/templates/views/recruitment/applications/dialogs/progress/ApplicationWithdrawnDialog.vue')
                        }
                    },
                    {
                        icon      : 'isax-card-slash',
                        get label(){ return t('table.applicationList.actions.RejectApplication.title') },
                        condition : ( application, ctx ) => { return $permission.isVisible( 'application-reject', 'application-list', { application, job: application.job } ) }, //!ctx.$permission.isRampAccount() && ctx.$permission.has(['admin','employer']) && ['open','paused'].includes( application.job.status ) && ["submitted","reviewed","interviewing","under-offer"].includes( application.status )
                        action    :
                        {
                            type      : 'modal',
                            id        : 'ApplicationRejectedModal',
                            ctx       : { fetchList: async () => await fetchItemList() },
                            transform : ( store, item ) => { return { id: item.id } },
                            component : () => import('@/templates/views/recruitment/applications/dialogs/progress/ApplicationRejectedDialog.vue')
                        }
                    },
                    {
                        icon      : 'isax-card-slash',
                        get label(){ return t('table.applicationList.actions.DropoutApplication.title') },
                        condition : ( application, ctx ) => { return $permission.isVisible( 'application-dropout', 'application-list', { application } ) }, //!ctx.$permission.isRampAccount() && ctx.$permission.has(['admin','employer']) && ["placed","hired"].includes( application.status )
                        action    :
                        {
                            type      : 'modal',
                            id        : 'ApplicationDropoutModal',
                            ctx       : { fetchList: async () => await fetchItemList() },
                            transform : ( store, item ) => { return { id: item.id } },
                            component : () => import('@/templates/views/recruitment/applications/dialogs/progress/ApplicationDropoutDialog.vue')
                        }
                    },
                    {
                        icon      : 'isax-backward',
                        get label(){ return t('table.applicationList.actions.ReinstateApplication.title') },
                        condition : ( application, ctx ) => { return $permission.isVisible( 'application-reinstate', 'application-list', { application } ) },
                        action    :
                        {
                            type      : 'modal',
                            id        : 'ApplicationReinstateModal',
                            ctx       : { fetchList: async () => await fetchItemList() },
                            transform : ( store, item ) => { return { id: item.id } },
                            component : () => import('@/templates/views/recruitment/applications/dialogs/progress/ApplicationReinstateDialog.vue')
                        }
                    }
                ]
            };

        if( !sections.includes('header') ) { delete actionList.header; }
        if( !sections.includes('bulk') )   { delete actionList.bulk; }
        if( !sections.includes('quick') )  { delete actionList.quick; }

        return actionList;
    },

    'placementList': ( sections = [ 'header', 'bulk', 'quick' ], $permission, $router, $dialogs, $swagger, fetchItemList ) =>
    {
        let actionList =
            {
                header :
                [
                    {
                        icon      : 'isax-add',
                        get label(){ return t('table.placementList.actions.CreatePlacement.title') },
                        class     : 'pulse-block-animation',
                        condition : ( placement, ctx ) => { return $permission.isVisible( 'placement-create', 'placement-list', placement ) }, //!ctx.$permission.isRampAccount() && ctx.$permission.has(['admin','employer'])
                        action    :
                        {
                            type      : 'modal',
                            id        : 'PlacementModal',
                            ctx       : { method: 'create', fetchList: async () => await fetchItemList() },
                            component : () => import('@/templates/views/recruitment/placements/dialogs/PlacementDialog')
                        }
                    }
                ],
                bulk   : [],
                quick  :
                [
                    {
                        icon      : 'isax-search-status',
                        get label(){ return t('table.placementList.actions.Details.title') },
                        children  :
                        [
                            {
                                icon      : 'isax-eye',
                                get label(){ return t('table.placementList.actions.ShowDetails.title') },
                                action    :
                                {
                                    type   : 'function',
                                    method : ( item ) => { $router.push( { name: 'PlacementDetail', params: { placementID: item.id } } ) },
                                }
                            }
                        ]
                    },

                    {
                        icon      : 'isax-edit-2',
                        get label(){ return t('table.placementList.actions.Modification.title') },
                        condition : ( placement, ctx ) =>
                        {
                            return $permission.isVisible( 'placement-dropout', 'placement-list', placement ) ||
                                $permission.isVisible( 'placement-edit', 'placement-list', placement ) ||
                                $permission.isVisible( 'placement-duplicate', 'placement-list', placement )
                        },
                        children  :
                        [
                            {
                                icon      : 'isax-notification-status4',
                                get label(){ return t('table.placementList.actions.ChangeStatus.title') },
                                condition : ( placement, ctx ) => { return $permission.isVisible( 'placement-dropout', 'placement-list', placement ) },
                                children  :
                                [
                                    {
                                        icon      : 'isax-note-remove',
                                        get label(){ return t('table.placementList.actions.Dropout.title') },
                                        condition : ( placement, ctx ) => { return $permission.isVisible( 'placement-dropout', 'placement-list', placement ) },
                                        action    :
                                        {
                                            type  : 'modal',
                                            id    : 'AreYouSureModal',
                                            props :
                                            {
                                                title          : t('table.placementList.actions.Dropout.dialog.title'),
                                                description    : t('table.placementList.actions.Dropout.dialog.description'),
                                                handleCallback : true,
                                                callback       : async ( submitButton ) =>
                                                {
                                                    await $swagger.dropout_placement( $dialogs['AreYouSureModal'].ctx.id );

                                                    submitButton.element.addEventListener('animationend', async () =>
                                                    {
                                                        $dialogs['AreYouSureModal'].close();

                                                        await fetchItemList();

                                                    }, { once: true });
                                                }
                                            },
                                            component: () => import('@/templates/components/Dialogs/AreYouSureDialog')
                                        }
                                    }
                                ]
                            },
                            {
                                icon      : 'isax-edit',
                                get label(){ return t('table.placementList.actions.Edit.title') },
                                condition : ( placement, ctx ) => { return $permission.isVisible( 'placement-edit', 'placement-list', placement ) }, //ctx.$permission.has(['admin','employer'])
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'PlacementModal',
                                    ctx         : { method: 'edit', fetchList: async () => await fetchItemList() },
                                    transform   : ( store, item ) => { return { id: item.id } },
                                    component   : () => import('@/templates/views/recruitment/placements/dialogs/PlacementDialog')
                                }
                            },
                            {
                                icon      : 'isax-copy',
                                get label(){ return t('table.placementList.actions.Duplicate.title') },
                                condition : ( placement, ctx ) => { return $permission.isVisible( 'placement-duplicate', 'placement-list', placement ) }, //ctx.$permission.has(['admin','employer'])
                                action    :
                                {
                                    type        : 'modal',
                                    id          : 'PlacementModal',
                                    ctx         : { method: 'duplicate' },
                                    transform   : ( store, item ) => { return { id: item.id } },
                                    component   : () => import('@/templates/views/recruitment/placements/dialogs/PlacementDialog')
                                }
                            }
                        ]
                    },

                    {
                        icon      : 'isax-sms',
                        get label(){ return t('table.placementList.actions.SendMessage.title') },
                        condition : ( placement, ctx ) =>
                        {
                            return $permission.isVisible( 'message-employer', 'placement-list', placement ) ||
                                $permission.isVisible( 'message-recruiter', 'placement-list', placement ) ||
                                $permission.isVisible( 'message-account-manager', 'placement-list', placement )
                        },
                        children  :
                        [
                            {
                                icon      : 'isax-sms-edit',
                                get label(){ return t('table.placementList.actions.JobManager.title') },
                                condition : ( placement, ctx ) => { return $permission.isVisible( 'message-employer', 'placement-list', placement ) },
                                action    :
                                {
                                    type   : 'function',
                                    method : ( item ) => { $router.push(`/placements/${item.id}/create?currentTab=PlacementMessages${item.employer.map( e => '&recipient=' + e.id ).join('')}`) },
                                }
                            },
                            {
                                icon      : 'isax-sms-edit',
                                get label(){ return t('table.placementList.actions.Recruiter.title') },
                                condition : ( placement, ctx ) => { return $permission.isVisible( 'message-recruiter', 'placement-list', placement ) },
                                action    :
                                {
                                    type   : 'function',
                                    method : ( item ) => { $router.push(`/placements/${item.id}/create?currentTab=PlacementMessages&recipient=${item.recruiter.id}`) },
                                }
                            },
                            {
                                icon      : 'isax-sms-edit',
                                get label(){ return t('table.placementList.actions.AccountManager.title') },
                                condition : ( placement, ctx ) => { return $permission.isVisible( 'message-account-manager', 'placement-list', placement ) },
                                action    :
                                {
                                    type   : 'function',
                                    method : ( item ) => { $router.push(`/placements/${item.id}/create?currentTab=PlacementMessages${item.contacts.accountManagers.map( e => '&recipient=' + e.id ).join('')}`) },
                                }
                            }
                        ]
                    },

                    {
                        type: 'divider',
                        condition : ( placement, ctx ) => { return $permission.isVisible( 'placement-delete', 'placement-list', placement ) }
                    },

                    {
                        icon      : 'isax-trash',
                        get label(){ return t('table.placementList.actions.DeletePlacement.title') },
                        condition : ( placement, ctx ) => { return $permission.isVisible( 'placement-delete', 'placement-list', placement ) },
                        action    :
                        {
                            type        : 'modal',
                            id          : 'AreYouSureModal',
                            props       :
                            {
                                title          : t('table.placementList.actions.DeletePlacement.dialog.title'),
                                description    : t('table.placementList.actions.DeletePlacement.dialog.description'),
                                handleCallback : true,
                                callback       : async ( submitButton ) =>
                                {
                                    await $swagger.delete_placement( $dialogs['AreYouSureModal'].ctx.id );

                                    submitButton.element.addEventListener('animationend', async () =>
                                    {
                                        $dialogs['AreYouSureModal'].close(); await fetchItemList();

                                    }, { once: true });
                                }
                            },
                            component: () => import('@/templates/components/Dialogs/AreYouSureDialog')
                        }
                    }
                ]
            }

        if( !sections.includes('header') ) { delete actionList.header; }
        if( !sections.includes('bulk') )   { delete actionList.bulk; }
        if( !sections.includes('quick') )  { delete actionList.quick; }

        return actionList;
    },

    'contractList': ( sections = [ 'header', 'bulk', 'quick' ], $permission, $router, $dialogs, $swagger, fetchItemList ) =>
    {
        let actionList =
        {
            header :
            [
                {
                    icon      : 'isax-add',
                    get label(){ return t('table.contractList.actions.CreateAssignment.title') },
                    class     : 'pulse-block-animation',
                    condition : ( contract, ctx ) => { return $permission.isVisible( 'contract-create', 'contract-list', contract ) }, //!ctx.$permission.isRampAccount() && ctx.$permission.has(['admin','employer'])
                    action    :
                    {
                        type      : 'modal',
                        id        : 'ContractModal',
                        ctx       : { method: 'create', fetchList: async () => await fetchItemList() },
                        component : () => import('@/templates/views/recruitment/contracts/dialogs/ContractDialog')
                    }
                }
            ],
            bulk   : [],
            quick  :
            [
                {
                    icon      : 'isax-search-status',
                    get label(){ return t('table.contractList.actions.Details.title') },
                    children  :
                    [
                        {
                            icon      : 'isax-eye',
                            get label(){ return t('table.contractList.actions.ShowDetails.title') },
                            action    :
                            {
                                type   : 'function',
                                method : ( item ) => { $router.push( { name: 'ContractDetail', params: { contractID: item.id } } ) },
                            }
                        }
                    ]
                },

                {
                    icon      : 'isax-edit-2',
                    get label(){ return t('table.contractList.actions.Modification.title') },
                    condition : ( contract, ctx ) =>
                    {
                        return $permission.isVisible( 'contract-extend', 'contract-list', contract ) ||
                            $permission.isVisible( 'contract-terminate', 'contract-list', contract ) ||
                            $permission.isVisible( 'contract-dropout', 'contract-list', contract ) ||
                            $permission.isVisible( 'contract-timesheet-add', 'contract-list', contract ) ||
                            $permission.isVisible( 'contract-edit', 'contract-list', contract ) ||
                            $permission.isVisible( 'contract-duplicate', 'contract-list', contract )
                    },
                    children  :
                    [
                        {
                            icon      : 'isax-notification-status4',
                            get label(){ return t('table.contractList.actions.ChangeStatus.title') },
                            condition : ( contract, ctx ) =>
                            {
                                return $permission.isVisible( 'contract-extend', 'contract-list', contract ) ||
                                    $permission.isVisible( 'contract-terminate', 'contract-list', contract ) ||
                                    $permission.isVisible( 'contract-dropout', 'contract-list', contract )
                            },
                            children  :
                            [
                                {
                                    icon      : 'isax-rotate-right',
                                    get label(){ return t('table.contractList.actions.Extend.title') },
                                    condition : ( contract, ctx ) => { return $permission.isVisible( 'contract-extend', 'contract-list', contract ) },
                                    action    :
                                    {
                                        type        : 'modal',
                                        id          : 'ContractExtendModal',
                                        ctx         : { fetchList: async () => await fetchItemList() },
                                        component   : () => import('@/templates/views/recruitment/contracts/dialogs/edit/ContractExtendDialog')
                                    }
                                },
                                {
                                    icon      : 'isax-stop-circle',
                                    get label(){ return t('table.contractList.actions.Terminate.title') },
                                    condition : ( contract, ctx ) => { return $permission.isVisible( 'contract-terminate', 'contract-list', contract ) },
                                    action    :
                                    {
                                        type        : 'modal',
                                        id          : 'AreYouSureModal',
                                        props       :
                                        {
                                            title          : t('table.contractList.actions.Terminate.dialog.title'),
                                            description    : t('table.contractList.actions.Terminate.dialog.description'),
                                            handleCallback : true,
                                            callback       : async ( submitButton ) =>
                                            {
                                                await $swagger.terminate_contract( $dialogs['AreYouSureModal'].ctx.id );

                                                submitButton.element.addEventListener('animationend', async () => { $dialogs['AreYouSureModal'].close(); await fetchItemList(); }, { once: true });
                                            }
                                        },
                                        component: () => import('@/templates/components/Dialogs/AreYouSureDialog')
                                    }
                                },
                                {
                                    icon      : 'isax-note-remove',
                                    get label(){ return t('table.contractList.actions.Dropout.title') },
                                    condition : ( contract, ctx ) => { return $permission.isVisible( 'contract-dropout', 'contract-list', contract ) },
                                    action    :
                                    {
                                        type        : 'modal',
                                        id          : 'AreYouSureModal',
                                        props       :
                                        {
                                            title          : t('table.contractList.actions.Dropout.dialog.title'),
                                            description    : t('table.contractList.actions.Dropout.dialog.description'),
                                            handleCallback : true,
                                            callback       : async ( submitButton ) =>
                                            {
                                                await $swagger.dropout_contract( $dialogs['AreYouSureModal'].ctx.id );

                                                submitButton.element.addEventListener('animationend', async () =>
                                                {
                                                    $dialogs['AreYouSureModal'].close();

                                                    await fetchItemList();

                                                }, { once: true });
                                            }
                                        },
                                        component: () => import('@/templates/components/Dialogs/AreYouSureDialog')
                                    }
                                }
                            ]
                        },
                        {
                            icon      : 'isax-calendar-edit',
                            get label(){ return t('table.contractList.actions.AddTimesheet.title') },
                            condition : ( contract, ctx ) => { return $permission.isVisible( 'contract-timesheet-add', 'contract-list', contract ) },
                            action    :
                            {
                                type        : 'modal',
                                id          : 'TimesheetModal',
                                ctx         : { method: 'create', fetchList: async () => await fetchItemList() },
                                transform   : ( store, item ) => { return { contractID: item.id } },
                                component   : () => import('@/templates/views/recruitment/contracts/dialogs/timesheet/TimesheetDialog.vue')
                            }
                        },
                        {
                            icon      : 'isax-edit',
                            get label(){ return t('table.contractList.actions.Edit.title') },
                            condition : ( contract, ctx ) => { return $permission.isVisible( 'contract-edit', 'contract-list', contract ) },
                            action    :
                            {
                                type        : 'modal',
                                id          : 'ContractModal',
                                ctx         : { method: 'edit', fetchList: async () => await fetchItemList() },
                                transform   : ( store, item ) => { return { id: item.id } },
                                component   : () => import('@/templates/views/recruitment/contracts/dialogs/ContractDialog')
                            }
                        },
                        {
                            icon      : 'isax-copy',
                            get label(){ return t('table.contractList.actions.Duplicate.title') },
                            condition : ( contract, ctx ) => { return $permission.isVisible( 'contract-duplicate', 'contract-list', contract ) },
                            action    :
                            {
                                type        : 'modal',
                                id          : 'ContractModal',
                                ctx         : { method: 'duplicate' },
                                transform   : ( store, item ) => { return { id: item.id } },
                                component   : () => import('@/templates/views/recruitment/contracts/dialogs/ContractDialog')
                            }
                        }
                    ]
                },

                {
                    icon      : 'isax-sms',
                    get label(){ return t('table.contractList.actions.SendMessage.title') },
                    condition : ( contract, ctx ) =>
                    {
                        return $permission.isVisible( 'message-employer', 'contract-list', contract ) ||
                            $permission.isVisible( 'message-recruiter', 'contract-list', contract ) ||
                            $permission.isVisible( 'message-account-manager', 'contract-list', contract )
                    },
                    children  :
                    [
                        {
                            icon      : 'isax-sms-edit',
                            get label(){ return t('table.contractList.actions.JobManager.title') },
                            condition : ( contract, ctx ) => { return $permission.isVisible( 'message-employer', 'contract-list', contract ) }, //ctx.$permission.has(['admin','recruiter']) && contract?.employer?.length
                            action    :
                            {
                                type   : 'function',
                                method : ( item ) => { $router.push(`/contracts/${item.id}/create?currentTab=ContractMessages${item.employer.map( e => '&recipient=' + e.id ).join('')}`) },
                            }
                        },
                        {
                            icon      : 'isax-sms-edit',
                            get label(){ return t('table.contractList.actions.Recruiter.title') },
                            condition : ( contract, ctx ) => { return $permission.isVisible( 'message-recruiter', 'contract-list', contract ) }, //ctx.$permission.has(['admin','employer']) && contract?.recruiter?.id
                            action    :
                            {
                                type   : 'function',
                                method : ( item ) => { $router.push(`/contracts/${item.id}/create?currentTab=ContractMessages&recipient=${item.recruiter.id}`) },
                            }
                        },
                        {
                            icon      : 'isax-sms-edit',
                            get label(){ return t('table.contractList.actions.AccountManager.title') },
                            condition : ( contract, ctx ) => { return $permission.isVisible( 'message-account-manager', 'contract-list', contract ) }, //ctx.$permission.has(['employer','recruiter']) && contract?.contacts?.accountManagers?.length
                            action    :
                            {
                                type   : 'function',
                                method : ( item ) => { $router.push(`/contracts/${item.id}/create?currentTab=ContractMessages${item.contacts.accountManagers.map( e => '&recipient=' + e.id ).join('')}`) },
                            }
                        }
                    ]
                },

                {
                    type: 'divider',
                    condition : ( contract, ctx ) => { return $permission.isVisible( 'contract-delete', 'contract-list', contract ) }
                },

                {
                    icon      : 'isax-trash',
                    get label(){ return t('table.contractList.actions.DeleteAssignment.title') },
                    condition : ( contract, ctx ) => { return $permission.isVisible( 'contract-delete', 'contract-list', contract ) }, //!ctx.$permission.isRampAccount() && ctx.$permission.has(['admin','employer'])
                    action    :
                    {
                        type  : 'modal',
                        id    : 'AreYouSureModal',
                        props :
                        {
                            title          : t('table.contractList.actions.DeleteAssignment.dialog.title'),
                            description    : t('table.contractList.actions.DeleteAssignment.dialog.description'),
                            handleCallback : true,
                            callback       : async ( submitButton ) =>
                            {
                                await $swagger.delete_contract( $dialogs['AreYouSureModal'].ctx.id );

                                submitButton.element.addEventListener('animationend', async () =>
                                {
                                    $dialogs['AreYouSureModal'].close(); await fetchItemList();

                                }, { once: true });
                            }
                        },
                        component: () => import('@/templates/components/Dialogs/AreYouSureDialog')
                    }
                }
            ]
        }

        if( !sections.includes('header') ) { delete actionList.header; }
        if( !sections.includes('bulk') )   { delete actionList.bulk; }
        if( !sections.includes('quick') )  { delete actionList.quick; }

        return actionList;
    },

    'workerList': ( sections = [ 'header', 'bulk', 'quick' ], $permission, $router, $dialogs, $swagger, fetchItemList ) =>
    {
        let actionList =
        {
            header : [],
            bulk   : [],
            quick  :
            [
                {
                    icon      : 'isax-search-status',
                    get label(){ return t('table.workerList.actions.Details.title') },
                    children  :
                    [
                        {
                            icon      : 'isax-eye',
                            get label(){ return t('table.workerList.actions.ShowDetails.title') },
                            action    :
                            {
                                type   : 'function',
                                method : ( item ) => { $router.push( { name: 'WorkerDetail', params: { workerID: item._id } } ) },
                            }
                        }
                    ]
                }
            ]
        }

        if( !sections.includes('header') ) { delete actionList.header; }
        if( !sections.includes('bulk') )   { delete actionList.bulk; }
        if( !sections.includes('quick') )  { delete actionList.quick; }

        return actionList;
    },

    'agencyList': ( sections = [ 'header', 'bulk', 'quick' ], $store, $permission, $router, $dialogs, $swagger, company, fetchItemList ) =>
    {
        let actionList =
        {
            header :
            [
                {
                    icon      : 'isax-award',
                    get label(){ return t('table.agencyList.actions.AgencySuggester.title') },
                    class     : 'primary',
                    condition : ( agency, ctx ) => { return $permission.isVisible( 'only-admin', 'global' ) },
                    action    :
                    {
                        type        : 'modal',
                        id          : 'AgencySuggesterModal',
                        component   : () => import('@/templates/views/recruitment/agencies/dialogs/suggester/AgencySuggesterDialog.vue'),
                    }
                },

                {
                    icon      : 'isax-add4',
                    get label(){ return t('table.agencyList.actions.InviteAgencyToRegister.title') },
                    class     : 'primary',
                    condition : ( agency, ctx ) => { return $permission.isVisible( 'agency-invite', 'global' ) },
                    action    :
                    {
                        type        : 'modal',
                        id          : 'OnboardAgencyInvitationModal',
                        component   : () => import('@/templates/views/recruitment/agencies/dialogs/invitation/OnboardAgencyInvitationDialog.vue'),
                    }
                }
            ],
            bulk   :
            [
                {
                    icon      : 'isax-hashtag',
                    get label(){ return t('table.agencyList.actions.Tags.title') },
                    class     : 'primary',
                    condition : ( agency, ctx ) => { return $permission.isVisible( 'agency-tag', 'agency-list' ) },
                    action    :
                    {
                        type: 'tag',
                        condition : ( agency, ctx ) => { return $permission.isVisible( 'agency-tag', 'agency-list' ) },
                    }
                },
            ],
            quick  :
            [
                {
                    icon      : 'isax-search-status',
                    get label(){ return t('table.agencyList.actions.Details.title') },
                    children  :
                    [
                        {
                            icon      : 'isax-eye',
                            get label(){ return t('table.agencyList.actions.ShowDetails.title') },
                            action    :
                            {
                                type   : 'function',
                                method : ( item ) => { $router.push( { name: 'AgencyDetail', params: { agencyID: item.id } } ) },
                            }
                        }
                    ]
                },

                {
                    icon      : 'isax-edit-2',
                    get label(){ return t('table.agencyList.actions.Actions.title') },
                    condition : ( agency, ctx ) => { return $permission.isVisible( 'agency-exclude', 'agency-list', { agency, company } ) || $permission.isVisible( 'agency-exclude-remove', 'agency-list', { agency, company } ) },
                    children  :
                    [
                        {
                            icon      : 'isax-eye-slash',
                            get label(){ return t('table.agencyList.actions.ExcludeAgency.title') },
                            condition : ( agency, ctx ) => { return $permission.isVisible( 'agency-exclude', 'agency-list', { agency, company } ) }, //!ctx.$permission.isRampAccount() && ctx.$permission.has([ 'admin', 'employer' ]) && !company.value?.blacklist?.agencies?.find( a => a.id === item.id )
                            action    :
                            {
                                type        : 'modal',
                                id          : 'AreYouSureModal',
                                props       :
                                {
                                    title          : t('table.agencyList.actions.ExcludeAgency.dialog.title'),
                                    description    : t('table.agencyList.actions.ExcludeAgency.dialog.description'),
                                    buttonClass    : 'primary md error',
                                    handleCallback : true,
                                    callback       : async ( submitButton ) =>
                                    {
                                        await $swagger.update_organization( company.value.id, { body: { blacklist: { agencyIDs: [ ...new Set([ ...( company.value?.blacklist?.agencies?.map( a => a.id ) || [] ), $dialogs['AreYouSureModal'].ctx.id ]) ] } } });

                                        submitButton.element.addEventListener('animationend', async () =>
                                        {
                                            $dialogs['AreYouSureModal'].close();

                                            company.value = await $swagger.get_organization( $store.getters['auth/user/detail'].currentAccount.organization.id );

                                            await fetchItemList();

                                        }, { once: true });
                                    }
                                },
                                component: () => import('@/templates/components/Dialogs/AreYouSureDialog')
                            }
                        },

                        {
                            type: 'divider',
                            condition : ( agency, ctx ) => { return $permission.isVisible( 'agency-exclude-remove', 'agency-list', { agency, company } ) },
                        },

                        {
                            icon      : 'isax-trash',
                            get label(){ return t('table.agencyList.actions.RemoveExclusion.title') },
                            condition : ( agency, ctx ) => { return $permission.isVisible( 'agency-exclude-remove', 'agency-list', { agency, company } ) }, //!ctx.$permission.isRampAccount() && ctx.$permission.has([ 'admin', 'employer' ]) && company.value?.blacklist?.agencies?.find( a => a.id === item.id )
                            action    :
                            {
                                type        : 'modal',
                                id          : 'AreYouSureModal',
                                props       :
                                {
                                    title          : t('table.agencyList.actions.RemoveExclusion.dialog.title'),
                                    description    : t('table.agencyList.actions.RemoveExclusion.dialog.description'),
                                    buttonClass    : 'primary md success',
                                    handleCallback : true,
                                    callback       : async ( submitButton ) =>
                                    {
                                        let blacklist = { agencyIDs: [] };

                                        if( company.value?.hasOwnProperty('blacklist') && company.value.blacklist.agencies?.length )
                                        {
                                            blacklist = { agencyIDs: company.value.blacklist.agencies.filter( f => f.id !== $dialogs['AreYouSureModal'].ctx.id ).map( i => i.id ) };
                                        }

                                        await $swagger.update_organization( company.value.id, { body: { blacklist } });

                                        submitButton.element.addEventListener('animationend', async () =>
                                        {
                                            $dialogs['AreYouSureModal'].close();

                                            company.value = await $swagger.get_organization( $store.getters['auth/user/detail'].currentAccount.organization.id );

                                            await fetchItemList();

                                        }, { once: true });
                                    }
                                },
                                component: () => import('@/templates/components/Dialogs/AreYouSureDialog')
                            }
                        }
                    ]
                },

                {
                    icon      : 'isax-hashtag',
                    get label(){ return t('table.agencyList.actions.Tags.title') },
                    condition : ( agency, ctx ) => { return $permission.isVisible( 'agency-tag', 'agency-list' ) },
                    children  :
                    [
                        {
                            type: 'tag',
                            condition : ( agency, ctx ) => { return $permission.isVisible( 'agency-tag', 'agency-list' ) },
                        }
                    ]
                }
            ]
        }

        if( !sections.includes('header') ) { delete actionList.header; }
        if( !sections.includes('bulk') )   { delete actionList.bulk; }
        if( !sections.includes('quick') )  { delete actionList.quick; }

        return actionList;
    },

    'employerList': ( sections = [ 'header', 'bulk', 'quick' ], $store, $permission, $router, $dialogs, $swagger, company, fetchItemList ) =>
    {
        let actionList =
        {
            header : [],
            bulk   : [],
            quick  : [{
                icon      : 'isax-edit-2',
                get label(){ return t('table.employerList.actions.Modification.title') },
                condition : ( job, ctx ) => { return !ctx.$permission.isRampAccount() && ctx.$permission.has(['admin']) },
                children  :
                []
            }]
        }

        if( !sections.includes('header') ) { delete actionList.header; }
        if( !sections.includes('bulk') )   { delete actionList.bulk; }
        if( !sections.includes('quick') )  { delete actionList.quick; }

        return actionList;
    },

    'programmeList': ( sections = [ 'header', 'bulk', 'quick' ], $permission, $router, $dialogs, $swagger, fetchItemList ) =>
    {
        let actionList =
        {
            header:
            [
                {
                    icon      : 'isax-add',
                    get label(){ return t('table.programmeList.actions.CreateProgram.title') },
                    condition : ( programme, ctx ) => { return !ctx.$permission.isRampAccount() && ctx.$permission.has(['admin']) },
                    action    :
                    {
                        type        : 'modal',
                        id          : 'ProgrammeModal',
                        ctx         : { method: 'create', fetchList: async () => await fetchItemList() },
                        component   : () => import('@/templates/views/recruitment/programmes/dialogs/ProgrammeDialog')
                    }
                }
            ],
            quick:
            [
                /*
                {
                    icon      : 'isax-edit-2',
                    get label(){ return t('table.programmeList.actions.Modification.title') },
                    condition : ( job, ctx ) => { return !ctx.$permission.isRampAccount() && ctx.$permission.has(['admin']) },
                    children  :
                    [
                        {
                            icon      : 'isax-edit',
                            get label(){ return t('table.programmeList.actions.EditProgramme.title') },
                            condition : ( programme, ctx ) => { return ctx.$permission.has(['admin']) },
                            action    :
                            {
                                type        : 'modal',
                                id          : 'ProgrammeModal',
                                ctx         : { method: 'edit', fetchList: async () => await $_helpers.fetchItemList() },
                                transform   : ( store, item ) => { return { id: item.id } },
                                component   : () => import('@/templates/views/recruitment/programmes/dialogs/ProgrammeDialog')
                            }
                        },
                    ]
                },

                {
                    icon      : 'isax-next',
                    get label(){ return t('table.programmeList.actions.Progression.title') },
                    condition : ( job, ctx ) => { return !ctx.$permission.isRampAccount() },
                    children  :
                    [
                        {
                            icon      : 'isax-cloud-add4',
                            get label(){ return t('table.programmeList.actions.InviteAgencies.title') },
                            class     : 'primary',
                            condition : ( programme, ctx ) => { return !ctx.$permission.isRampAccount() && ctx.$permission.has(['admin']) },
                            action    :
                            {
                                type        : 'modal',
                                id          : 'AgencyInvitationModal',
                                ctx         : { fetchList: async () => await $_helpers.fetchItemList() },
                                transform   : ( store, item ) => { return { id: item.id } },
                                component   : () => import('@/templates/views/recruitment/programmes/dialogs/invitation/ProgrammeAgencyInvitationDialog.vue')
                            }
                        },
                        {
                            icon      : 'isax-archive-tick',
                            get label(){ return t('table.programmeList.actions.AcceptInvitation.title') },
                            condition : ( programme, ctx ) => { return ctx.$permission.has(['recruiter']) && programme.pendingInvitation },
                            action    :
                            {
                                type        : 'modal',
                                id          : 'AreYouSureModal',
                                props       :
                                {
                                    title          : t('table.programmeList.actions.AcceptInvitation.dialog.title'),
                                    description    : t('table.programmeList.actions.AcceptInvitation.dialog.description'),
                                    buttonClass    : 'primary md success',
                                    handleCallback : true,
                                    callback       : async ( submitButton ) =>
                                    {
                                        await $swagger.accept_onboarding_invitation( $dialogs['AreYouSureModal'].ctx.pendingInvitation );

                                        submitButton.element.addEventListener('animationend', async () =>
                                        {
                                            $dialogs['AreYouSureModal'].close(); await $_helpers.fetchItemList();

                                        }, { once: true });
                                    }
                                },
                                component: () => import('@/templates/components/Dialogs/AreYouSureDialog')
                            }
                        }
                    ]
                },

                {
                    type: 'divider',
                    condition : ( job, ctx ) => { return !ctx.$permission.isRampAccount() && ctx.$permission.has(['recruiter']) && programme.pendingInvitation },
                },

                {
                    icon      : 'isax-archive-slash',
                    get label(){ return t('table.programmeList.actions.DeclineInvitation.title') },
                    condition : ( programme, ctx ) => { return !ctx.$permission.isRampAccount() && ctx.$permission.has(['recruiter']) && programme.pendingInvitation },
                    action    :
                    {
                        type        : 'modal',
                        id          : 'AreYouSureModal',
                        props       :
                        {
                            title          : t('table.programmeList.actions.DeclineInvitation.dialog.title'),
                            description    : t('table.programmeList.actions.DeclineInvitation.dialog.description'),
                            buttonClass    : 'primary md error',
                            handleCallback : true,
                            callback       : async ( submitButton ) =>
                            {
                                await $swagger.reject_onboarding_invitation( $dialogs['AreYouSureModal'].ctx.pendingInvitation );

                                submitButton.element.addEventListener('animationend', async () =>
                                {
                                    $dialogs['AreYouSureModal'].close(); await $_helpers.fetchItemList();

                                }, { once: true });
                            }
                        },
                        component: () => import('@/templates/components/Dialogs/AreYouSureDialog')
                    }
                }
                */
            ]
        }

        if( !sections.includes('header') ) { delete actionList.header; }
        if( !sections.includes('bulk') )   { delete actionList.bulk; }
        if( !sections.includes('quick') )  { delete actionList.quick; }

        return actionList;
    },

    'agencyOnboardingList': ( sections = [ 'header', 'bulk', 'quick' ], $permission, $router, $dialogs, $swagger, fetchItemList ) =>
    {
        let actionList =
        {
            header : [],
            quick  :
            [
                {
                    icon      : 'isax-document',
                    get label(){ return t('table.agencyOnboardingList.actions.OpenDocument.title') },
                    uid       : 'open-document',
                    condition : ( onboarding, ctx ) => { return onboarding.status === 'accepted' && onboarding.compliant && onboarding?.documents?.length },
                    action    :
                    {
                        type        : 'modal',
                        id          : 'DocumentModal',
                        ctx         : {},
                        transform   : ( store, item ) => { let document = item.documents[0]; return { ...document, title: document.title, mime: 'pdf', document: { file: { url: document.file } } } },
                        component   : () => import('@/templates/components/Dialogs/DocumentDialog.vue')
                    }
                },
                {
                    icon      : 'isax-archive-tick',
                    get label(){ return t('table.agencyOnboardingList.actions.AcceptInvitation.title') },
                    uid       : 'accept-invitation',
                    condition : ( onboarding, ctx ) => { return $permission.isVisible( 'agency-onboarding-invitation-accept', 'agency-list', { onboarding }); },
                    action    :
                    {
                        type        : 'modal',
                        id          : 'ProgressAgencyInvitationModal',
                        ctx         : { fetchList: async () => await fetchItemList() },
                        transform   : ( store, item ) => { return { method: 'accept', invitationID: item.id, agencyID: item.agency.id, recruiterID: store.getters['auth/user/detail'].currentAccount.id } },
                        component   : () => import('@/templates/views/recruitment/agencies/dialogs/invitation/ProgressAgencyInvitationDialog.vue')
                    }
                },
                {
                    icon      : 'isax-archive-slash',
                    get label(){ return t('table.agencyOnboardingList.actions.DeclineInvitation.title') },
                    uid       : 'decline-invitation',
                    condition : ( onboarding, ctx ) => { return $permission.isVisible( 'agency-onboarding-invitation-decline', 'agency-list', { onboarding }); },
                    action    :
                    {
                        type        : 'modal',
                        id          : 'ProgressAgencyInvitationModal',
                        ctx         : { fetchList: async () => await fetchItemList() },
                        transform   : ( store, item ) => { return  { method: 'decline', invitationID: item.id, agencyID: item.agency.id, recruiterID: store.getters['auth/user/detail'].currentAccount.id }  },
                        component   : () => import('@/templates/views/recruitment/agencies/dialogs/invitation/ProgressAgencyInvitationDialog.vue')
                    }
                },
                {
                    icon      : 'isax-document-upload',
                    get label(){ return t('table.agencyOnboardingList.actions.SignDocument.title') },
                    condition : ( onboarding, ctx ) => { return onboarding.status === 'accepted' && !onboarding.compliant && !onboarding?.documents?.length },
                    action    :
                    {
                        type        : 'modal',
                        id          : 'CompleteComplianceModal',
                        ctx         : { fetchList: async () => await fetchItemList() },
                        transform   : ( store, item ) => { return { employer: item.programme.organization.name, invitationID: item.id, agencyID: item.agency.id, recruiterID: store.getters['auth/user/detail'].currentAccount.id } },
                        component   : () => import('@/templates/views/recruitment/agencies/dialogs/invitation/CompleteComplianceDialog.vue')
                    }
                },
                {
                    icon      : 'isax-notification-status4',
                    get label(){ return t('table.agencyOnboardingList.actions.ChangeStatus.title') },
                    condition : ( onboarding, ctx ) => { return !ctx.$permission.isRampAccount() && ctx.$permission.has(['admin']) },
                    action    :
                    {
                        type        : 'modal',
                        id          : 'OnboardingStatusModal',
                        ctx         : { fetchList: async () => await fetchItemList() },
                        transform   : ( store, item ) => { return { id: item.id, onboardingStatus: item.onboardingStatus } },
                        component   : () => import('@/templates/views/recruitment/programmes/dialogs/onboarding/edit/OnboardingStatusDialog.vue')
                    }
                }
            ]
        }

        if( !sections.includes('header') ) { delete actionList.header; }
        if( !sections.includes('bulk') )   { delete actionList.bulk; }
        if( !sections.includes('quick') )  { delete actionList.quick; }

        return actionList;
    }
} 